(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp', [
            'ngAnimate',
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngSanitize',
            'ngCacheBuster',
            'ngFileUpload',
            'ngFileSaver',
            'ngLoadingSpinner',
            'ui.bootstrap',
            'ui.router'
        ])
        .run(run);

    run.$inject = ['stateHandler', '$rootScope', 'Principal', 'Info', '$sce', '$urlRouter', '$location'];

    function run(stateHandler, $rootScope, Principal, Info, $sce, $urlRouter, $location) {
        stateHandler.initialize();
        $rootScope.Principal = Principal;
        $rootScope.Info = Info;
        $rootScope.$sce = $sce;
        $rootScope.$location = $location;
        var test = 1;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('users', {
            parent: 'application',
            url: '/users?login&email&enable',
            params: {
                login: null,
                email: null,
                enable: null
            },
            data: {
                authorities: ['USER_RESOURCE'],
                pageTitle: 'Użytkownicy - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/users/users.html',
                    controller: 'UsersController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('UsersController', UsersController);

    UsersController.$inject = ['$state', '$stateParams', 'UsersService', 'AccountService', 'Info', 'Principal'];

    function UsersController($state, $stateParams, UsersService, AccountService, Info, Principal) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.userInterval = {
            current: null,
            currentMeasure: "dni",
            new: null,
            newMeasure: "dni",
        };
        vm.clientInterval = {
            current: null,
            currentMeasure: "dni",
            new: null,
            newMeasure: "dni",
        };

        //Declare functions
        vm.init = init;
        vm.resetFilters = resetFilters;
        vm.getUsers = getUsers;
        vm.getUserInterval = getUserInterval;
        vm.setUserInterval = setUserInterval;
        vm.getClientInterval = getClientInterval;
        vm.setClientInterval = setClientInterval;

        //Declare utils
        vm.validateFilter = validateFilter;

        //Init functions
        function init() {
            //Init filter
            vm.filter = {
                current: {
                    login: null,
                    email: null,
                    enable: null
                },
                query: {
                    login: null,
                    email: null,
                    enable: null
                }
            };

            //Init data
            vm.data = {
                error: null,
                result: {
                    users: []
                }
            };

            //Init interval
            vm.getUserInterval();

            vm.getClientInterval();

            //Copy URL parameters to current filter
            angular.copy($stateParams, vm.filter.query);

            //Get users from server
            vm.getUsers();
        }

        function resetFilters(event) {
            vm.filter.query = {
                login: null,
                email: null,
                enable: null
            };
        }

        function getUsers(event) {
            Info.clear();
            Info.setAction("Wyszukiwanie użytkowników...");
            //If event is not undefined
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Wyszukiwanie...";
                event.target.disabled = true;
            }
            //Validate the filter
            vm.validateFilter(vm.filter.query);
            //Get users JSON by new query
            UsersService.getUsers(vm.filter.query)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data = response.data;
                    //Update current filter without binding
                    angular.copy(vm.filter.query, vm.filter.current);
                    //Change URL to match the new query
                    $state.transitionTo('users', vm.filter.current, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Wyszukaj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function validateFilter(filter) {
            for (var key in filter) {
                if (filter[key] == "") {
                    filter[key] = null;
                }
            }
        }

        function setUserInterval(event) {
            Info.clear();
            Info.setAction("Aktualizowanie interwału hasła...");
            //If event is not undefined
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Aktualizowanie...";
                event.target.disabled = true;
            }
            var userInterval = vm.userInterval.new;
            switch (vm.userInterval.newMeasure) {
            case "dni":
                userInterval *= 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                break;
            case "miesiące":
                userInterval *= 30 /*dni*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                break;
            case "lata":
                userInterval *= 365 /*dni*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                break;
            }

            AccountService.changeUserPasswordInterval(userInterval)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.userInterval.current = response.data.result;
                    Info.addStatement('Pomyślnie zaktualizowano interwał zmiany hasła.');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function() {
                    //If event is not undefined
                    if (event != undefined) {
                        //Notify the user of searching and disable the button
                        event.target.innerText = "Aktualizuj interwał";
                        event.target.disabled = false;
                    }
                    vm.getUserInterval();
                    Info.clearAction();
                });
        }

        function getUserInterval() {
            Info.clear();
            Info.setAction("Pobieranie interwału hasła...");
            Principal.hasAuthority('PASSWORD_INTERVAL_CHANGE_RESOURCE').then(function(response) {
                if (response) {
                    AccountService.getUserPasswordInterval()
                        //If successful
                        .then(function(response) {
                            //Compute day count
                            var userInterval = response.data.result;
                            //Convert to days
                            userInterval = userInterval / 1000 /*ms*/ / 60 /*s*/ / 60 /*min*/ / 24 /*h*/ ;
                            vm.userInterval.current = userInterval;
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        })
                        .finally(function() {
                            Info.clearAction();
                        });
                }
            });
        }

        function setClientInterval(event) {
                    Info.clear();
                    Info.setAction("Aktualizowanie interwału hasła...");
                    //If event is not undefined
                    if (event != undefined) {
                        //Notify the user of searching and disable the button
                        event.target.innerText = "Aktualizowanie...";
                        event.target.disabled = true;
                    }
                    var clientInterval = vm.clientInterval.new;
                    switch (vm.clientInterval.newMeasure) {
                    case "dni":
                        clientInterval *= 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "miesiące":
                        clientInterval *= 30 /*dni*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "lata":
                        clientInterval *= 365 /*dni*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    }

                    AccountService.changeClientPasswordInterval(clientInterval)
                        //If successful
                        .then(function(response) {
                            //Set data to controller data
                            vm.clientInterval.current = response.data.result;
                            Info.addStatement('Pomyślnie zaktualizowano interwał zmiany hasła.');
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        })
                        .finally(function() {
                            //If event is not undefined
                            if (event != undefined) {
                                //Notify the user of searching and disable the button
                                event.target.innerText = "Aktualizuj interwał";
                                event.target.disabled = false;
                            }
                            vm.getClientInterval();
                            Info.clearAction();
                        });
                }

        function getClientInterval() {
            Info.clear();
            Info.setAction("Pobieranie interwału hasła...");
            Principal.hasAuthority('PASSWORD_INTERVAL_CHANGE_RESOURCE').then(function(response) {
                        if (response) {
                            AccountService.getClientPasswordInterval()
                                //If successful
                                .then(function(response) {
                                    //Compute day count
                                    var clientInterval = response.data.result;
                                    //Convert to days
                                    clientInterval = clientInterval / 1000 /*ms*/ / 60 /*s*/ / 60 /*min*/ / 24 /*h*/ ;
                                    vm.clientInterval.current = clientInterval;
                                })
                                //If there were errors
                                .catch(function(response) {
                                    Info.addErrorCode(response.data.errorCode);
                                })
                                .finally(function() {
                                    Info.clearAction();
                                });
                        }
            });
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('userActivate', {
            parent: 'register',
            url: '/activate/user',
            data: {
                pageTitle: 'Aktywacja konta klienta - VB Leasing'
            },
            views: {
                'step@register': {
                    templateUrl: 'app/views/userActivate/user-activate.html',
                    controller: 'ActivateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                    var deferred = $q.defer();

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(function() {
                        if (Utils.isEmpty($stateParams.token)) {
                            $state.go('login');
                            deferred.reject();
                        } else {
                            RegisterService.getRegistration($stateParams)
                                .then(function(response) {
                                    if (response.data.result != null) {
                                        deferred.resolve(response.data.result);
                                    } else {
                                        $state.go('login');
                                        deferred.reject();
                                    }
                                })
                                .catch(function(response) {
                                    $state.go('register-fail-' + response.data.errorCode);
                                    deferred.reject();
                                });
                        }
                    });

                    return deferred.promise;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', 'Auth', 'Info'];

    function LoginController($rootScope, $state, Auth, Info) {
        var vm = this;

        vm.credentials = {
            login: null,
            password: null,
            remember: false
        };

        //Declare functions
        vm.login = login;

        function login() {
            Info.clear();

            //Validate if all inputs are not empty
            if ($('input[type=password].ng-valid.ng-not-empty').length == 0 || $('input[type=text].ng-valid.ng-not-empty').length == 0) {
                Info.addError('Podaj kod klienta / login oraz hasło.');
            } else {
                $("#loginForm").addClass('form-success');
                $(".content").addClass('hidden');
                $('.loader').removeClass('hidden');
                //Login
                Auth.login(vm.credentials)
                    //When successful
                    .then(function(response) {
                        //Go to the documents state
                        $state.go($rootScope.afterAuth || 'documents');
                        $rootScope.afterAuth = undefined;
                    })
                    //When not successful
                    .catch(function(response) {
                        if (response.data == null) {
                            Info.addError('Wystąpił błąd podczas próby zalogowania. Prosimy o kontakt z Działem Obsługi Klienta na adres e-mail: <a href="mailto:portal.klienta@vbl.pl">portal.klienta@vbl.pl</a>.');
                            $("#loginForm").removeClass('form-success');
                            $(".content").removeClass('hidden');
                            $('.loader').addClass('hidden');
                        } else if (response.data.error == 4011) {
                            $state.go('passwordExpired', { login: vm.credentials.login, currentValue: vm.credentials.password }).then(function() {
                                $("#loginForm").removeClass('form-success');
                                $(".content").removeClass('hidden');
                                $('.loader').addClass('hidden');
                            });
                        } else {
                            Info.addErrorCode(response.data.error, 'login', response.data.result);
                            $("#loginForm").removeClass('form-success');
                            $(".content").removeClass('hidden');
                            $('.loader').addClass('hidden');
                        }
                    });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user', {
            parent: 'application',
            url: '/user?user_id',
            params: {
                user_id: null
            },
            data: {
                authorities: ['USER_RESOURCE'],
                pageTitle: 'Informacja o użytkowniku - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/user/user.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('UserController', UserController);

    UserController.$inject = ['$state', '$stateParams', 'UsersService', 'RolesService', 'DateUtils', 'Info', 'PasswordResetService', 'Principal'];

    function UserController($state, $stateParams, UsersService, RolesService, DateUtils, Info, PasswordResetService, Principal) {
        var vm = this;

        //Declare variables
        vm.data = {
            user: null,
            roles: null,
            logs: null
        };

        vm.filter = {
            user_id: $stateParams.user_id,
            ts_from: null,
            ts_to: null
        };

        vm.warnings = [];

        //Declare functions
        vm.init = init;
        vm.now = now;
        vm.getUser = getUser;
        vm.getUserRoles = getUserRoles;
        vm.getUserLogs = getUserLogs;
        vm.getRoles = getRoles;
        vm.updateUserRoles = updateUserRoles;
        vm.deleteUser = deleteUser;
        vm.resetPassword = resetPassword;
        vm.unlock = unlock;
        vm.generateUpdateObject = generateUpdateObject;
        vm.Date = DateUtils.convertDateTimeFromServer;
        vm.toggleActivation = toggleActivation;
        vm.resetFilters = resetFilters;
        vm.getLogQueryObject = getLogQueryObject;

        //Init functions
        function init() {
            //Get user if specified in state parameters
            if ($stateParams.user_id != null) {
                vm.getUser();
            }
        }

        function getUser() {
            //Get role JSON
            UsersService.getUser($stateParams.user_id)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.user = response.data.result;
                    vm.getRoles();
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getUserRoles() {
            //Get role JSON
            UsersService.getUserRoles($stateParams.user_id)
                //If successful
                .then(function(response) {
                    for (var userRole in response.data.result.roles) {
                        for (var role in vm.data.roles) {
                            if (vm.data.roles[role].role_id == response.data.result.roles[userRole].role_id) {
                                vm.data.roles[role].checked = true;
                            }
                        }
                    }
                    vm.getUserLogs();
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getUserLogs() {
            Principal.hasAuthority('LOGS_EMPLOYEE_RESOURCE').then(function(response) {
                if (response) {
                    //Get role JSON
                    UsersService.getUserLogs(vm.getLogQueryObject())
                        //If successful
                        .then(function(response) {
                            vm.data.logs = response.data.result.logs;
                            $state.transitionTo('user', vm.getLogQueryObject(), {
                                location: true,
                                inherit: true,
                                relative: $state.$current,
                                notify: false
                            });
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        });
                }
            });
        }

        function getRoles() {
            Principal.hasAuthority('ROLE_RESOURCE').then(function(response) {
                if (response) {
                    //Get documents JSON by new query
                    RolesService.getRoles()
                        //If successful
                        .then(function(response) {
                            //Set data to controller data
                            vm.data.roles = response.data.result.roles;
                            vm.getUserRoles();
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        });
                }
            });


        }

        function updateUserRoles() {
            //Get role JSON
            UsersService.updateUserRoles(vm.generateUpdateObject())
                //If successful
                .then(function(response) {
                    Info.addStatement('Pomyślnie zaktualizowano role użytkownika ' + vm.data.user.login + '.');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function generateUpdateObject() {
            var role_ids = [];
            for (var role in vm.data.roles) {
                if (vm.data.roles[role].checked)
                    role_ids.push(vm.data.roles[role].role_id);
            }
            return {
                user_id: $stateParams.user_id,
                role_ids: role_ids
            };
        }

        function deleteUser() {
            //Get role JSON
            UsersService.deleteUser(vm.data.user.user_id)
                //If successful
                .then(function(response) {
                    Info.addStatement('Pomyślnie usunięto użytkownika ' + vm.data.user.login + '.', 'users');
                    $state.go('users');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function unlock(event) {
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Odblokowywanie...";
                event.target.disabled = true;
            }
            UsersService.unlockUser(vm.data.user.login)
                .then(function(response) {
                    Info.addStatement("Odblokowano konto użytkownika.");
                    vm.data.user.account_blocked = false;
                    vm.data.user.invalid_login_counter = 0;
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Odblokuj konto";
                        event.target.disabled = false;
                    }
                });
        }

        function toggleActivation() {
            //Get role JSON
            UsersService.updateUser({
                user_id: vm.data.user.user_id,
                enable: !vm.data.user.enable
            })
                //If successful
                .then(function(response) {
                    vm.data.user.enable = !vm.data.user.enable;
                    if (vm.data.user.enable) {
                        Info.addStatement('Pomyślnie aktywowano konto użytkownika ' + vm.data.user.login + '.');
                    } else {
                        Info.addStatement('Pomyślnie deaktywowano konto użytkownika ' + vm.data.user.login + '.');
                    }
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function resetPassword(event) {
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Resetowanie...";
                event.target.disabled = true;
            }
            PasswordResetService.resetPassword({
                login: vm.data.user.login,
                email: vm.data.user.email
            })
                .then(function(response) {
                    Info.addStatement("Na adres e-mail pracownika została wysłana wiadomość umożliwiająca nadanie nowego hasła.");
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Zresetuj hasło";
                        event.target.disabled = false;
                    }
                });
        }

        function getLogQueryObject() {
            var filter = jQuery.extend(true, {}, vm.filter);
            filter.relative_id = filter.user_id;
            filter.maker_id = filter.user_id;
            return filter;
        }

        function resetFilters() {
            vm.filter = {
                user_id: $stateParams.user_id,
                ts_from: null,
                ts_to: null
            };
        }

        function getDate(date) {
            var result = new Date(0);
            result.setSeconds(0);
            result.setMinutes(0);
            result.setHours(0);
            result.setDate(date.split('.')[0]);
            result.setMonth(date.split('.')[1] - 1);
            result.setYear(date.split('.')[2]);
            return result.getTime();
        }

        function now() {
            return new Date().getTime();
        }

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'application',
            url: '/settings',
            data: {
                authorities: [],
                pageTitle: 'Ustawienia konta  - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$state', '$stateParams', 'AccountService', 'Principal', 'Info', 'Utils'];

    function SettingsController($state, $stateParams, AccountService, Principal, Info, Utils) {
        var vm = this;

        //Declare variables
        vm.data = null;
        vm.eInvoice = Principal.getProperty('e_invoice');
        vm.pipeRegex = Utils.getPipeRegex();

        //Declare functions
        vm.init = init;
        vm.changePassword = changePassword;
        vm.changeEmail = changeEmail;
        vm.activateEInvoice = activateEInvoice;
        vm.acceptAgreements = acceptAgreements;

        //Init functions
        function init() {
            //Init data
            vm.data = {
                password: {
                    currentValue: '',
                    newValue: '',
                    newRepeat: ''
                },
                email: {
                    currentValue: '',
                    newValue: '',
                    newRepeat: ''
                },
                agreements: {
                    agreement1: false,
                    agreement2: false,
                    agreement3: false,
                    agreement4: false
                },
                eInvoice: false

            };

            AccountService.getRegistrationForUser($stateParams)
                .then(function(response) {
                    if (response.data.result != null) {
                        vm.data.agreements.agreement1 = response.data.result.agreement4;
                        vm.data.agreements.agreement2 = response.data.result.agreement5;
                        vm.data.agreements.agreement3 = response.data.result.agreement6;
                        vm.data.agreements.agreement4 = response.data.result.agreement7;
                    }
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function acceptAgreements(event) {
            Info.clear();
            Info.setAction("Aktualizowanie zgód...");
            //Notify the user of sending and disable the button
            event.target.innerText = "Wysyłanie...";
            event.target.disabled = true;
            AccountService.acceptAgreements(vm.data.agreements)
                //If successful
                .then(function(response) {
                    Info.addStatement("Zgody zostały zmienione.");
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Aktualizuj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function changePassword(event) {
            Info.clear();
            Info.setAction("Aktualizowanie hasła...");
            //If event is not undefined
            if (event != undefined) {
                //Notify the user of changing the password and disable the button
                event.target.innerText = "Aktualizowanie...";
                event.target.disabled = true;
            }
            //Send change request
            AccountService.changePassword(vm.data.password)
                //If successful
                .then(function(response) {
                    Info.addStatement("Hasło zostało zmienione.");
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Aktualizuj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });

        }

        function changeEmail(event) {
            Info.clear();
            Info.setAction("Aktualizowanie adresu e-mail...");
            //If event is not undefined
            if (event != undefined) {
                //Notify the user of changing the email and disable the button
                event.target.innerText = "Aktualizowanie...";
                event.target.disabled = true;
            }
            //Send change request
            AccountService.changeEmail(vm.data.email)
                //If successful
                .then(function(response) {
                    Info.addStatement("Wiadomość z linkiem aktywującym zmianę adresu e-mail do obsługi Portalu VB Leasing została wysłana na podany adres e-mail.");
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Aktualizuj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function activateEInvoice(event) {
            Info.clear();
            Info.setAction("Aktywowanie usługi e-faktura...");
            //If event is not undefined
            if (event != undefined) {
                //Notify the user of activating and disable the button
                event.target.innerText = "Aktywowanie...";
                event.target.disabled = true;
            }
            //If the user accepted
            if (vm.data.eInvoice == true) {
                //Send activation request
                AccountService.activateEInvoice()
                    //If successful
                    .then(function(response) {
                        Info.addStatement("Pomyślnie aktywowano usługę e-faktura.");
                        vm.eInvoice = true;
                    })
                    //If there were errors
                    .catch(function(response) {
                        Info.addErrorCode(response.data.errorCode);
                    })
                    .finally(function(response) {
                        //If event is not undefined
                        if (event != undefined) {
                            //Enable the button and return to former text
                            event.target.innerText = "Aktywuj";
                        }
                        Info.clearAction();
                    });
            }
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('roles', {
            parent: 'application',
            url: '/roles',
            data: {
                authorities: ['ROLE_RESOURCE'],
                pageTitle: 'Role - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/roles/roles.html',
                    controller: 'RolesController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('RolesController', RolesController);

    RolesController.$inject = ['RolesService', 'Info'];

    function RolesController(RolesService, Info) {
        var vm = this;

        //Declare variables
        vm.data = null;
        vm.warnings = [];

        //Declare functions
        vm.init = init;
        vm.getRoles = getRoles;

        //Init functions
        function init() {
            //Init data         
            vm.data = {
                roles: null
            };

            //Get documents from server
            vm.getRoles();
        }

        function getRoles() {
            Info.clear();
            Info.setAction("Wyszukiwanie ról...");
            //Get documents JSON by new query
            RolesService.getRoles()
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.roles = response.data.result.roles;
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function() {
                    Info.clearAction();
                });
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('role', {
            parent: 'application',
            url: '/role?role_id',
            params: {
                role_id: null
            },
            data: {
                authorities: ['ROLE_RESOURCE'],
                pageTitle: 'Edycja roli - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/role/role.html',
                    controller: 'RoleController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('RoleController', RoleController);

    RoleController.$inject = ['$state', '$stateParams', 'RolesService', 'DateUtils', 'PermissionsService', 'Info', 'Principal'];

    function RoleController($state, $stateParams, RolesService, DateUtils, PermissionsService, Info, Principal) {
        var vm = this;

        //Declare variables
        vm.data = null;
        vm.warnings = [];

        //Declare functions
        vm.init = init;
        vm.getRole = getRole;
        vm.getRolePermissions = getRolePermissions;
        vm.getPermissions = getPermissions;
        vm.updateRole = updateRole;
        vm.generateUpdateObject = generateUpdateObject;
        vm.deleteRole = deleteRole;
        vm.getRoleLogs = getRoleLogs;
        vm.Date = DateUtils.convertDateTimeFromServer;
        vm.resetFilters = resetFilters;
        vm.getLogQueryObject = getLogQueryObject;

        //Init functions
        function init() {
            //Init data
            vm.data = {
                role: null,
                permissions: null,
                logs: null
            };

            if ($stateParams.role_id != null) {
                vm.getPermissions($stateParams.role_id);
                vm.getRole($stateParams.role_id);
            }

            vm.getRoleLogs();
        }

        function getRole(role_id) {
            //Get role JSON
            RolesService.getRole(role_id)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.role = response.data.result;
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getRolePermissions(role_id) {
            //Get role JSON
            RolesService.getRolePermissions(role_id)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    for (var userPermission in response.data.result.permissions) {
                        for (var permission in vm.data.permissions) {
                            if (vm.data.permissions[permission].perm_id == response.data.result.permissions[userPermission].perm_id) {
                                vm.data.permissions[permission].checked = true;
                            }
                        }
                    }
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getPermissions() {
            //Get role JSON
            PermissionsService.getPermissions()
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.permissions = response.data.result.permissions;
                    vm.getRolePermissions($stateParams.role_id);
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function updateRole() {
            // Update role
            RolesService.updateRole(vm.data.role)
                //If successful
                .then(function(response) {
                    // Update role permissions
                    RolesService.updateRolePermissions(vm.generateUpdateObject())
                        //If successful
                        .then(function(response) {
                            Info.addStatement('Pomyślnie zaktualizowano rolę.', 'roles');
                            $state.go('roles');
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        });
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function generateUpdateObject() {
            var perm_ids = [];
            for (var permission in vm.data.permissions) {
                if (vm.data.permissions[permission].checked)
                    perm_ids.push(vm.data.permissions[permission].perm_id);
            }

            return {
                role_id: parseInt($stateParams.role_id),
                perm_ids: perm_ids
            };
        }

        function getRoleLogs() {
                   //Principal.hasAuthority('LOGS_EMPLOYEE_RESOURCE').then(function(response) {
                    //    if (response) {
                            //Get role JSON
                            RolesService.getRoleLogs(vm.getLogQueryObject())
                                //If successful
                                .then(function(response) {
                                    vm.data.logs = response.data.result.logs;
                                    $state.transitionTo('role', vm.getLogQueryObject(), {
                                        location: true,
                                        inherit: true,
                                        relative: $state.$current,
                                        notify: false
                                    });
                                })
                                //If there were errors
                                .catch(function(response) {
                                    Info.addErrorCode(response.data.errorCode);
                                });
                   //     }
                   // });
        }

        vm.filter = {
            role_id: $stateParams.role_id,
            ts_from: null,
            ts_to: null
        };

        function getLogQueryObject() {
            var filter = jQuery.extend(true, {}, vm.filter);
            filter.relative_id = filter.role_id;
            return filter;
        }

        function resetFilters() {
                    vm.filter = {
                        role_id: $stateParams.role_id,
                        ts_from: null,
                        ts_to: null
                    };
        }


        function deleteRole() {
            //Get role JSON
            RolesService.deleteRole(vm.data.role.role_id)
                //If successful
                .then(function(response) {
                    Info.addStatement('Pomyślnie usunięto rolę ' + vm.data.role.label + '.', 'roles');
                    $state.go('roles');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getDate(date) {
                    var result = new Date(0);
                    result.setSeconds(0);
                    result.setMinutes(0);
                    result.setHours(0);
                    result.setDate(date.split('.')[0]);
                    result.setMonth(date.split('.')[1] - 1);
                    result.setYear(date.split('.')[2]);
                    return result.getTime();
                }

        function now() {
                    return new Date().getTime();
                }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reset', {
            parent: 'site',
            url: '/reset',
            data: {
                authorities: [],
                pageTitle: 'Resetowanie hasła - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/reset/reset.html',
                    controller: 'ResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('ResetService', ResetService);

    ResetService.$inject = ['API_URL','$http'];

    function ResetService (API_URL, $http) {
 
		        return {
		};
	    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('ResetController', ResetController);

    ResetController.$inject = ['$state', 'ResetService'];

    function ResetController ($state, ResetService) {
		        var vm = this;

		//Declare functions
		        vm.reset = reset;
		
		        function reset(){
			    setTimeout(function(){
				    $state.go('login');
			},3000);			
		}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('appRegulations', {
            parent: 'site',
            url: '/regulations',
            data: {
            	authorities: [],
                pageTitle: 'Regulamin - VB Leasing'
            },
            views: {
            	'index@': {
                    templateUrl: 'app/views/regulations/regulations.html'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('Register3Controller', Register3Controller);

    Register3Controller.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils', 'registration'];

    function Register3Controller($state, $stateParams, $location, RegisterService, Info, Utils, registration) {
        var vm = this;


        vm.location = $location;

        vm.data = registration ? registration : {
            agreement1: null,
            agreement2: null,
            agreement3: null,
            agreement4: null,
            agreement5: null,
            agreement6: null,
            agreement7: null
        };

        angular.merge(vm.data, RegisterService.registration);

        //Declare functions
        vm.proceed = proceed;
        vm.back = back;

        function proceed(event) {
            $('.content').addClass('hidden');
            $('.loader.registrator').removeClass('hidden');
            //Notify the user of sending and disable the button
            event.target.innerText = "Wysyłanie...";
            event.target.disabled = true;
            RegisterService.step3(vm.data)
                //If successful
                .then(function(response) {
                    //Change URL to match the new query
                    $state.go('register-finish');
                    $('.content').removeClass('hidden');
                    $('.loader.registrator').addClass('hidden');
                })
                //If there were errors
                .catch(function(response) {
                    if ([202].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register2');
                        $state.go('register2');
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    } else if ([205, 206].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register1');
                        $state.go('register1');
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    } else {
                        Info.addErrorCode(response.data.errorCode, 'register-fail');
                        $state.go('register-fail-' + response.data.errorCode);
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    }
                    //Enable the button and return to former text
                    event.target.innerText = "Wyślij";
                    event.target.disabled = false;
                    $('.content').removeClass('hidden');
                    $('.loader.registrator').addClass('hidden');
                });
        }

        function back() {
            $state.go('register2');
            RegisterService.persist(vm.data);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('Register2Controller', Register2Controller);

    Register2Controller.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils', 'registration'];

    function Register2Controller($state, $stateParams, $location, RegisterService, Info, Utils, registration) {
        var vm = this;

        vm.data = registration ? registration : {
            email: null,
            newPassword: null,
            password: null,
            telephone_number: null
        };

        angular.merge(vm.data, RegisterService.registration);

        //Declare functions
        vm.proceed = proceed;
        vm.back = back;

        function proceed(event) {
            //Notify the user of sending and disable the button
            event.target.innerText = "Weryfikacja...";
            event.target.disabled = true;
            RegisterService.step2(vm.data)
                //If successful
                .then(function(response) {
                    //Change URL to match the new query
                    $state.go('register3');
                })
                //If there were errors
                .catch(function(response) {
                    if ([205, 206].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register2');
                    } else {
                        Info.addErrorCode(response.data.errorCode, 'register-fail');
                        $state.go('register-fail-' + response.data.errorCode);
                    }
                }).finally(function() {
                    event.target.innerText = "Dalej";
                    event.target.disabled = false;
                });
        }

        function back() {
            $state.go('register1');
            RegisterService.persist(vm.data);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('Register1Controller', Register1Controller);

    Register1Controller.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils', 'registration'];

    function Register1Controller($state, $stateParams, $location, RegisterService, Info, Utils, registration) {
        var vm = this;

        vm.data = registration ? registration : {
            login: null,
            document_nr: null,
            total_netto: null
        };

        if (registration == null) {
            RegisterService.registration = {};
        } else
            angular.merge(vm.data, RegisterService.registration);

        //Declare functions
        vm.proceed = proceed;

        function proceed(event) {
            //Notify the user of sending and disable the button
            event.target.innerText = "Weryfikacja...";
            event.target.disabled = true;
            RegisterService.step1(vm.data)
                //If successful
                .then(function(response) {
                    //Change URL to match the new query
                    $state.go('register2', { token: response.data.result });
                })
                //If there were errors
                .catch(function(response) {
                    if ([205, 206].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register1');
                    } else if ([208].indexOf(response.data.errorCode) != -1) {

                    } else {
                        Info.addErrorCode(response.data.errorCode, 'register-fail');
                        $state.go('register-fail-' + response.data.errorCode);
                    }
                })
                .finally(function() {
                    event.target.innerText = "Dalej";
                    event.target.disabled = false;
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        //Parent state
        $stateProvider.state('register', {
            parent: 'site',
            abstract: true,
            url: '/register?token',
            params: {
                    token: null
                },
            data: {
                    authorities: [],
                    pageTitle: 'Rejestracja do Portalu - VB Leasing'
                },
            views: {
                    'index@': {
                        templateUrl: 'app/views/register/register.html'
                    }
                }
        }) //Step 1
            .state('register1', {
                parent: 'register',
                url: '/1',
                data: {
                    pageTitle: 'Rejestracja do Portalu - VB Leasing'
                },
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/register-1.html',
                        controller: 'Register1Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                        var deferred = $q.defer();

                        // $timeout is an example; it also can be an xhr request or any other async function
                        $timeout(function() {
                            if (!Utils.isEmpty($stateParams.token)) {
                                RegisterService.getRegistration($stateParams)
                                    .then(function(response) {
                                        if (response.data.result != null) {
                                            $stateParams = response.data.result;
                                            deferred.resolve(response.data.result);
                                        } else {
                                            $state.go('register1');
                                            deferred.reject();
                                        }
                                    })
                                    .catch(function(response) {
                                        $state.go('register-fail-' + response.data.errorCode);
                                        deferred.reject();
                                    });
                            } else {
                                deferred.resolve(null);
                            }
                        });

                        return deferred.promise;
                    }
                }
            }) //Step 2
            .state('register2', {
                parent: 'register',
                url: '/2',
                params: {
                    token: null
                },
                data: {
                    authorities: [],
                    pageTitle: 'Rejestracja do Portalu - VB Leasing'
                },
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/register-2.html',
                        controller: 'Register2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                        var deferred = $q.defer();

                        // $timeout is an example; it also can be an xhr request or any other async function
                        $timeout(function() {
                            if (Utils.isEmpty($stateParams.token)) {
                                $state.go('register1');
                                deferred.reject();
                            } else {
                                RegisterService.getRegistration($stateParams)
                                    .then(function(response) {
                                        if (response.data.result != null) {
                                            $stateParams = response.data.result;
                                            deferred.resolve(response.data.result);
                                        } else {
                                            $state.go('register1');
                                            deferred.reject();
                                        }
                                    })
                                    .catch(function(response) {
                                        $state.go('register-fail-' + response.data.errorCode);
                                        deferred.reject();
                                    });
                            }
                        });

                        return deferred.promise;
                    }
                }
            }) //Step 3
            .state('register3', {
                parent: 'register',
                url: '/3',
                data: {
                    authorities: [],
                    pageTitle: 'Rejestracja do Portalu - VB Leasing'
                },
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/register-3.html',
                        controller: 'Register3Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                        var deferred = $q.defer();

                        // $timeout is an example; it also can be an xhr request or any other async function
                        $timeout(function() {
                            if (Utils.isEmpty($stateParams.token)) {
                                $state.go('register1');
                                deferred.reject();
                            } else {
                                RegisterService.getRegistration($stateParams)
                                    .then(function(response) {
                                        if (response.data.result != null) {
                                            $stateParams = response.data.result;
                                            deferred.resolve(response.data.result);
                                        } else {
                                            $state.go('register1');
                                            deferred.reject();
                                        }
                                    })
                                    .catch(function(response) {
                                        $state.go('register-fail-' + response.data.errorCode);
                                        deferred.reject();
                                    });
                            }
                        });

                        return deferred.promise;
                    }
                }
            }).state('regulations', {
                parent: 'register',
                url: '/regulations',
                data: {
                    pageTitle: 'Regulamin - VB Leasing'
                },
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/regulations.html',
                        controller: 'Register3Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                        var deferred = $q.defer();

                        // $timeout is an example; it also can be an xhr request or any other async function
                        $timeout(function() {
                            if (Utils.isEmpty($stateParams.token)) {
                                $state.go('register1');
                                deferred.reject();
                            } else {
                                RegisterService.getRegistration($stateParams)
                                    .then(function(response) {
                                        if (response.data.result != null) {
                                            $stateParams = response.data.result;
                                            deferred.resolve(response.data.result);
                                        } else {
                                            $state.go('register1');
                                            deferred.reject();
                                        }
                                    })
                                    .catch(function(response) {
                                        $state.go('register-fail-' + response.data.errorCode);
                                        deferred.reject();
                                    });
                            }
                        });

                        return deferred.promise;
                    }
                }
            }) //Confirmation of registration
            .state('register-finish', {
                parent: 'register',
                url: '/finish',
                data: {
                    authorities: [],
                    pageTitle: 'Rejestracja do Portalu - VB Leasing'
                },
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/finish.html'
                    }
                }
            }); //Failure during registration

        var errors = [204, 207, 208, 209, 2013, 2015, 2016, 2020];
        //Add all error states
        for (var errorIndex in errors) {
            $stateProvider.state('register-fail-' + errors[errorIndex], {
                parent: 'register',
                url: '/fail/' + errors[errorIndex],
                views: {
                    'step@register': {
                        templateUrl: 'app/views/register/' + errors[errorIndex] + '.html'
                    }
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('RegisterService', RegisterService);

    RegisterService.$inject = ['API_URL', '$http'];

    function RegisterService(API_URL, $http) {
        var service = {
            'registration': {},
            'persist': function(registrationData) {
                angular.merge(service.registration, registrationData);
            },
            'step1': function(data) {
                service.persist(data);
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register/1',
                    data: data
                });
            },
            'step2': function(data) {
                service.persist(data);
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register/2',
                    data: data
                });
            },
            'step3': function(data) {
                service.persist(data);
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register/3',
                    data: data
                });
            },
            'register': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register',
                    data: data
                });
            },
            'getRegistration': function(data) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/register',
                    params: data
                });
            },
            activate: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/register',
                    data: data
                });
            },
            quickActivate: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/register/quick/end',
                    data: data
                });
            },
            userActivate: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/register/user',
                    data: data
                });
            },
            getApprovalData: function(data) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/register/quick/data',
                    params: data
                });
            },
            spreadApproval: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/register/quick/approval',
                    data: data
                });
            }
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils'];

    function RegisterController($state, $stateParams, $location, RegisterService, Info, Utils) {
        var vm = this;

        vm.location = $location;

        vm.data = {
            login: null,
            document_nr: null,
            total_netto: null,
            email: null,
            password: null,
            telephone_number: null,
            agreement1: false,
            agreement2: false,
            agreement3: false,
            agreement4: false,
            agreement5: false,
            agreement6: false
        };

        vm.activation = {
            startPassword: null,
            password: null,
            newRepeat: null,
            token: null
        };

        //Declare functions
        vm.init = init;
        vm.stepValidity = stepValidity;
        vm.proceed = proceed;
        vm.back = back;
        vm.register = register;
        vm.activate = activate;
        vm.quickActivate = quickActivate;
        vm.userActivate = userActivate;

        function init() {
            if ($state.current.name == 'activate' || $state.current.name == 'quickActivate' || $state.current.name == 'userActivate') {
                //Copy URL parameters to data
                angular.copy($stateParams, vm.activation);
            }
        }

        function stepValidity() {
            var state = $state.current.name;
            //If current state is not first, and step before has not been properly filled
            while (state.slice(-1) > 1 && !vm['isFilledStep' + (state.slice(-1) - 1)]()) {
                //Change state to one before
                state = state.slice(0, -1) + (state.slice(-1) - 1);
            }
            //If not all steps before current were filled properly
            if (state != $state.current.name) {
                //Change to last properly filled state
                $state.go(state);
                return false;
            } //If all steps were filled properly
            else {
                return true;
            }
        }

        function proceed(event) {
            if (vm.stepValidity()) {
                switch ($state.$current.self.url) {
                case '/1':
                    $state.go('register2');
                    break;
                case '/2':
                    $state.go('register3');
                    break;
                case '/3':
                    vm.register(event);
                case '/regulations':
                    $state.go('register3');
                }
            }
        }

        function back() {
            switch ($state.$current.self.url) {
            case '/1':
                $state.go('login');
                break;
            case '/2':
                $state.go('register1');
                break;
            case '/3':
                $state.go('register2');
                break;
            }
        }

        function step1() {
            RegisterService.step1(vm.data)
                //If successful
                .then(function(response) {
                    //Change URL to match the new query
                    $state.go('register2');
                })
                //If there were errors
                .catch(function(response) {
                    if ([205, 206].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register1');
                        $state.go('register1');
                    } else {
                        Info.addErrorCode(response.data.errorCode, 'register-fail');
                        $state.go('register-fail-' + response.data.errorCode);
                    }
                });
        }

        function register(event) {
            $('.content').addClass('hidden');
            $('.loader.registrator').removeClass('hidden');
            //Notify the user of sending and disable the button
            event.target.innerText = "Wysyłanie...";
            event.target.disabled = true;

            //Register with given data
            RegisterService.register(vm.data)
                //If successful
                .then(function(response) {
                    //Change URL to match the new query
                    $state.go('register-finish');
                    $('.content').removeClass('hidden');
                    $('.loader.registrator').addClass('hidden');
                })
                //If there were errors
                .catch(function(response) {
                    if ([202].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register2');
                        $state.go('register2');
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    } else if ([205, 206].indexOf(response.data.errorCode) != -1) {
                        Info.addErrorCode(response.data.errorCode, 'register1');
                        $state.go('register1');
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    } else {
                        Info.addErrorCode(response.data.errorCode, 'register-fail');
                        $state.go('register-fail-' + response.data.errorCode);
                        $('.content').removeClass('hidden');
                        $('.loader.registrator').addClass('hidden');
                    }
                    //Enable the button and return to former text
                    event.target.innerText = "Wyślij";
                    event.target.disabled = false;
                    $('.content').removeClass('hidden');
                    $('.loader.registrator').addClass('hidden');
                });
        }

        function activate() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            RegisterService.activate(vm.activation)
                .then(function() {
                    Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą kodu klienta oraz nowego hasła.', 'login');
                    $state.go('login');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }

        function quickActivate() {
                    $('.content').addClass('hidden');
                    $('.loader.activator').removeClass('hidden');
                    var activationToSend={};
                    angular.copy(vm.activation, activationToSend);
                    delete activationToSend["newRepeat"]
                    RegisterService.quickActivate(activationToSend)
                        .then(function() {
                            Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą kodu klienta oraz nowego hasła.', 'login');
                            $state.go('login');
                            $('.content').removeClass('hidden');
                            $('.loader.activator').addClass('hidden');
                        }).catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                            $('.content').removeClass('hidden');
                            $('.loader.activator').addClass('hidden');
                        });
                }

        function userActivate() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            RegisterService.userActivate(vm.activation)
                .then(function() {
                    Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą loginu oraz nowego hasła.', 'login');
                    $state.go('login');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('ActivateController', ActivateController);

    ActivateController.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils'];

    function ActivateController($state, $stateParams, $location, RegisterService, Info, Utils) {
        var vm = this;

        vm.data = {
            login: null,
            document_nr: null,
            total_netto: null,
            email: null,
            password: null,
            telephone_number: null,
            agreement1: false,
            agreement2: false,
            agreement3: false,
            agreement4: false,
            agreement5: false,
            agreement6: false
        };

        vm.activation = {
            startPassword: null,
            password: null,
            newRepeat: null,
            token: null
        };


        vm.activate = activate;
        vm.quickActivate = quickActivate;
        vm.userActivate = userActivate;

        angular.copy($stateParams, vm.activation);

        function activate() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            var activationToSend={};
            angular.copy(vm.activation, activationToSend);
            delete activationToSend["newRepeat"]
            RegisterService.activate(activationToSend)
                .then(function() {
                    Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą kodu klienta oraz nowego hasła.', 'login');
                    $state.go('login');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }

        function quickActivate() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            var activationToSend={};
            angular.copy(vm.activation, activationToSend);
            delete activationToSend["newRepeat"]
            RegisterService.quickActivate(activationToSend)
                .then(function() {
                    Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą kodu klienta oraz nowego hasła.', 'login');
                    $state.go('login');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }

        function userActivate() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            var activationToSend={};
            angular.copy(vm.activation, activationToSend);
            delete activationToSend["newRepeat"]
            RegisterService.userActivate(activationToSend)
                .then(function() {
                    Info.addStatement('Hasło do konta w Portalu VB Leasing zostało nadane. Proszę zalogować się za pomocą loginu oraz nowego hasła.', 'login');
                    $state.go('login');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('passwordReset', {
            parent: 'site',
            url: '/passwordReset?token',
            params: {
                token: null
            },
            data: {
                authorities: [],
                pageTitle: 'Resetowanie hasła - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/passwordReset/passwordReset.html',
                    controller: 'PasswordResetController',
                    controllerAs: 'vm'
                },
                'step@passwordReset': {
                    templateUrl: 'app/views/passwordReset/passwordReset-Reset.html',
                }
            }
        }).state('passwordReset-Success', {
            parent: 'passwordReset',
            url: '/success',
            views: {
                'step@passwordReset': {
                    templateUrl: 'app/views/passwordReset/passwordReset-Success.html'
                }
            }
        }).state('passwordReset-Confirm', {
            parent: 'passwordReset',
            url: '/confirm',
            views: {
                'step@passwordReset': {
                    templateUrl: 'app/views/passwordReset/passwordReset-Confirm.html'
                }
            },
            resolve: {
                change: function($q, $timeout, $state, $stateParams, Utils, PasswordResetService) {
                    var deferred = $q.defer();

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(function() {
                        if (Utils.isEmpty($stateParams.token)) {
                            $state.go('login');
                            deferred.reject();
                        } else {
                            PasswordResetService.getChange($stateParams)
                                .then(function(response) {
                                    if (response.data.result != null) {
                                        deferred.resolve(response.data.result);
                                    } else {
                                        $state.go('login');
                                        deferred.reject();
                                    }
                                })
                                .catch(function(response) {
                                    $state.go('passwordReset-Fail-' + response.data.errorCode);
                                    deferred.reject();
                                });
                        }
                    });

                    return deferred.promise;
                }
            }
        }).state('passwordReset-Confirm-Success', {
            parent: 'passwordReset',
            url: '/confirm/success',
            views: {
                'step@passwordReset': {
                    templateUrl: 'app/views/passwordReset/passwordReset-Confirm-Success.html'
                }
            }
        }).state('passwordReset-Fail', {
            parent: 'passwordReset',
            url: '/fail',
            views: {
                'step@passwordReset': {
                    templateUrl: 'app/views/passwordReset/passwordReset-Fail.html'
                }
            }
        });

        var errors = [208, 403, 408, 1027, 1028, 1029, 1031, 2013, 2016];
        //Add all error states
        for (var errorIndex in errors) {
            $stateProvider.state('passwordReset-Fail-' + errors[errorIndex], {
                parent: 'passwordReset-Fail',
                url: '/' + errors[errorIndex],
                views: {
                    'fail@passwordReset-Fail': {
                        templateUrl: 'app/views/passwordReset/passwordReset-Fail-' + errors[errorIndex] + '.html'
                    }
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('PasswordResetService', PasswordResetService);

    PasswordResetService.$inject = ['API_URL', '$http'];

    function PasswordResetService(API_URL, $http) {

        return {
            resetPassword: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password/reset',
                    data: data
                });
            },
            confirmResetPassword: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/password/reset/change',
                    data: data
                });
            },
            getChange: function(data) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/change',
                    params: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('PasswordResetController', PasswordResetController);

    PasswordResetController.$inject = ['$state', '$stateParams', 'PasswordResetService', 'Info'];

    function PasswordResetController($state, $stateParams, PasswordResetService, Info) {
        var vm = this;

        //Variables
        vm.data = {
            login: null,
            email: null,
            newValue: null,
            repeatValue: null,
            token: $stateParams.token
        };

        //Function declarations
        vm.resetPassword = resetPassword;
        vm.confirmResetPassword = confirmResetPassword;

        //Function definitions
        function resetPassword() {
            $('.content').addClass('hidden');
            $('.loader').removeClass('hidden');
            vm.data.captcha = grecaptcha.getResponse();
            if (vm.data.captcha == "") {
                Info.addError("Przed wysłaniem formularza potwierdź swoją tożsamość.");
                $('.content').removeClass('hidden');
                $('.loader').addClass('hidden');
            } else {
                PasswordResetService.resetPassword(vm.data)
                    .then(function(response) {
                        $state.go('passwordReset-Success').finally(function() {
                            $('.content').removeClass('hidden');
                            $('.loader').addClass('hidden');
                        });
                    })
                    .catch(function(response) {
                        switch (response.data.errorCode) {
                        case 205:
                            Info.addError("Podany kod klienta i/lub adres e-mail są nieprawidłowe. Spróbuj ponownie.");
                            $('.content').removeClass('hidden');
                            $('.loader').addClass('hidden');
                            break;
                        case 403:
                        case 408:
                            $state.go('passwordReset-Fail-' + response.data.errorCode).then(function() {
                                    $('.content').removeClass('hidden');
                                    $('.loader').addClass('hidden');
                                });
                            break;
                        default:
                            Info.addErrorCode(response.data.errorCode);
                            $('.content').removeClass('hidden');
                            $('.loader').addClass('hidden');
                        }
                    })
                    .finally(function(response) {
                        grecaptcha.reset();
                    });
            }
        }

        function confirmResetPassword() {
            $('.content').addClass('hidden');
            $('.loader').removeClass('hidden');
            PasswordResetService.confirmResetPassword(vm.data)
                .then(function(response) {
                    $state.go('passwordReset-Confirm-Success');
                    $('.content').removeClass('hidden');
                    $('.loader').addClass('hidden');
                })
                .catch(function(response) {
                    $state.go('passwordReset-Fail-' + response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader').addClass('hidden');
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('passwordExpired', {
            parent: 'site',
            url: '/passwordExpired',
            params: {
                login: null,
                currentValue: null
            },
            data: {
                authorities: [],
                pageTitle: 'Zmiana hasła- VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/passwordExpired/passwordExpired.html',
                    controller: 'PasswordExpiredController',
                    controllerAs: 'vm'
                },
                'step@passwordExpired': {
                    templateUrl: 'app/views/passwordExpired/passwordExpired-Change.html',
                }
            },
            resolve: {
                params: function($q, $timeout, $state, $stateParams, Utils) {
                    var deferred = $q.defer();

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(function() {
                        if (Utils.isEmpty($stateParams.login) || Utils.isEmpty($stateParams.currentValue)) {
                            $state.go('login');
                            deferred.reject();
                        } else {
                            deferred.resolve(true);
                        }
                    });

                    return deferred.promise;
                }
            }
        }).state('passwordExpired-Success', {
            parent: 'passwordExpired',
            url: '/success',
            data: {
                authorities: [],
                pageTitle: 'Zmiana hasła- VB Leasing'
            },
            views: {
                'step@passwordExpired': {
                    templateUrl: 'app/views/passwordExpired/passwordExpired-Success.html',
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('PassworExpiredService', PassworExpiredService);

    PassworExpiredService.$inject = ['API_URL', '$http'];

    function PassworExpiredService(API_URL, $http) {

        return {
            changeExpiredPassword: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password/expired',
                    data: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('PasswordExpiredController', PasswordExpiredController);

    PasswordExpiredController.$inject = ['$rootScope', '$state', '$stateParams', 'PassworExpiredService', 'Info'];

    function PasswordExpiredController($rootScope, $state, $stateParams, PassworExpiredService, Info) {
        var vm = this;

        //Variables
        vm.data = {
            login: $stateParams.login,
            currentValue: $stateParams.currentValue,
            newValue: null
        };

        vm.changePassword = changePassword;

        function changePassword() {
            $('.content').addClass('hidden');
            $('.loader').removeClass('hidden');
            PassworExpiredService.changeExpiredPassword(vm.data)
                .then(function(response) {
                    $state.go('passwordExpired-Success');
                    $('.content').removeClass('hidden');
                    $('.loader').addClass('hidden');
                })
                .catch(function(response) {
                    $('.content').removeClass('hidden');
                    $('.loader').addClass('hidden');
                    Info.addErrorCode(response.data.errorCode);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'application',
            url: '/password',
            data: {
                authorities: [],
                pageTitle: 'Resetowanie hasła - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('PasswordService', PasswordService);

    PasswordService.$inject = ['API_URL','$http'];

    function PasswordService (API_URL, $http) {
 
		        return {
		};
	    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['$state', '$stateParams', 'PasswordService'];

    function PasswordController ($state, $stateParams, PasswordService) {
		        var vm = this;		
		
		
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newUserEmail', {
            parent: 'application',
            url: '/user/newEmail',
            params: { userName: null, },
            data: {
                authorities: ['USER_RESOURCE'],
                pageTitle: 'Aktualizuj email użytkownika - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newUserEmail/newUserEmail.html',
                    controller: 'newUserEmailController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('newUserEmailController', newUserEmailController);

    newUserEmailController.$inject = ['$rootScope', '$state', '$stateParams', 'AccountService', 'Info'];

    function newUserEmailController($rootScope, $state, $stateParams, AccountService, Info) {
        var vm = this;

        //Declare variables
        vm.data = {
            email: {
                newValue: null,
                newRepeat: null,
                login: $stateParams.userName
            }
        };

        //Declare functions
        vm.changeUserEmail = changeUserEmail;
        vm.init = init;

        function changeUserEmail() {
            AccountService.changeEmailByAdmin(vm.data.email)
                .then(function(response) {
                    Info.addStatement('Pomyślnie zmieniono adres email użytkownika ' + vm.data.login + 
                        '. Na podany adres e-mail została wysłana wiadomość umożliwiająca nowemu użytkownikowi uzyskanie dostępu do Portalu.', 
                        'users');
                    $state.go('users');
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function init(){
            if (vm.data.email.login == null || vm.data.email.login == undefined) {
                $state.go('users');
            }
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newUser', {
            parent: 'application',
            url: '/user/new',
            data: {
                authorities: ['USER_RESOURCE'],
                pageTitle: 'Nowy użytkownik - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newUser/newUser.html',
                    controller: 'newUserController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('newUserController', newUserController);

    newUserController.$inject = ['$rootScope', '$state', '$stateParams', 'UsersService', 'Info'];

    function newUserController($rootScope, $state, $stateParams, UsersService, Info) {
        var vm = this;

        //Declare variables
        vm.data = {
            login: null,
            pass: null,
            email: null,
            enable: false
        };

        //Declare functions
        vm.createUser = createUser;

        function createUser() {
            UsersService.registerUser(vm.data)
                .then(function(response) {
                    Info.addStatement('Pomyślnie dodano użytkownika ' + vm.data.login + '. Na podany adres e-mail została wysłana wiadomość umożliwiająca nowemu użytkownikowi uzyskanie dostępu do Portalu.', 'users');
                    $state.go('users');
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newRole', {
            parent: 'application',
            url: '/role/new',
            params: {
                role_id: null
            },
            data: {
                authorities: ['ROLE_RESOURCE'],
                pageTitle: 'Nowa rola - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newRole/newRole.html',
                    controller: 'newRoleController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('newRoleController', newRoleController);

    newRoleController.$inject = ['$state', 'RolesService', 'PermissionsService', 'Info'];

    function newRoleController($state, RolesService, PermissionsService, Info) {
        var vm = this;

        //Declare variables
        vm.data = null;
        vm.warnings = [];

        //Declare functions
        vm.init = init;
        vm.createRole = createRole;
        vm.getPermissions = getPermissions;
        vm.updateRolePermissions = updateRolePermissions;
        vm.generateUpdateObject = generateUpdateObject;

        //Init functions
        function init() {
            //Init data 
            vm.data = {
                label: null,
                name: null,
                permissions: null
            };

            vm.getPermissions();
        }

        function createRole() {
            RolesService.createRole(vm.data)
                .then(function(response) {
                    vm.updateRolePermissions(response.data.result);
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function getPermissions() {
            //Get role JSON
            PermissionsService.getPermissions()
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.permissions = response.data.result.permissions;
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function updateRolePermissions(role_id) {
            // Update role permissions
            RolesService.updateRolePermissions(vm.generateUpdateObject(role_id))
                //If successful
                .then(function(response) {
                    Info.addStatement('Pomyślnie dodano rolę ' + vm.data.label + '.', 'roles');
                    $state.go('roles');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                });
        }

        function generateUpdateObject(role_id) {
            var perm_ids = [];
            for (var permission in vm.data.permissions) {
                if (vm.data.permissions[permission].checked)
                    perm_ids.push(vm.data.permissions[permission].perm_id);
            }

            return {
                role_id: role_id,
                perm_ids: perm_ids
            };
        }


        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newClientEmail', {
            parent: 'application',
            url: '/client/newEmail',
            params: { clientLogin: null },
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Aktualizuj email klienta - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newClientEmail/newClientEmail.html',
                    controller: 'newClientEmailController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('newClientEmailController', newUserEmailController);

    newUserEmailController.$inject = ['$rootScope', '$state', '$stateParams', 'AccountService', 'Info'];

    function newUserEmailController($rootScope, $state, $stateParams, AccountService, Info) {
        var vm = this;

        //Declare variables
        vm.data = {
            login: $stateParams.clientLogin,
            newValue: null,
            newRepeat: null
        };

        //Declare functions
        vm.changeUserEmail = changeUserEmail;
        vm.init = init;

        function changeUserEmail() {
            AccountService.changeEmailByAdmin(vm.data)
                .then(function(response) {
                    Info.addStatement('Pomyślnie zmieniono adres email klienta ' + vm.data.login +
                        '. Na podany adres e-mail została wysłana wiadomość umożliwiająca klientowi uzyskanie dostępu do Portalu.',
                        'client');
                    $state.go('client');
                })
                .catch(function(response) {
                    if (response.data.errorCode == null) {
                        Info.addError('Brak uprawnień')
                    } else {
                        Info.addErrorCode(response.data.errorCode);
                    }
                });
        }

        function init() {
            if (vm.data.login == null || !angular.isDefined(vm.data.login)) {
                $state.go('client');
            }
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'site',
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'Logowanie do Portalu - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', 'Auth', 'Info'];

    function LoginController($rootScope, $state, Auth, Info) {
        var vm = this;

        vm.credentials = {
            login: null,
            password: null,
            remember: false
        };

        //Declare functions
        vm.login = login;

        function login() {
            Info.clear();

            //Validate if all inputs are not empty
            if ($('input[type=password].ng-valid.ng-not-empty').length == 0 || $('input[type=text].ng-valid.ng-not-empty').length == 0) {
                Info.addError('Podaj kod klienta / login oraz hasło.');
            } else {
                $("#loginForm").addClass('form-success');
                $(".content").addClass('hidden');
                $('.loader').removeClass('hidden');
                //Login
                Auth.login(vm.credentials)
                    //When successful
                    .then(function(response) {
                        //Go to the documents state
                        $state.go($rootScope.afterAuth || 'documents');
                        $rootScope.afterAuth = undefined;
                    })
                    //When not successful
                    .catch(function(response) {
                        if (response.data == null) {
                            Info.addError('Wystąpił błąd podczas próby zalogowania. Prosimy o kontakt z Działem Obsługi Klienta na adres e-mail: <a href="mailto:portal.klienta@vbl.pl">portal.klienta@vbl.pl</a>.');
                            $("#loginForm").removeClass('form-success');
                            $(".content").removeClass('hidden');
                            $('.loader').addClass('hidden');
                        } else if (response.data.error == 4011) {
                            $state.go('passwordExpired', { login: vm.credentials.login, currentValue: vm.credentials.password }).then(function() {
                                $("#loginForm").removeClass('form-success');
                                $(".content").removeClass('hidden');
                                $('.loader').addClass('hidden');
                            });
                        } else {
                            Info.addErrorCode(response.data.error, 'login', response.data.result);
                            $("#loginForm").removeClass('form-success');
                            $(".content").removeClass('hidden');
                            $('.loader').addClass('hidden');
                        }
                    });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faq', {
            parent: 'application',
            url: '/faq',
			            params :{
			},
            data: {
                authorities: [],
                pageTitle: 'Pytania i odpowiedzi - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/faq/faq.html'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                views: {
                    'index@': {
                        templateUrl: 'app/views/error/error.html'
                    }
                }
            })
            .state('401', {
                parent: 'error',
                url: '/401',
                data: {
                    authorities: [],
                    pageTitle: 'Nie zalogowano - VB Leasing'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/401.html'
                    }
                }
            })
            .state('403', {
                parent: 'error',
                url: '/403',
                data: {
                    authorities: [],
                    pageTitle: 'Brak dostępu - VB Leasing'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/403.html'
                    }
                }
            })
            .state('404', {
                parent: 'error',
                url: '/404',
                data: {
                    authorities: [],
                    pageTitle: 'Podana strona nie istnieje - VB Leasing'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/404.html'
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('emailChange', {
            parent: 'site',
            url: '/emailChange?token',
            params: {
                token: null
            },
            data: {
                authorities: [],
                pageTitle: 'Zmiana adresu e-mail - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/emailChange/emailChange.html'
                }
            }
        }).state('emailChange-Success', {
            parent: 'emailChange',
            url: '/success',
            views: {
                'step@emailChange': {
                    templateUrl: 'app/views/emailChange/emailChange-Success.html',
                }
            },
            resolve: {
                change: function($rootScope, $q, $timeout, $state, $stateParams, Utils, AccountService) {
                    var deferred = $q.defer();
                    var fromState = $rootScope.fromState;

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(jQuery.proxy(function() {
                        if (Utils.isEmpty($stateParams.token)) {
                            $state.go(fromState);
                            deferred.reject();
                        } else {
                            AccountService.getChange($stateParams)
                                .then(function(response) {
                                    if (response.data.result != null) {
                                        AccountService.applyChange($stateParams)
                                            .then(function() {
                                                deferred.resolve(response.data.result);
                                            }).catch(function(response) {
                                                $state.go('emailChange-Fail-' + response.data.errorCode);
                                                deferred.reject();
                                            });
                                    } else {
                                        $state.go(fromState);
                                        deferred.reject();
                                    }
                                })
                                .catch(function(response) {
                                    $state.go('emailChange-Fail-' + response.data.errorCode);
                                    deferred.reject();
                                });
                        }
                    }, this));
                    return deferred.promise;
                }
            }
        }).state('emailChange-Fail', {
            parent: 'emailChange',
            url: '/fail',
            views: {
                'step@emailChange': {
                    templateUrl: 'app/views/emailChange/emailChange-Fail.html'
                }
            }
        });

        var errors = [208, 2013, 2016];
        //Add all error states
        for (var errorIndex in errors) {
            $stateProvider.state('emailChange-Fail-' + errors[errorIndex], {
                parent: 'emailChange-Fail',
                url: '/' + errors[errorIndex],
                views: {
                    'fail@emailChange-Fail': {
                        templateUrl: 'app/views/emailChange/emailChange-Fail-' + errors[errorIndex] + '.html'
                    }
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'application',
            url: '/documents?login&agreement_nr&document_nr&ksef_nr&date_issue_from&date_issue_to&document_types&total_netto_from&total_netto_to&currency&date_document_open_from&date_document_open_to&date_payment_from&date_payment_to',
            params: {
                login: null,
                agreement_nr: null,
                document_nr: null,
                ksef_nr: null,
                date_issue_from: null,
                date_issue_to: null,
                document_types: [],
                total_netto_from: null,
                total_netto_to: null,
                currency: null,
                date_document_open_from: null,
                date_document_open_to: null,
                date_payment_from: null,
                date_payment_to: null
            },
            data: {
                pageTitle: 'Faktury i noty - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/documents/documents.html',
                    controller: 'DocumentsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('DocumentsController', DocumentsController);

    DocumentsController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'DocumentsService', 'DateUtils', 'Info',
    'Principal', 'API_URL', '$http', 'Utils', 'FileSaver', 'Blob'];

    function DocumentsController($scope, $state, $stateParams, $filter, DocumentsService, DateUtils, Info, Principal,
    API_URL, $http, Utils, FileSaver, Blob) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.additionalInfo = null;
        vm.sort = ['-date_issue', '+document_nr'];

        //vm.sortingOrder = {field:'date_document_open', order:'DESC'};

        vm.sortingOrder = [
            {field:'date_issue', order:'DESC'},
            {field:'document_nr', order:'ASC'},
            {field:'ksef_nr', order:'ASC'},
            {field:'agreement_nr', order:'DESC'},
            {field:'document_type', order:'DESC'},
            {field:'invoice_reference', order:'DESC'},
            {field:'date_payment', order:'DESC'},
            {field:'total_netto', order:'DESC'},
            {field:'total_vat', order:'DESC'},
            {field:'total_brutto', order:'DESC'},
            {field:'date_document_open', order:'DESC'}
        ];

        vm.types = [];
        vm.client = null;
        vm.clientEInvoice = null;
        vm.lastLoginDate = null;

        //Declare functions
        vm.init = init;
        vm.resetFilters = resetFilters;
        vm.getDocuments = getDocuments;
        vm.downloadMergedPDF = downloadMergedPDF;
        vm.downloadDocument = downloadDocument;
        vm.downloadXML = downloadXML;
        vm.downloadExcel = downloadExcel;
        vm.getDocumentTypes = getDocumentTypes;
        vm.sortBy = sortBy;
        vm.isSortedWithOrder = isSortedWithOrder;

        //Declare utils
        vm.getDate = DateUtils.convertDateFromServer;
        vm.getValue = getValue;
        vm.isFilterFilled = isFilterFilled;
        vm.isFieldFilled = isFieldFilled;
        vm.validateFilter = validateFilter;
        vm.isDocumentRead = isDocumentRead;

        //Declare pagination functions
        vm.first = first;
        vm.previous = previous;
        vm.next = next;
        vm.last = last;
        vm.getDocs = getDocs;
        vm.open = open;

        //Init functions
        function init() {
            //Init filter
            vm.filter = {
                current: {
                    login: null,
                    agreement_nr: null,
                    document_nr: null,
                    ksef_nr: null,
                    date_issue_from: null,
                    date_issue_to: null,
                    document_types: [],
                    total_netto_from: null,
                    total_netto_to: null,
                    currency: null,
                    date_document_open_from: null,
                    date_document_open_to: null,
                    date_payment_from: null,
                    date_payment_to: null,
                    sorting_order: vm.sortingOrder
                },
                query: {
                    login: null,
                    agreement_nr: null,
                    document_nr: null,
                    ksef_nr: null,
                    date_issue_from: null,
                    date_issue_to: null,
                    document_types: [],
                    total_netto_from: null,
                    total_netto_to: null,
                    currency: null,
                    date_document_open_from: null,
                    date_document_open_to: null,
                    date_payment_from: null,
                    date_payment_to: null,
                    sorting_order: vm.sortingOrder
                }
            };

            //Init data
            vm.data = {
                error: null,
                result: {
                    documents: []
                }
            };
            vm.page = {
                number: 1,
                totalPages: 1,
                newNumber: 1
            };

            vm.enabled = {
                first: false,
                prev: false,
                next: false,
                last: false
            };


            //Copy URL parameters to current filter
            angular.copy($stateParams, vm.filter.query);
            vm.filter.query.document_types = [];
            if (typeof $stateParams.document_types == "string") {
                vm.filter.query.document_types.push($stateParams.document_types);
            } else {
                for (var type in $stateParams.document_types) {
                    vm.filter.query.document_types.push($stateParams.document_types[type]);
                }
            }


            //Check if current user is a client
            Principal.isClient()
                .then(function(isClient) {
                    vm.client = isClient;
                    //If is client
                    if (isClient) {
                        vm.filter.query.login = Principal.getLogin();
                        vm.clientEInvoice = Principal.isEInvoice();
                        vm.lastLoginDate = Principal.getLastLoginDate();
                        vm.lastLoginDate = vm.lastLoginDate !== undefined ? vm.lastLoginDate : null;
                    }

                    if (vm.filter.query.date_issue_from === null || vm.filter.query.date_issue_from === undefined) {
                        var date = new Date(new Date().getTime() - (1000 /*ms*/ * 60 /*s*/ * 60 /*min*/ * 24 /*h*/ * 30 /*days*/ ));
                        vm.filter.query.date_issue_from = String(date.getTime());
                        $(".date-picker[ng-model='vm.filter.query.date_issue_from']").datepicker('update');
                    }

                    //If the filter is filled
                    if (isFilterFilled(vm.filter.query)) {
                        //Get documents from server
                        vm.getDocuments();
                    } else {
                        //If is client
                        if (isClient) {
                            Info.addInfo("Proszę uzupełnić przynajmniej jedno z pól: KOD KLIENTA, NR UMOWY lub NR DOKUMENTU.");
                        } else {
                            Info.addInfo("Proszę uzupełnić przynajmniej jedno z pól: KOD KLIENTA, NR UMOWY, NR DOKUMENTU lub DATA OTWARCIA.");
                        }
                    }
                });

            DocumentsService.getAdditionalInfo(Principal.getLogin()).then(function(response){
                vm.additionalInfo = response.data;
            });

            // Init doc type dropdown
            $('#docTypeDropdown').multiselect({
                nonSelectedText: 'Wszystkie',
                allSelectedText: 'Wszystkie',
                numberDisplayed: 1,
                nSelectedText: ' zaznaczono',
                buttonWidth: '100%',
                inheritClass: true,
                disabledText: 'Brak typów',
                maxHeight: 250,
                selectedClass: 'docTypeDropdownOptionSelected',
                optionClass: 'docTypeDropdownOption',
                onChange: function(option, checked, select) {
                    if (checked)
                        vm.filter.query.document_types.push(option[0].value);
                    else
                        vm.filter.query.document_types.splice(vm.filter.query.document_types.indexOf(option[0].value), 1);

                }
            });
            $('#docTypeDropdown').multiselect('dataprovider', vm.types);
            $('#docTypeDropdown').multiselect('rebuild');


        }

        function first() {
            if (vm.page.number > 1) {
                vm.page.number = 1;
                getDocs();
            }
        }

        function previous() {
            if (vm.page.number > 1) {
                vm.page.number = vm.page.number - 1;
                getDocs();
            }
        }

        function next() {
            if (vm.page.number < vm.page.totalPages) {
                vm.page.number = vm.page.number + 1;
                getDocs();
            }
        }

        function last() {
            if (vm.page.number < vm.page.totalPages) {
                vm.page.number = vm.page.totalPages;
                getDocs();
            }
        }

        function open() {
            //if (vm.page.newNumber === parseInt(vm.page.newNumber, 10) && vm.page.newNumber >= 1 && vm.page.newNumber <= vm.page.totalPages ) {
            if (isNumeric(vm.page.newNumber) && vm.page.newNumber >= 1 && vm.page.newNumber <= vm.page.totalPages) {
                vm.page.number = parseInt(vm.page.newNumber);
                getDocs();
            }
        }

        function isNumeric(num){
          return !isNaN(num)
        }

        function getDocs() {
            //Validate the filter
            vm.validateFilter(vm.filter.current);
            //Get documents JSON by new query
            vm.filter.current.sorting_order = vm.sortingOrder;
            DocumentsService.getDocumentsPaged(vm.filter.current, vm.page.number)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.errorCode = response.data.errorCode;
                    vm.data.result = response.data.result.documents;
                    vm.page.totalPages = response.data.result.pagesNumber;


                    angular.forEach(vm.data.result.documents, function(document){
                        document['additional_info'] = getDocumentRowToolTip(document);
                    });


                    if (response.data.result.documents.documents.length == 0)
                        Info.addStatement('Brak dokumentów spełniających podane kryteria.');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                //If event is not undefined
                    if (event != undefined) {
                    //Enable the button and return to former text
                        event.target.innerText = "Wyszukaj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function resetFilters() {
            vm.filter.query = {
                login: null,
                agreement_nr: null,
                document_nr: null,
                ksef_nr: null,
                date_issue_from: null,
                date_issue_to: null,
                document_types: [],
                total_netto_from: null,
                total_netto_to: null,
                currency: null,
                date_document_open_from: null,
                date_document_open_to: null
            };
            $("input.date-picker").trigger("clearDate");
            $('#docTypeDropdown').multiselect('deselectAll', false);
            $('#docTypeDropdown').multiselect('rebuild');

            //Check if current user is a client
            Principal.isClient()
                .then(function(isClient) {
                    vm.client = isClient;

                    //If is client
                    if (isClient) {
                        vm.filter.query.login = Principal.getLogin();
                    }
                });
        }

        function getDocuments(event) {
            vm.data = {
                error: null,
                result: {
                    documents: []
                }
            };
            Info.clear();
            Info.setAction("Wyszukiwanie dokumentów...");
            //If event is not undefined
            if (event != undefined) {
                //Notify he user of searching and disable the button
                event.target.innerText = "Wyszukiwanie...";
                event.target.disabled = true;
            }
            //Validate the filter
            vm.validateFilter(vm.filter.query);
            //Get documents JSON by new query
            vm.filter.query.sorting_order = vm.sortingOrder;
            DocumentsService.getDocumentsPaged(vm.filter.query, vm.page.number)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.errorCode = response.data.errorCode;
                    vm.data.result = response.data.result.documents;
                    vm.page.totalPages = response.data.result.pagesNumber;
                    vm.page.number = 1;


                    angular.forEach(vm.data.result.documents, function(document){
                        document['additional_info'] = getDocumentRowToolTip(document);
                    });



                    vm.filter.current = {};
                    //Update current filter without binding
                    angular.copy(vm.filter.query, vm.filter.current);
                    //Change URL to match the new query
                    $state.transitionTo('documents', vm.filter.current, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                    if (response.data.result.documents.documents.length == 0)
                        Info.addStatement('Brak dokumentów spełniających podane kryteria.');

                    if(response.data.result.documentsNumber > 0)
                        Info.addStatement("Znaleziono " + response.data.result.documentsNumber + " dokumentów spełniających warunki zapytania.");
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Wyszukaj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function downloadDocument(index, document) {
            if (vm.client && document.ksef_nr != null) {
                Info.addError("Podgląd niedostępny: dokument przesłany do KSeF.");
                return;
            }
            if ((document.e_invoice && vm.clientEInvoice) || !vm.client) {
                Info.setAction("Pobieranie dokumentu...");
                DocumentsService.getDocument(document.transaction_id, document.template, document.login)
                    .then(function(response) {
                        var file = new Blob([response.data], { type: "application/pdf" });
                        FileSaver.saveAs(file,
                            "Dokument nr " + document.document_nr + " z dnia " + new Date().toLocaleDateString() +
                            ".pdf");
                        Info.addStatement("Pomyślnie pobrano dokument.");

                        //Update date opened
                        if (vm.client && !document.date_document_open) {
                            document.date_document_open = new Date().getTime();
                            Principal.identity(true);
                        }
                    })
                    .catch(function(response) {
                        Info.addError("Wystąpił błąd podczas pobierania dokumentu.");
                    })
                    .finally(function() {
                        Info.clearAction();
                        Principal.identity(force);
                    });
            }
        }

        function downloadMergedPDF() {
                    Info.clear();
                    Info.setAction("Pobieranie dokumentów...");

                    //Validate the filter
                    vm.validateFilter(vm.filter.current);
                    //Get documents JSON by new query
                    vm.filter.current.sorting_order = vm.sortingOrder;
                    DocumentsService.downloadMergedPDFPaged(vm.filter.current, vm.page.number)
                        //If successful
                        .then(function(response) {
                           var file = new Blob([response.data], { type: "application/pdf" });
                           FileSaver.saveAs(file,
                               "Dokumenty.pdf");

                           var responseHeaders = response.headers();

                           var lastPage = responseHeaders.to_page;

                           if (lastPage > vm.page.totalPages) {
                                lastPage = vm.page.totalPages;
                           }
                           Info.addStatement("Pomyślnie pobrano dokumenty. Plik zawiera dokumenty ze stron " + vm.page.number + " - " + lastPage + ".");
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        })
                        .finally(function(response) {
                            Info.clearAction();
                            Principal.identity(force);
                        });
                }

        function downloadXML(event, index, document) {
            event.stopPropagation();
            if (vm.client && document.ksef_nr != null) {
                Info.addError("Podgląd XML niedostępny: dokument przesłany do KSeF.");
                return;
            }
            if (document.e_invoice || !vm.client) {
                Info.setAction("Pobieranie dokumentu...");
                DocumentsService.getXML(document.transaction_id, document.login)
                    .then(function(response) {
                        var file = new Blob([response.data], { type: "application/xml" });
                        FileSaver.saveAs(file,
                            "Dokument nr " + document.document_nr + " z dnia " + new Date().toLocaleDateString() +
                            ".xml");
                        Info.addStatement("Pomyślnie pobrano dokument.");

                        //Update date opened
                        if (vm.client && !document.date_document_open) {
                            document.date_document_open = new Date().getTime();
                            Principal.identity(true);
                        }
                    })
                    .catch(function(response) {
                        Info.addError("Wystąpił błąd podczas pobierania dokumentu.");
                    })
                    .finally(function() {
                        Info.clearAction();
                        Principal.identity(force);
                    });
            }
        }

        function downloadExcel(event) {
            Info.setAction("Pobieranie arkusza Excel...");
            //Notify the user of downloading and disable the button
            event.target.disabled = true;
            event.target.innerText = "POBIERANIE...";

            vm.filter.current.sorting_order = vm.sortingOrder;
            DocumentsService.getExcelSpreadsheetPaged(vm.filter.current, vm.page.number)
                .then(function(response) {
                    var file = new Blob([response.data], { type: "application/vnd.ms-excel" });
                    FileSaver.saveAs(file,
                        "Dokumenty z dnia " + new Date().toLocaleDateString() +
                        ".xls");

                    var responseHeaders = response.headers();

                    var lastPage = responseHeaders.to_page;

                    if (lastPage > vm.page.totalPages) {
                        lastPage = vm.page.totalPages;
                    }
                    Info.addStatement("Pomyślnie pobrano arkusz Excel. Arkusz zawiera dokumenty ze stron " + vm.page.number + " - " + lastPage + ".");
                })
                .catch(function(response) {
                    Info.addError("Wystąpił błąd podczas pobierania arkusza Excel.");
                })
                .finally(function() {
                    Info.clearAction();
                });

            //Notify the user that the document has been downloaded and enable the button
            event.target.disabled = false;
            event.target.innerText = "POBIERZ JAKO XLS";
        }

        function getDocumentTypes($event) {
            if (vm.types.length == 0) {
                DocumentsService.getDocumentTypes(Principal.getLogin())
                    .then(function(response) {
                        response.data.result.sort();
                        for (var type in response.data.result) {
                            vm.types.push({
                                label: response.data.result[type].toUpperCase(),
                                title: response.data.result[type],
                                value: response.data.result[type]
                            });
                        }
                        $('#docTypeDropdown').multiselect('dataprovider', vm.types);
                        $('#docTypeDropdown').multiselect('rebuild');
                        $('#docTypeDropdown').multiselect('select', vm.filter.query.document_types);
                    });
            }
        }

        function sortBy(property) {
            var propertyObject = $filter('filter')(vm.sortingOrder, {'field':property})[0]
            var index = vm.sortingOrder.indexOf(propertyObject);

            if (index > 0) {
                vm.sortingOrder.splice(index, 1);
                vm.sortingOrder.unshift(propertyObject);
            }

            if (propertyObject.order == "ASC") {
                propertyObject.order = "DESC";
            } else {
                propertyObject.order = "ASC";
            }
            getDocs();
        }

        function isSortedWithOrder(property, order) {
            var propertyObject = $filter('filter')(vm.sortingOrder, {'field':property})[0]
            var index = vm.sortingOrder.indexOf(propertyObject);

            return index == 0 && propertyObject.order === order;
        }


        function getValue(value) {
            //Get value with two decimal digits
            return parseFloat(value).toFixed(2);
        }

        function generateExcelDownloadLink() {
            var filter = vm.filter.current;
            var link = API_URL + "api/documents/excel?";
            for (var key in filter) {
                //If the value matched by key is an empty string
                if (isFieldFilled(filter[key])) {
                    link += (key + "=" + filter[key] + "&");
                }
            }
            return link;
        }

        function isFilterFilled(filter) {
            if (vm.isFieldFilled(filter.login) || vm.isFieldFilled(filter.agreement_nr) || vm.isFieldFilled(filter.document_nr))
                return true;
            else
            //If there are no mandatory values in the filter return false
                return false;
        }

        function isFieldFilled(field) {
            if (field != null && field !== '' && field === field)
                return true;
            else
                return false;
        }

        function validateFilter(filter) {
            //Check all keys
            for (var key in filter) {
                //If the value matched by key is empty
                if (!isFieldFilled(filter[key])) {
                    //Substitue it with null
                    filter[key] = null;
                }
            }
        }

        function getDate(date) {
            return Utils.getDate(date);
        }

        function isDocumentRead(document) {
            if (document.isRead === true || document.isRead === false)
                return document.isRead;

            var isRead;

            //E-invoice
            if (!document.e_invoice)
                isRead = false;
            //Employee
            else if (Principal.getLogin() !== document.login)
                isRead = document.first_document_view_date != null;
            //Client
             else
                isRead = document.first_document_view_date != null && document.first_document_view_date < Principal.getLastLoginDate();

            document.isRead = isRead; //Persist read state to prevent recalculation
            return isRead;
        }

        function checkIfErrorPaymentDate(document){

            var idx = vm.additionalInfo.documents.indexOf(document.document_nr);

            return idx >= 0;


        }

        function getDocumentRowToolTip(document){

            var tipText = ''

            Principal.isClient()
            console.info(vm.clientEInvoice);

            if(document.e_invoice && document.ksef_nr === null){
                tipText += 'Dokument (.pdf), kliknij by pobrać<BR>';
            }
            if(!document.e_invoice && (vm.clientEInvoice || !vm.isClient) && document.ksef_nr === null){
                tipText += 'Dokument został wystawiony w wersji tradycyjnej i wysłany pocztą<BR>';
            }
            if(!document.e_invoice && (!vm.clientEInvoice && vm.isClient) && document.ksef_nr === null){
                tipText += 'Podgląd niedostępny, dokument został wystawiony w wersji tradycyjnej i wysłany pocztą<BR>';
            }
            if(vm.additionalInfo != null && checkIfErrorPaymentDate(document) && document.ksef_nr === null){
                tipText += '<B>Uwaga! Błędny termin płatności na fakturze nr '+document.document_nr+'. Prawidłowy termin to 30-06-2019. Prosimy o opłacenie należności do 30-06-2019</B>';
            }
            if(document.ksef_nr !== null){
                tipText += 'Faktura jest dostępna do pobrania w KSeF<BR>';
            }
            return tipText;
        }



        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('communique', {
            parent: 'application',
            url: '/communique',
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Communique - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/communique/communique.html',
                    controller: 'CommuniqueController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('CommuniqueController', CommuniqueController);

    CommuniqueController.$inject = ['Info', 'ShellService'];

    function CommuniqueController(Info, ShellService) {
        var vm = this;

        //Declare variables
        vm.communique = null;


        //Declare functions
        vm.init = init;
        vm.updateCommunique = updateCommunique;
        vm.getCommunique = getCommunique;

        //Init functions
        function init() {
             vm.communique = {
                        dateStart: null,
                        dateEnd: null,
                        line1: null,
                        line2: null
                        };
        }

         function getCommunique() {

                    ShellService.communique1("b").then(function(response){
                      document.getElementById("lane1").value = response.data.result;
                    }).catch(function(response){
                      document.getElementById("lane1").value ="ERROR";
                    });

                     ShellService.communique2("b").then(function(response){
                       document.getElementById("lane2").value = response.data.result;
                     }).catch(function(response){
                       document.getElementById("lane2").value ="ERROR";
                     });

                     ShellService.dateStart().then(function(response){
                       document.getElementById("dateStart").value = response.data.result;
                     }).catch(function(response){
                       document.getElementById("dateStart").value ="ERROR";
                     });

                     ShellService.dateEnd().then(function(response){
                       document.getElementById("dateEnd").value = response.data.result;
                     }).catch(function(response){
                       document.getElementById("dateEnd").value ="ERROR";
                     });

                    }

        function updateCommunique(event) {
        vm.communique.line1 = document.getElementById("lane1").value;
        console.log(document.getElementById("lane1").value);
        vm.communique.line2 = document.getElementById("lane2").value;
        console.log(document.getElementById("lane2").value);
        vm.communique.dateStart = document.getElementById("dateStart").value;
        console.log(document.getElementById("dateStart").value);
        vm.communique.dateEnd =  document.getElementById("dateEnd").value;
        console.log(document.getElementById("dateEnd").value);

                 ShellService.getLine1(vm.communique).then(function(response){
                                     }).catch(function(response){

                                     });
                }

        vm.init();
        vm.getCommunique();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('client', {
            parent: 'application',
            url: '/client?login&email',
            params: {
                login: null,
                email: null
            },
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Klienci - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/client/client.html',
                    controller: 'ClientController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['$state', '$stateParams', 'ClientsService', 'DateUtils', 'Info', 'PasswordResetService', 'Principal', '$scope', 'Utils'];

    function ClientController($state, $stateParams, ClientsService, DateUtils, Info, PasswordResetService, Principal, $scope, Utils) {
        var vm = this;

        vm.data = null;

        //Declare functions
        vm.init = init;
        vm.previous = previous;
        vm.next = next;
        vm.page = page;
        vm.setClient = setClient;
        vm.getClient = getClients;
        vm.getClientLogs = getClientLogs;
        vm.resetPassword = resetPassword;
        vm.unlock = unlock;

        //Declare utils
        vm.validateFilter = validateFilter;
        vm.getLogQueryObject = getLogQueryObject;
        vm.Date = DateUtils.convertDateTimeFromServer;
        vm.isFilterFilled = isFilterFilled;
        vm.getValue = getValue;
        vm.resetFilters = resetFilters;
        vm.now = now;
        vm.getNumber = getNumber;
        vm.pipeRegex = Utils.getPipeRegex();

        //Init functions
        function init() {
            //Init filter
            vm.filter = {
                current: {
                    login: null,
                    email: null

                },
                query: {
                    login: null,
                    email: null
                },
                log: {
                    client_id: null,
                    ts_from: null,
                    ts_to: null
                }
            };

            //Init data
            vm.data = {
                offset: 0,
                client: null,
                result: {}
            };

            //Copy URL parameters to current filter
            angular.copy($stateParams, vm.filter.query);

            //If the filter is filled
            if (isFilterFilled(vm.filter.query)) {
                //Get client from server
                getClients();
            } else {
                Info.addInfo("Proszę uzupełnić przynajmniej jedno z pól: KOD KLIENTA lub E-MAIL.");
            }
        }

        function previous() {
            vm.data.offset--;
            if (vm.data.offset < parseInt(vm.data.pageStart) + 3)
                vm.data.pageStart = Math.max(0, vm.data.offset - 2);
            if (vm.data.offset > parseInt(vm.data.pageStart) + 7)
                vm.data.pageStart = Math.min(vm.data.result.pageCount - 10, vm.data.offset - 7);
            getClients();
        }

        function next() {
            vm.data.offset++;
            if (vm.data.offset < parseInt(vm.data.pageStart) + 3)
                vm.data.pageStart = Math.max(0, vm.data.offset - 2);
            if (vm.data.offset > parseInt(vm.data.pageStart) + 7)
                vm.data.pageStart = Math.min(vm.data.result.pageCount - 10, vm.data.offset - 7);
            getClients();
        }

        function page(index) {
            vm.data.offset = index;
            if (vm.data.result.pageCount > 10) {
                if (vm.data.offset < parseInt(vm.data.pageStart) + 3)
                    vm.data.pageStart = Math.max(0, vm.data.offset - 2);
                if (vm.data.offset > parseInt(vm.data.pageStart) + 7)
                    vm.data.pageStart = Math.min(vm.data.result.pageCount - 10, vm.data.offset - 7);
                if (vm.data.result.pageCount - 10 < parseInt(vm.data.pageStart))
                    vm.data.pageStart = Math.min(vm.data.result.pageCount - 10, vm.data.offset - 7);
            }
            getClients();
        }

        function setClient($event, client) {
            Info.clear();
            Info.setAction("Pobieranie klienta...");
            //Get users JSON by new query
            ClientsService.getClient(client)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.client = response.data.result;
                    if (vm.data.client != null)
                        getClientLogs();
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    Info.clearAction();
                });
        }

        function getClients(event) {
            Info.clear();
            Info.setAction("Wyszukiwanie klientów...");
            vm.data.client = null;
            //If event is not undefined
            if (event != undefined) {
                vm.data.pageStart = 0;
                vm.data.offset = 0;
                //Notify the user of searching and disable the button
                event.target.innerText = "Wyszukiwanie...";
                event.target.disabled = true;
            }
            //Validate the filter
            vm.validateFilter(vm.filter.query);
            //Get users JSON by new query
            ClientsService.getClients(vm.filter.query, vm.data.offset)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data.result = response.data.result;
                    //Update current filter without binding
                    angular.copy(vm.filter.query, vm.filter.current);

                    //Change URL to match the new query
                    $state.transitionTo('client', vm.filter.current, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });

                    if (vm.data.result.entries == null || vm.data.result.entries.clients == null || vm.data.result.entries.clients.length == 0) {
                        Info.addStatement("Brak klientów spełniających podane kryteria.");
                        vm.data.client = null;
                    }
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Wyszukaj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function getClientLogs() {
            Principal.hasAuthority('LOGS_CLIENT_RESOURCE').then(function(response) {
                if (response) {
                    Info.setAction("Pobieranie historii klienta...");
                    //Get users JSON by new query
                    ClientsService.getClientLogs(vm.getLogQueryObject())
                        //If successful
                        .then(function(response) {
                            //Set data to controller data
                            vm.data.logs = response.data.result.logs;
                        })
                        //If there were errors
                        .catch(function(response) {
                            Info.addErrorCode(response.data.errorCode);
                        })
                        .finally(function() {
                            Info.clearAction();
                            $('html, body').animate({
                                scrollTop: Math.min($('body').height() - window.innerHeight, $('#clientInfo').offset().top - 60)
                            }, 1000, 'swing');
                        });
                }
            });
        }

        function resetPassword(event) {
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Resetowanie...";
                event.target.disabled = true;
            }
            PasswordResetService.resetPassword({
                    login: vm.data.client.login,
                    email: vm.data.client.email
                })
                .then(function(response) {
                    Info.addStatement("Na adres e-mail klienta została wysłana wiadomość umożliwiająca nadanie nowego hasła.");
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Zresetuj hasło";
                        event.target.disabled = false;
                    }
                });
        }

        function unlock(event) {
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Odblokowywanie...";
                event.target.disabled = true;
            }
            ClientsService.unlockClient(vm.data.client.login)
                .then(function(response) {
                    Info.addStatement("Odblokowano konto klienta.");
                    vm.data.client.account_blocked = false;
                    vm.data.client.invalid_login_counter = 0;
                })
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Odblokuj konto";
                        event.target.disabled = false;
                    }
                });
        }

        function validateFilter(filter) {
            for (var key in filter) {
                if (!isFieldFilled(filter[key])) {
                    filter[key] = null;
                }
            }
        }

        function getLogQueryObject() {
            validateFilter(vm.filter.log);
            var filter = jQuery.extend(true, {}, vm.filter.log);
            filter.maker_id = vm.data.client.client_id;
            filter.relative_id = vm.data.client.client_id;
            return filter;
        }

        function isFilterFilled(filter) {
            //Check all keys
            for (var key in filter) {
                //If the value matched by key is not empty return true
                if (isFieldFilled(filter[key])) {
                    return true;
                }
            }
            //If there are no values in the filter return false
            return false;
        }

        function isFieldFilled(field) {
            if (field != null && field != '')
                return true;
            else
                return false;
        }

        function getValue(value) {
            //Get value with two decimal digits
            return parseFloat(value).toFixed(2);
        }

        function resetFilters() {
            var id = vm.filter.log.client_id;
            vm.filter.log = {
                client_id: id,
                ts_from: null,
                ts_to: null
            };
        }

        function getDate(date) {
            var result = new Date(0);
            result.setSeconds(0);
            result.setMinutes(0);
            result.setHours(0);
            result.setDate(date.split('.')[0]);
            result.setMonth(date.split('.')[1] - 1);
            result.setYear(date.split('.')[2]);
            return result.getTime();
        }

        function now() {
            return new Date().getTime();
        }

        function getNumber(num) {
            var a = new Array();
            for (var i = 0; i < num; i++)
                a.push(i);
            return a;
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('agreements', {
            parent: 'application',
            url: '/agreements?login&agreement_nr&agreement_date_from&agreement_date_to&end_plan_date_from&end_plan_date_to&subject&registration_number&status',
            params: {
                login: null,
                agreement_nr: null,
                agreement_date_from: null,
                agreement_date_to: null,
                end_plan_date_from: null,
                end_plan_date_to: null,
                subject: null,
                registration_number: null,
                status: null
            },
            data: {
                authorities: [],
                pageTitle: 'Umowy - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/agreements/agreements.html',
                    controller: 'AgreementsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('AgreementsController', AgreementsController);

    AgreementsController.$inject = ['$state', '$stateParams', 'AgreementsService', 'DateUtils', 'Info', 'Principal'];

    function AgreementsController($state, $stateParams, AgreementsService, DateUtils, Info, Principal) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.sort = ['-agreement_date', '+agreement_nr'];

        //Declare functions
        vm.init = init;
        vm.getAgreements = getAgreements;
        vm.resetFilters = resetFilters;
        vm.validateFilter = validateFilter;
        vm.sortBy = sortBy;
        vm.isFilterFilled = isFilterFilled;
        vm.Date = DateUtils.convertDateFromServer;

        //Init functions
        function init() {
            //Init filter
            vm.filter = {
                current: {
                    login: null,
                    agreement_nr: null,
                    agreement_date_from: null,
                    agreement_date_to: null,
                    end_plan_date_from: null,
                    end_plan_date_to: null,
                    subject: null,
                    registration_number: null,
                    status: null
                },
                query: {
                    login: null,
                    agreement_nr: null,
                    agreement_date_from: null,
                    agreement_date_to: null,
                    end_plan_date_from: null,
                    end_plan_date_to: null,
                    subject: null,
                    registration_number: null,
                    status: null
                }
            };

            vm.data = {
                error: null,
                result: {
                    agreements: []
                }
            };

            //Copy URL parameters to current filter
            angular.copy($stateParams, vm.filter.query);

            //Check if current user is a client
            Principal.isClient()
                .then(function(isClient) {
                    //If is client
                    if (isClient) {
                        vm.filter.query.login = Principal.getLogin();
                    }
                    //If the filter is filled
                    if (isFilterFilled(vm.filter.query)) {
                        //Get documents from server
                        vm.getAgreements();
                    } else {
                        Info.addInfo("Proszę uzupełnić przynajmniej jedno z pól: KOD KLIENTA lub NR UMOWY.");
                    }
                });
        }

        vm.init();

        function resetFilters(event) {
            if (event != undefined) {
                if (event.target.localName != "button") {
                    event.target = event.target.parentNode;
                }
                //Notify the user of refreshing by disabling the button
                event.target.disabled = true;
            }
            if (event != undefined) {
                //Notify the user of end of refreshing by enabling the button
                event.target.disabled = false;
                vm.filter.query.agreement_nr = null;
                vm.filter.query.login = null;
                vm.filter.query.agreement_date_from = null;
                vm.filter.query.agreement_date_to = null;
                vm.filter.query.end_plan_date_from = null;
                vm.filter.query.end_plan_date_to = null;
                vm.filter.query.subject = null;
                vm.filter.query.registration_number = null;
                vm.filter.query.status = null;
            }
        }

        function getAgreements(event) {
            vm.data = {
                error: null,
                result: {
                    agreements: []
                }
            };
            Info.clear();
            Info.setAction("Pobieranie umów...");
            //If event is not undefined     
            if (event != undefined) {
                //Notify the user of searching and disable the button
                event.target.innerText = "Wyszukiwanie...";
                event.target.disabled = true;
            }
            vm.validateFilter(vm.filter.query);
            //Get documents JSON by new query
            AgreementsService.getAgreements(vm.filter.query)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    vm.data = response.data;
                    //Update current filter without binding
                    angular.copy(vm.filter.query, vm.filter.current);
                    //Change URL to match the new query
                    $state.transitionTo('agreements', vm.filter.current, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                    if (response.data.result.agreements.length == 0)
                        Info.addStatement('Brak umów spełniających podane kryteria.');
                })
                //If there were errors
                .catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                })
                .finally(function(response) {
                    //If event is not undefined
                    if (event != undefined) {
                        //Enable the button and return to former text
                        event.target.innerText = "Wyszukaj";
                        event.target.disabled = false;
                    }
                    Info.clearAction();
                });
        }

        function sortBy(property) {
            //If sort contains this property descending
            if (vm.sort.indexOf('-' + property) == 0) {
                //Push it as ascending instead
                vm.sort = ['+' + property];
            } //If sort contains this property ascending
            else if (vm.sort.indexOf('+' + property) == 0) {
                //Delete it from sort
                vm.sort = ['-agreement_date', '+agreement_nr'];
            } //If sort does not contain this property at all
            else {
                //Push it as descending
                vm.sort = ['-' + property];
            }
        }

        function isFilterFilled(filter) {
            //Check all keys
            for (var key in filter) {
                //If the value matched by key is not empty return true
                if (filter[key] != null && filter[key] != undefined && filter[key] != "") {
                    return true;
                }
            }
            //If there are no values in the filter return false
            return false;
        }

        function validateFilter(filter) {
            //Check all keys
            for (var key in filter) {
                //If the value matched by key is an empty string
                if (filter[key] == "" || filter[key] !== filter[key] || filter[key] == undefined) {
                    //Substitue it with null
                    filter[key] = null;
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('QuickActivate1Controller', QuickActivate1Controller);

    QuickActivate1Controller.$inject = ['$state', '$stateParams', '$location', 'RegisterService', 'Info', 'Utils'];

    function QuickActivate1Controller($state, $stateParams, $location, RegisterService, Info) {
        var vm = this;

        vm.data = {
            agreement1: true,
            agreement3: false
        };

        vm.tokenData = {
            token: null
        }

        vm.getData = getData;
        vm.spreadApproval = spreadApproval;

        angular.copy($stateParams, vm.tokenData);

        getData();

        function getData() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            RegisterService.getApprovalData(vm.tokenData)
                .then(function(response) {
                    vm.data.agreement3 = response.data.result;
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }

        function spreadApproval() {
            $('.content').addClass('hidden');
            $('.loader.activator').removeClass('hidden');
            RegisterService.spreadApproval(vm.tokenData)
                .then(function() {
                    $state.go('quickActivate2');
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                }).catch(function(response) {
                    Info.addErrorCode(response.data.errorCode);
                    $('.content').removeClass('hidden');
                    $('.loader.activator').addClass('hidden');
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'register',
            url: '/activate',
            data: {
                pageTitle: 'Aktywacja konta klienta - VB Leasing'
            },
            views: {
                'step@register': {
                    templateUrl: 'app/views/activate/activate.html',
                    controller: 'ActivateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                    var deferred = $q.defer();

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(function() {
                        if (Utils.isEmpty($stateParams.token)) {
                            $state.go('login');
                            deferred.reject();
                        } else {
                            RegisterService.getRegistration($stateParams)
                                .then(function(response) {
                                    if (response.data.result != null) {
                                        deferred.resolve(response.data.result);
                                    } else {
                                        $state.go('login');
                                        deferred.reject();
                                    }
                                })
                                .catch(function(response) {
                                    $state.go('register-fail-' + response.data.errorCode);
                                    deferred.reject();
                                });
                        }
                    });

                    return deferred.promise;
                }
            }
        }).state('quickActivate2', {
            parent: 'register',
            url: '/activate/quick/end',
            data: {
                pageTitle: 'Aktywacja konta klienta - VB Leasing'
            },
            views: {
                'step@register': {
                    templateUrl: 'app/views/activate/quickActivate2.html',
                    controller: 'ActivateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                    var deferred = $q.defer();

                    // $timeout is an example; it also can be an xhr request or any other async function
                    $timeout(function() {
                        if (Utils.isEmpty($stateParams.token)) {
                            $state.go('login');
                            deferred.reject();
                        } else {
                            RegisterService.getRegistration($stateParams)
                                .then(function(response) {
                                    if (response.data.result != null) {
                                        deferred.resolve(response.data.result);
                                    } else {
                                        $state.go('login');
                                        deferred.reject();
                                    }
                                })
                                .catch(function(response) {
                                    $state.go('register-fail-' + response.data.errorCode);
                                    deferred.reject();
                                });
                        }
                    });

                    return deferred.promise;
                }
            }
        }).state('quickActivate1', {
                      parent: 'register',
                      url: '/activate/quick',
                      data: {
                          pageTitle: 'Aktywacja konta klienta - VB Leasing'
                      },
                      views: {
                          'step@register': {
                              templateUrl: 'app/views/activate/quickActivate1.html',
                              controller: 'QuickActivate1Controller',
                              controllerAs: 'vm'
                          }
                      },
                      resolve: {
                          registration: function($q, $timeout, $state, $stateParams, Utils, RegisterService) {

                              var deferred = $q.defer();

                              // $timeout is an example; it also can be an xhr request or any other async function
                              $timeout(function() {
                                  if (Utils.isEmpty($stateParams.token)) {
                                      $state.go('quickActivate2');
                                      deferred.reject();
                                  } else {
                                      RegisterService.getRegistration($stateParams)
                                          .then(function(response) {
                                              if (response.data.result != null) {
                                                  deferred.resolve(response.data.result);
                                              } else {
                                                  $state.go('quickActivate2');
                                                  deferred.reject();
                                              }
                                          })
                                          .catch(function(response) {
                                              $state.go('register-fail-' + response.data.errorCode);
                                              deferred.reject();
                                          });
                                  }
                              });

                              return deferred.promise;
                          }
                      }
                  });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Utils', Utils);

    Utils.$inject = [];

    function Utils() {

        var utils = {
            isEmpty: isEmpty,
            isNotAmount: isNotAmount,
            isNotDate: isNotDate,
            getDate: getDate,
            getPipeRegex: getPipeRegex
        };

        return utils;

        function isEmpty(value) {
            if (value == null || value.toString() == '' || value !== value)
                return true;
            else
                return false;
        }

        function isNotAmount(value) {
            if (value == null || value.toString() == '' || isNaN(value.toString().replace(',', '.')))
                return true;
            else
                return false;
        }

        function isNotDate(value) {
            if (value == null || value.toString() == '' || !/^\d{2}\.\d{2}\.\d{4}$/.test(value))
                return true;
            else
                return false;
        }

        function getDate(date) {
            if (date) {
                date = new Date(date);
                return ((date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "." + (date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "." + date.getFullYear());
            }
        }

        function getPipeRegex() {
            return /\|/g;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Info', Info);

    Info.$inject = ['$state'];

    function Info($state) {
        var _errors = {},
            _statements = {},
            _infos = {},
            _action = [];

        return {
            action: _action,
            errors: _errors,
            statements: _statements,
            infos: _infos,
            addInfo: addInfo,
            addStatement: addStatement,
            addError: addError,
            addErrorCode: addErrorCode,
            setAction: setAction,
            clearAction: clearAction,
            clear: clear
        };

        function addInfo(info, state) {
            //If the state has not been passed
            if (state == undefined)
            //Set it as current state
                state = $state.current.name;
                //If the container for 'state' is not initialized
            if (_infos[state] == undefined)
            //Initialize it as an array
                _infos[state] = [];

            var container = _infos[state];
            var index = container.indexOf(info);
            // If the info already is in _infos
            if (index != -1) {
                // Remove it from _infos
                container.splice(index, 1);
            }
            // Add the info to _infos
            container.push(info);
        }

        function addStatement(statement, state) {
            //If the state ahs not been passed
            if (state == undefined)
            //Set it as current state
                state = $state.current.name;
                //If the container for 'state' is not initialized
            if (_statements[state] == undefined)
            //Initialize it as an array
                _statements[state] = [];

            var container = _statements[state];
            var index = container.indexOf(statement);
            // If the statement already is in _statements
            if (index != -1) {
                // Remove it from _statements
                container.splice(index, 1);
            }
            // Add the statement to _statements
            container.push(statement);
        }

        function addError(error, state) {
            //If the state ahs not been passed
            if (state == undefined)
            //Set it as current state
                state = $state.current.name;
                //If the container for 'state' is not initialized
            if (_errors[state] == undefined)
            //Initialize it as an array
                _errors[state] = [];

            var container = _errors[state];
            var index = container.indexOf(error);
            // If the error already is in _errors
            if (index != -1) {
                // Remove it from _errors
                container.splice(index, 1);
            }
            // Add the error to _errors
            container.push(error);
        }

        function addErrorCode(errorCode, state, detail) {
            //If the state has not been passed
            if (state == undefined)
            //Set it as current state
                state = $state.current.name;
                // Choose error message corresponding to the error code and add it to errors
            switch (errorCode) {
                //VALIDATION
            case 101:
                addError('Nie podano KODU KLIENTA, ani NUMERU UMOWY.', state);
                break;
            case 102:
                addError('Nie podano KODU lub E-MAILA klienta.', state);
                break;
            case 103:
                addError('Nie podano ID klienta.', state);
                break;
            case 104:
                addError('Nie podano hasła.', state);
                break;
            case 105:
                addError('Nie podano żadnej wartości do zaktualizowania.', state);
                break;
            case 106:
                addError('Nie wypełniono wszystkich pól.', state);
                break;
            case 107:
                addError('Nie podano wymaganych pól.', state);
                break;
            case 108:
                addError('Nie wypełniono wszystkich pól.', state);
                break;
            case 109:
                addError('Nie podano ID roli.', state);
                break;
            case 1010:
                addError('Nie podano żadnej wartości do zaktualizowania.', state);
                break;
            case 1011:
                addError('Nie podano ID roli.', state);
                break;
            case 1012:
                addError('Nie podano żadnych uprawnień dla tej roli.', state);
                break;
            case 1013:
                addError('Nie wypełniono wszystkich pól.', state);
                break;
            case 1014:
                addError('Nie podano ID użytkownika.', state);
                break;
            case 1015:
                addError('Nie podano żadnej wartości do zaktualizowania.', state);
                break;
            case 1016:
                addError('Nie podano ID użytkownika.', state);
                break;
            case 1017:
                addError('Nie podano żadnej roli dla tego użytkownika.', state);
                break;
            case 1018:
                addError('Podaj interwał dłuższy lub równy 7 dni.', state);
                break;
            case 1019:
                addError('Podane aktualne hasło jest nieprawidłowe.', state);
                break;
            case 1020:
                addError('Podany stary adres e-mail nie jest taki sam, jak aktualny adres e-mail.', state);
                break;
            case 1027:
                addError('Nie podano tokenu.', state);
                break;
            case 1028:
                addError('Nie podano nowego hasła dwukrotnie.', state);
                break;
            case 1029:
                addError('Podane hasła nie są jednakowe.', state);
                break;
            case 1031:
                addError('Podane hasło nie spełnia wymogów bezpieczeństwa.', state);
                break;
            case 1401:
                addError('Nie potwierdzono zgód lub sesja wygasła. Kliknij ponownie w link aktywacyjny.', state);
                break;

                    //RESOURCE
            case 201:
                addError('Podany login już istnieje.', state);
                break;
            case 202:
                addError('Podany nowy adres e-mail już istnieje.', state);
                break;
            case 203:
                addError('Błąd podczas generowania dokumentu Excel.', state);
                break;
            case 204:
                addError('Podany klient jest już zarejestrowany.', state);
                break;
            case 205:
                addError('Podany klient nie istnieje.', state);
                break;
            case 206:
                addError('Podany dokument nie istnieje.', state);
                break;
            case 207:
                addError('Klient o podanym numerze jest już zarejestrowany w Portalu VB Leasing.', state);
                break;
            case 208:
                addError('Rejestracji o podanym tokenie nie ma w bazie.', state);
                break;
            case 209:
                addError('Klient o podanym numerze nie posiada aktywnej umowy z VB Leasing.', state);
                break;
            case 2010:
                addError('Podany typ szablonu dokumentu jest niepoprawny.', state);
                break;
            case 2011:
                addError('Podany typ dokumentu jest niepoprawny.', state);
                break;
            case 2012:
                addError('Wystąpił błąd podczas pobierania dokumentu.', state);
                break;
            case 2013:
                addError('Klient o podanym numerze jest już zarejestrowany w Portalu VB Leasing.', state);
                break;
            case 2014:
                addError('Podane hasło startowe nie jest takie samo, jak hasło startowe podane w pierwszym etapie rejestracji.', state);
                break;
            case 2015:
                addError('Klient o podanym numerze nie posiada dostępu do Portalu VB Leasing.', state);
                break;
            case 2021:
                addError('Klient o podanym numerze nie może zarejestrować się za pomocąszybkiej metody. Proszę użyć <a href="#/register/1">formularza rejestracyjnego</a>.', state);
                break;
            case 2023:
                addError('Podane hasło nie jest prawidłowe.', state);
                break;

                    //DATABASE
            case 301:
                addError('Błąd połączenia z bazą danych.', state);
                break;
            case 302:
                addError('Błędne zapytanie SQL.', state);
                break;

                    //AUTHENTICATION
            case 401:
                addError('Podane konto nie istnieje.', state);
                break;
            case 402:
                switch (detail) {
                    case 1:
                        addError('Podano nieprawidłowy login i/lub hasło.', state);
                        break;
                    case 2:
                        addError('Podano nieprawidłowe hasło. Kolejna błędna próba logowania spowoduje zablokowanie dostępu do Portalu VB Leasing na 15 minut. Jeśli nie pamiętasz hasła <a href="#/passwordReset">kliknij</a>.', state);
                        break;
                    case 3:
                    case 4:
                    case 5:
                        addError('Podano nieprawidłowe hasło. Konto zostało zablokowane na 15 minut.', state);
                        break;
                    default:
                        addError('Podano nieprawidłowy login i/lub hasło.', state);
                        break;
                    }
                break;
            case 403:
                addError('Twoje konto zostało zablokowane. Aby odzyskać dostęp do Portalu VB Leasing, prosimy o kontakt z naszym Działem Wsparcia Obsługi Klienta pod adresem: <a href="mailto:portal.klienta@vbl.pl">portal.klienta@vbl.pl</a>.', state);
                break;
            case 404:
                addError('Zbyt dużo prób logowania.', state);
                break;
            case 405:
                addError('Podany użytkownik jest już zalogowany.', state);
                break;
            case 407:
                addError('Podany użytkownik nie posiada aktywnego konta.', state);
                break;
            case 408:
                addError('Podany użytkownik nie ma dostępu do Portalu.', state);
                break;
            case 409:
                var remaining = Math.ceil((1000 /*ms*/ * 60 /*s*/ * 15 /*min*/ - detail) / 1000 /*ms*/ / 60 /*s*/ );
                addError('Konto będzie zablokowane przez: ' + remaining + ' minut(y). Przez ten czas nie jest możliwe zalogowanie się do Portalu VB Leasing.', state);
                break;
            case 4012:
                addError('Hasło do tego konta zostało zresetowane. Proszę sprawdzić swoją skrzynkę pocztową.', state);
                break;

            default:
                addError('Nieznany błąd.', state);
                break;
            }
        }

        function setAction(act) {
            clearAction();
            _action.push(act);
        }

        function clearAction() {
            _action.splice(0, _action.length);
        }

        function clear(state) {
            clearAction();
            //If the state has not been passed
            if (state == undefined)
            //Set it as current state
                state = $state.current.name;

            //If _errors for this state are undefined
            if (_errors[state] == undefined)
            //Initialize a new array
                _errors[state] = [];
            else
            //Clear the array
                _errors[state].splice(0, _errors[state].length);

            //If _statements for this state are undefined
            if (_statements[state] == undefined)
            //Initialize a new array
                _statements[state] = [];
            else
            //Clear the array
                _statements[state].splice(0, _statements[state].length);

            //If infos for this state are undefined
            if (_infos[state] == undefined)
            //Initialize a new array
                _infos[state] = [];
            else
            //Clear the array
                _infos[state].splice(0, _infos[state].length);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('UsersService', UsersService);

    UsersService.$inject = ['API_URL', '$http'];

    function UsersService(API_URL, $http) {

        return {
            'getUsers': function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/users',
                    params: params
                });
            },
            'getUser': function(user_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/users/' + user_id,
                });
            },
            'createUser': function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/users',
                    data: data
                });
            },
            'updateUser': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/users',
                    data: data
                });
            },
            'deleteUser': function(data) {
                return $http({
                    method: 'DELETE',
                    url: API_URL + 'api/users/' + data
                });
            },
            'getUserRoles': function(user_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/users/' + user_id + '/roles',
                });
            },
            'updateUserRoles': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/users/roles',
                    data: data
                });
            },
            'getUserPermissions': function(user_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/users/' + user_id + '/permissions',
                });
            },
            'getUserLogs': function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/users/logs',
                    params: params
                });
            },
            'registerUser': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register/user',
                    data: data
                });
            },
            unlockUser: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/users/unlock',
                    data: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('SettingsService', SettingsService);

    SettingsService.$inject = ['API_URL', '$http'];

    function SettingsService(API_URL, $http) {

        return {
            'changePassword': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password',
                    data: data
                });
            },
            'changeEmail': function(emailSet) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/settings'
                });
            },
            'activateEInvoice': function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/settings'
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('RolesService', RolesService);

    RolesService.$inject = ['API_URL', '$http'];

    function RolesService(API_URL, $http) {

        return {
            getRoles: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles'
                });
            },
            getRole: function(role_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/' + role_id,
                });
            },
            createRole: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/roles',
                    data: data
                });
            },
            updateRole: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/roles',
                    data: data
                });
            },
            deleteRole: function(data) {
                return $http({
                    method: 'DELETE',
                    url: API_URL + 'api/roles/' + data
                });
            },
            getRoleLogs: function(params) {
                 return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/logs',
                    params: params
                 });
            },
            getRolePermissions: function(role_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/' + role_id + '/permissions',
                });
            },
            updateRolePermissions: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/roles/permissions',
                    data: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('PermissionsService', PermissionsService);

    PermissionsService.$inject = ['API_URL', '$http'];

    function PermissionsService(API_URL, $http) {

        return {
            getPermissions: function(role_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/permissions',
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('DocumentsService', DocumentsService);

    DocumentsService.$inject = ['API_URL', '$http'];

    function DocumentsService(API_URL, $http) {

        return {
            getDocuments: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents',
                    params: filter
                });
            },
            getDocumentsPaged: function(filter, pageNum) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/page/' + pageNum,
                    params: filter
                });
            },
            getDocument: function(transaction_id, template, login) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/' + transaction_id + '/' + template + '/download',
                    params: {
                        login: login
                    },
                    responseType: 'arraybuffer'
                });
            },
            downloadMergedPDF: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/download',
                    params: filter,
                    responseType: 'arraybuffer'
                });
            },
            downloadMergedPDFPaged: function(filter, pageNum) {
                 return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/download/page/' + pageNum,
                    params: filter,
                    responseType: 'arraybuffer'
                 });
            },
            getXML: function(transaction_id, login) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/' + transaction_id + '/download',
                    params: {
                        login: login
                    },
                    responseType: 'arraybuffer'
                });
            },
            getExcelSpreadsheet: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/excel',
                    params: filter,
                    responseType: 'arraybuffer'
                });
            },
            getExcelSpreadsheetPaged: function(filter, pageNum) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/excel/page/' + pageNum,
                    params: filter,
                    responseType: 'arraybuffer'
                });
            },
            getDocumentTypes: function(login) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/types?login=' + encodeURIComponent(login)
                });
            },
            getAdditionalInfo: function(login) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/documents/additionalInfo?login=' + encodeURIComponent(login)
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('CommuniqueService', CommuniqueService);

    CommuniqueService.$inject = ['API_URL', '$http'];

    function CommuniqueService(API_URL, $http) {

        return {
            getRoles: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles'
                });
            },
            getRole: function(role_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/' + role_id,
                });
            },
            createRole: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/roles',
                    data: data
                });
            },
            updateRole: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/roles',
                    data: data
                });
            },
            deleteRole: function(data) {
                return $http({
                    method: 'DELETE',
                    url: API_URL + 'api/roles/' + data
                });
            },
            getRoleLogs: function(params) {
                 return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/logs',
                    params: params
                 });
            },
            getRolePermissions: function(role_id) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/roles/' + role_id + '/permissions',
                });
            },
            updateRolePermissions: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/roles/permissions',
                    data: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('ClientsService', ClientsService);

    ClientsService.$inject = ['API_URL', '$http'];

    function ClientsService(API_URL, $http) {

        return {
            getClient: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/clients/',
                    params: filter
                });
            },
            getClients: function(filter, page) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/clients/' + page,
                    params: filter
                });
            },
            getClientLogs: function(filter) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/clients/logs',
                    params: filter
                });
            },
            unlockClient: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/clients/unlock',
                    data: data
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('AgreementsService', AgreementsService);

    AgreementsService.$inject = ['API_URL', '$http'];

    function AgreementsService(API_URL, $http) {

        return {
            getAgreements: function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/agreements',
                    params: params
                });
            }
        };
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('AccountService', AccountService);

    AccountService.$inject = ['API_URL', '$http'];

    function AccountService(API_URL, $http) {

        return {
            getAccount: function() {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account'
                });
            },
            /*REGISTRATION*/
            'getRegistration': function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/register',
                    params: params
                });
            },
            'getRegistrationForUser': function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/register/user',
                    params: params
                });
            },
            'createRegistration': function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/register',
                    data: data
                });
            },
            activateRegistration: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/register',
                    data: data
                });
            },
            /*PASSWORD*/
            changePassword: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password',
                    data: data
                });
            },
            changeExpiredPassword: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password/expired',
                    data: data
                });
            },
            resetPassword: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/password/reset',
                    data: data
                });
            },
            /*EMAIL*/
            changeEmail: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/email',
                    data: data
                });
            },
            /*EMAIL BY ADMIN*/
            changeEmailByAdmin: function(data) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/emailByAdmin',
                    data: data
                });
            },
            /*EINVOICE*/
            activateEInvoice: function() {
                return $http({
                    method: 'POST',
                    url: API_URL + 'api/account/einvoice'
                });
            },
            /*PASSWORD INTERVAL*/
            getUserPasswordInterval: function() {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/userPasswordInterval'
                });
            },
            changeUserPasswordInterval: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/userPasswordInterval',
                    data: data
                });
            },
            /*CLIENT PASSWORD INTERVAL*/
            getClientPasswordInterval: function() {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/clientPasswordInterval'
                });
            },
            changeClientPasswordInterval: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/clientPasswordInterval',
                    data: data
                });
            },
            /*CHANGE*/
            getChange: function(params) {
                return $http({
                    method: 'GET',
                    url: API_URL + 'api/account/change',
                    params: params
                });
            },
            applyChange: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/change',
                    data: data
                });
            },
            acceptAgreements: function(data) {
                return $http({
                    method: 'PUT',
                    url: API_URL + 'api/account/agreements/accept',
                    data: data
                });
            }
        };
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            getIdentity: getIdentity,
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            hasRoles: hasRoles,
            hasPermissions: hasPermissions,
            getProperty: getProperty,
            isClient: isClient,
            setProperty: setProperty,
            getLogin: getLogin,
            isEInvoice: isEInvoice,
            getLastLoginDate: getLastLoginDate,
            updateLastAccessedTime: updateLastAccessedTime
        };

        return service;

        function getIdentity() {
            return _identity;
        }

        function getLogin() {
            if (_identity !== undefined) {
                return _identity.login;
            }
        }

        function isEInvoice() {
            if (_identity !== undefined) {
                return _identity.e_invoice;
            }
        }

        function getLastLoginDate() {
            if (_identity !== undefined) {
                return _identity.lastLoginDate;
            }
        }

        function isClient() {
            return service.hasAuthority('ROLE_CLIENT');
        }

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function() {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            /*if (force === true) {
                _identity = null;
                _authenticated = false;
            }*/
            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (force !== true && _identity != null && _identity != undefined) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = account.data ? true : false;
                updateLastAccessedTime();
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function hasRoles(roles) {
            if (!_authenticated || !_identity || !_identity.roles) {
                return false;
            }

            if (!roles) {
                return true;
            }

            for (var i = 0; i < roles.length; i++) {
                if (_identity.roles.indexOf(roles[i]) == -1) {
                    return false;
                }
            }
            return true;
        }

        function hasPermissions(permissions) {
            if (!_authenticated || !_identity || !_identity.permissions) {
                return false;
            }

            if (!permissions) {
                return true;
            }

            for (var i = 0; i < permissions.length; i++) {
                if (_identity.permissions.indexOf(permissions[i]) == -1) {
                    return false;
                }
            }
            return true;
        }

        function getProperty(property) {
            if (!property || !_identity) {
                return null;
            }
            return _identity[property];
        }

        function setProperty(property, value) {
            if (_identity)
                _identity[property] = value;
        }

        function updateLastAccessedTime() {
            setProperty('sessionLastAccess', new Date().getTime());
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'API_URL'];

    function AuthServerProvider($http, $localStorage, API_URL) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken() {
            var token = this.getToken();
            return !!token;
        }

        function login(credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.login) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post(API_URL + 'api/login', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                timeout: 0
            }).success(function(response) {
                return response;
            });
        }

        function logout() {
            // logout from the server
            return $http.post(API_URL + 'api/logout').success(function(response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get(API_URL + 'api/welcome'); //Change to 'api/account' if needed
                return response;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider'];

    function Auth($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider) {
        var service = {
            authorize: authorize,
            login: login,
            logout: logout
        };

        return service;

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();
                return;
                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        //$state.go('403');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $sessionStorage.previousStateName = $rootScope.toState.name;
                        $sessionStorage.previousStateParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('401');
                    }
                }
            }
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout() {
            return AuthServerProvider.logout()
                .then(function() {
                    Principal.authenticate(null);

                    // Reset state memory
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    delete $rootScope.afterAuth;
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Account', Account);

    Account.$inject = ['$resource', 'API_URL'];

    function Account($resource, API_URL) {
        var service = $resource(API_URL + 'api/account', {}, {
            'get': {
                method: 'GET',
                params: {},
                isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$state', '$scope', 'Auth', 'Principal'];

    function SidebarController($state, $scope, Auth, Principal) {
        var vm = this;

        //Declare functions
        vm.logout = logout;

        function logout() {
            //Logout through HTTP request
            Auth.logout().then(function() {
                //Go to login view
                $state.go('login');
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('ShellService', ShellService);
	    ShellService.$inject = ['API_URL','$http'];


    function ShellService (API_URL, $http) {
		        return {
			    'logout': function(){
				    return $http({
				      method: 'POST',
				      url: API_URL + 'api/auth/logout'
				});
			},
	communique1: function (line1) {
             return $http({
                    method: 'GET',
                    url: API_URL + '/api/communique/communique1/'+ line1
             });
	         },
	communique2: function (line1) {
             return $http({
                    method: 'GET',
                    url: API_URL + '/api/communique/communique2/'+ line1
             });
	         },
    dateStart: function () {
             return $http({
             method: 'GET',
             url: API_URL + '/api/communique/date1'
             });
             },
    dateEnd: function () {
             return $http({
             method: 'GET',
             url: API_URL + '/api/communique/date2'
             });
             },
    getLine1: function(data) {
             return $http({
             method: 'POST',
             url: API_URL + 'api/communique/update',
             data: data
             });
             }
    };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('ShellController', ShellController);

    ShellController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', 'ShellService', 'Info'];

    function ShellController($rootScope, $scope, $state, Auth, Principal, ShellService, Info) {
        var vm = this;

        //Declare function
        vm.toggleSidebar = toggleSidebar;
        vm.showSidebar = showSidebar;
        vm.hideSidebar = hideSidebar;
        vm.logout = logout;
        vm.name = Principal.getProperty('displayName').indexOf('|') != -1 ?
            Principal.getProperty('displayName').slice(0, Principal.getProperty('displayName').indexOf('|')) :
            Principal.getProperty('displayName');

        function showSidebar() {
            var toggle = $('.navbar-toggle');
            setTimeout(function() {
                toggle.addClass('toggled');
            }, 430);

            $('html').addClass('nav-open');
        }

        function hideSidebar(hideAnimation) {
            var toggle = $('.navbar-toggle');
            if (hideAnimation)
                $('html').css("transition", "none");
            $('html').removeClass('nav-open');
            setTimeout(function() {
                toggle.removeClass('toggled');
                $('html').css("transition", "all 0.3s ease-in-out");
            }, 430);
        }

        function toggleSidebar() {
            var navbar = $('.navbar-collapse');
            if ($rootScope.sidebar == undefined) {
                $rootScope.sidebar = true;
            } else {
                navbar.css('min-height', window.screen.height);
                $rootScope.sidebar = !$rootScope.sidebar;
            }

            if ($rootScope.sidebar) {
                showSidebar();
            } else {
                hideSidebar();
            }
        }

        function logout() {
            Info.setAction('Wylogowywanie...');
            //Logout through HTTP request
            Auth.logout().finally(function() {
                //Go to login view
                $state.go('login');
                $("[role='tooltip']").remove(); //Remove tooltips
                Info.clearAction();
            });
        }

        function showTimeout(withSeconds) {
            var timeoutIndicator = $('#sessionTimeout');
            var timeout, minutes, seconds;
            return setInterval(function() {
                timeout = Principal.getProperty('sessionLastAccess') + Principal.getProperty('sessionLength') - new Date().getTime();
                if (timeout < 0) {
                    logout();
                } else if (withSeconds) {
                    minutes = Math.floor(timeout / 60000);
                    seconds = Math.floor((timeout - minutes * 60000) / 1000);
                    timeoutIndicator.text(minutes + (seconds < 10 ? ":0" + seconds : ":" + seconds));
                } else {
                    minutes = Math.ceil(timeout / 60000);
                    timeoutIndicator.text(minutes + " min");
                }

            }, 1000);
        }

        function getCommunique() {
             var communiqueln1 = $('#communiqueln1');
             var communiqueln2 = $('#communiqueln2');

            ShellService.communique1("a").then(function(response){
              communiqueln1.text(response.data.result);
            }).catch(function(response){
            communiqueln1.text("error");
            });

            ShellService.communique2("a").then(function(response){
              communiqueln2.text(response.data.result);
            }).catch(function(response){
            communiqueln2.text("error");
            });
            }


        getCommunique();
        var timer = showTimeout(true);

        $scope.$on("$destroy", function() {
            if (timer) {
                clearInterval(timer);
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('tooltip', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    element.attr('data-html', true);
                    $(element).hover(function() {
                        // on mouseenter
                        $(element).tooltip('show');
                    }, function() {
                        // on mouseleave
                        $(element).tooltip('hide');
                    });
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('subjects', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var subjects = scope.agreement.subjects;
                    var tooltip = "<div style='text-align:left;'>";
                    for (var subject in subjects) {
                        tooltip += '<li style="font-size:10pt;font-weight:normal;margin:5px;">' + subjects[subject] + '</li>';
                    }
                    tooltip += "</div>";

                    element.tooltip({
                        placement: function() {
                            if (window.innerHeight / 2 - $(element)[0].getBoundingClientRect().top > 0)
                                return 'bottom';
                            else
                                return 'top';
                        },
                        html: true,
                        title: tooltip,
                        container: 'body'
                    });

                    $(element).hover(function() {
                        $(this).tooltip('show');
                    },
                        function() {

                            $(this).tooltip('hide');
                        });
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('edistradaIdealeasingPortalApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';
	
    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('invalid', function(){
			
			            return {
				    restrict: 'A',
				    link: function(scope, element, attrs){
					    $(element).change(function(){
						    if(!this.classList.contains("ng-invalid")){
							    $(element).tooltip('hide');
						}else{
							    $(element).tooltip('show');
						}			
					});
				}
			};
		        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('equals', function() {

            return {
                require: 'ngModel',
                restrict: 'A',
                link: function(scope, element, attrs, ctrl) {
                    element.change(jQuery.proxy(function(scope) {
                        var toEqual = this.attr('equals');
                        var value = this.val();
                        var message = this.attr('data-equals-message');
                        //Two values do not match
                        if (toEqual != value) {
                            var tooltip = '<p style="font-size:10pt;font-weight:normal;margin:0px;">' + message + '</p>';
                            this.attr('data-original-title', tooltip);
                            this.tooltip('fixTitle');
                            this.tooltip('show');
                            this[0].classList.add('ng-invalid');
                        } else {
                            this.tooltip('hide');
                        }
                    }, element));
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('document', function() {
            return {
                restrict: 'E,A',
                templateUrl: 'app/components/util/document.html',
                link: function(scope, element, attrs) {
                    var document = scope.document;

                    document.netto = [];
                    document.vat = [];
                    document.brutto = [];
                    if (document.netto != null) {
                        put(document.total_netto, document.currency, document.netto);
                    }
                    if (document.currency_vat == null) {
                        put(document.total_brutto, document.currency, document.brutto);
                        if (document.total_vat != 0)
                            put(document.total_vat, document.currency, document.vat);
                    } else {
                        put(document.total_netto, document.currency, document.brutto);
                        if (document.total_vat != 0) {
                            put(document.total_vat, document.currency_vat, document.vat);
                            put(document.total_vat, document.currency_vat, document.brutto);
                        }
                    }

                    function put(value, currency, dest) {
                        if (value != null) {
                            dest.push(scope.vm.getValue(value) + " " + currency);
                        }
                    }
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertDateFromServer: convertDateFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date).toLocaleString();
            } else {
                return null;
            }
        }

        function convertDateFromServer(date) {
            if (date) {
                return new Date(date).toLocaleDateString();
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                return input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return "";
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';
	
    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('principalRoles', ['Principal', function(Principal) {

			              return function(scope, element, attrs) {
				    var roles  = attrs.principalRoles.split(",");
				    if(!Principal.hasRoles(roles))
					    element.hide();
			};
		        }]);
})();
;
(function() {
    'use strict';
	
    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('principalProperty', ['Principal', function(Principal) {
			
			            return {
				    restrict: "A",
				    link: function(scope, element, attrs) {
					    var property  = attrs.principalProperty;
					    element.text(Principal.getProperty(property));
				}
			};
		        }]);
})();
;
(function() {
    'use strict';
	
    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('principalPermissions', ['Principal', function(Principal) {

			              return function(scope, element, attrs) {
				    var permissions  = attrs.principalPermissions.split(",");
				    if(!Principal.hasPermissions(permissions))
					    element.hide();
			};
		        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .controller('LoginOldController', LoginOldController);

    LoginOldController.$inject = ['$rootScope', '$state', '$sessionStorage', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginOldController ($rootScope, $state, $sessionStorage, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if ($sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('phone', ['Principal', function(Principal) {

            return {
                restrict: 'E',
                replace: 'true',
                template: "<input type='email' class='form-control' data-html='true' data-trigger='manual'>",
                link: function(scope, element, attrs) {

                    function isValid(elem) {
                        if (elem.hasClass('ng-valid') && !elem.hasClass('ng-invalid'))
                            return true;
                        else
                            return false;
                    }

                    function makeInvalid(elem) {
                        addClass(elem, 'ng-invalid');
                        removeClass(elem, 'ng-valid');
                    }

                    function makeValid(elem) {
                        removeClass(elem, 'ng-invalid');
                        addClass(elem, 'ng-valid');
                    }

                    function addClass(elem, cls) {
                        if (!elem.hasClass(cls))
                            elem.addClass(cls);
                    }

                    function removeClass(elem, cls) {
                        if (elem.hasClass(cls))
                            elem.removeClass(cls);
                    }

                    //On each key up
                    $(element).keyup(jQuery.proxy(function(scope) {
                        console.log('KEYUP');
                        var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]{1}[a-zA-Z]{2,}$/;
                        //VALIDATE
                        //If email field is probably valid, but should not be identical to current email
                        if (this.attr('data-new-email') != undefined && Principal.getProperty('email') == this.val()) {
                            makeInvalid(this);
                            addClass(this, 'ng-invalid-new');
                        } else {
                            removeClass(this, 'ng-invalid-new');
                        }
                        //If repeat email field is probably valid, but should be identical to new email
                        if (this.attr('data-repeat-email') != undefined && $("input[data-new-email]").val() != this.val()) {
                            makeInvalid(this);
                            addClass(this, 'ng-invalid-repeat');
                        } else {
                            removeClass(this, 'ng-invalid-repeat');
                        }
                        //If repeat email field is probably valid, but should be identical to new email
                        if (!pattern.test(this.val())) {
                            makeInvalid(this);
                            addClass(this, 'ng-invalid-pattern');
                        } else {
                            removeClass(this, 'ng-invalid-pattern');
                        }
                        //If repeat email field is probably valid, but should be identical to new email
                        if (this.val().length > 256) {
                            makeInvalid(this);
                            addClass(this, 'ng-invalid-maxlength');
                        } else {
                            removeClass(this, 'ng-invalid-maxlength');
                        }

                    }, element));
                    //On change
                    $(element).change(jQuery.proxy(function() {
                        console.log('CHANGE');
                        $(element).trigger('keyup');
                        //COSTRUCT TOOLTIP BASED ON VALIDATION
                        var tooltip = "";
                        //If the email field is invalid
                        if (!isValid(this)) {
                            var invalid = false;
                            //If it does not match email pattern
                            if (this.hasClass('ng-invalid-pattern')) {
                                invalid = true;
                                tooltip += '<p style="font-size:10pt;font-weight:normal;margin:0px;">Wprowadź poprawny adres e-mail.</p>';
                            }
                            //If it is too long
                            if (this.hasClass('ng-invalid-maxlength')) {
                                invalid = true;
                                tooltip += '<p style="font-size:10pt;font-weight:normal;margin:0px;">Adres e-mail może zawierać maksymalnie 256 znaków.</p>';
                            }
                            //If repeat is invalid
                            if (this.hasClass('ng-invalid-new')) {
                                invalid = true;
                                tooltip += '<p style="font-size:10pt;font-weight:normal;margin:0px;">Nowy adres e-mail jest identyczny jak dotychczasowy.</p>';
                            }
                            //If repeat is invalid
                            if (this.hasClass('ng-invalid-repeat')) {
                                invalid = true;
                                tooltip += '<p style="font-size:10pt;font-weight:normal;margin:0px;">Podane adresy e-mail nie są identyczne.</p>';
                            }

                            //If is not invalid
                            if (!invalid) {
                                this.attr('data-original-title', '');
                                this.tooltip('fixTitle').tooltip('hide');
                                makeValid(this);
                            } //If is invalid and current tooltip is different than generated tooltip - avoid flickering
                            else if (this.attr('data-original-title') != tooltip) {
                                //Swap and show it
                                this.attr('data-original-title', tooltip);
                                this.tooltip('fixTitle').tooltip('show');
                                makeInvalid(this);
                            }
                        } //If is valid
                        else {
                            this.attr('data-original-title', '');
                            this.tooltip('fixTitle').tooltip('hide');
                            makeValid(this);
                        }
                    }, element));
                    $(element).blur(jQuery.proxy(function() {
                        console.log('BLUR');
                        this.trigger('change');
                    }, element));
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('patternTooltip', ['Principal', function(Principal) {

            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    //Add usage of HTML tags in a tooltip
                    $(element).attr('data-html', true);
                    //Make tooltip appear on demand, rather than on hover
                    $(element).attr('data-trigger', 'focus');

                    //On each keyup
                    $(element).keyup(jQuery.proxy(function(scope) {
                        var tooltip = '';
                        //VALIDATE
                        //If input did not match the pattern
                        if (this.hasClass('ng-invalid-pattern')) {
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>" + this.attr('data-pattern-tooltip') + '</p>';
                        }

                        //SHOW AND HIDE TOOLTIP AUTOMATICALLY ON VALIDITY CHANGE
                        if (this.attr('data-original-title') != tooltip) {
                            //Change title
                            this.attr('data-original-title', tooltip);
                            this.tooltip('fixTitle');
                            //If title is blank then hide tooltip and make field valid
                            if (tooltip == '') {
                                this.tooltip('hide');
                                //Else show tooltip with new title
                            } else if ($(this)[0] === document.activeElement) {
                                this.tooltip('show');
                            }
                        }
                    }, element));

                    //On change
                    $(element).change(jQuery.proxy(function() {
                        this.trigger('keyup');
                    }, element));

                    //On lose focus
                    $(element).blur(jQuery.proxy(function() {
                        this.trigger('keyup');
                    }, element));
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('pass', ['Utils', function(Utils) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='password' title='' autocomplete='new-password' data-toggle='tooltip' data-trigger='focus' data-html='true'>",
                link: function(scope, element, attributes, control) {

                    //Validate minimum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = 256;
                        if (!Utils.isEmpty($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    //Validate password
                    control.$validators.password = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /(?=.*[~`!@#$%^&*()_+-={}\[\]|:";'<>?,\\/.0-9]+.*)(?=.*[a-z]+.*)(?=.*[A-Z]+.*)[0-9a-zA-Z~`!@#$%^&*()_+-={}\[\]|:";'<>?,\\/.]{8,}/.test(value));
                    }, element);

                    if (element.attr('data-old-password') != undefined) {
                        //Validate old password
                        control.$validators.oldPassword = jQuery.proxy(function(value) {
                            angular.element('input[data-new-password]').data('$ngModelController').$validate();
                            angular.element('input[data-new-password]').trigger('change');
                            return true;
                        }, element);
                    }

                    if (element.attr('data-new-password') != undefined) {
                        //Validate new password
                        control.$validators.newPassword = jQuery.proxy(function(value) {
                            angular.element('input[data-repeat-password]').data('$ngModelController').$validate();
                            angular.element('input[data-repeat-password]').trigger('change');
                            return (control.$isEmpty(value) || $('input[data-old-password]').val() != value);
                        }, element);
                    }

                    if (element.attr('data-repeat-password') != undefined) {
                        //Validate repeat password
                        control.$validators.repeatPassword = jQuery.proxy(function(value) {
                            return (control.$isEmpty(value) || $('input[data-new-password]').val() == value);
                        }, element);
                    }

                    //Live validation tooltip
                    $(element).on('keyup change', function(event) {
                        var tooltip = '';
                        if (control.$error.max)
                            tooltip += "<p>Hasło może zawierać maksymalnie " + ($(this).attr('data-max') || 256) + " znaków..</p>";
                        if (control.$error.password)
                            tooltip += "<p>Hasło powinno zawierać przynajmniej 8 znaków, w tym przynajmniej jedną małą i wielką literę oraz cyfrę lub znak specjalny.</p>";
                        if (control.$error.newPassword)
                            tooltip += "<p>Nowe hasło jest identyczne jak dotychczasowe.</p>";
                        if (control.$error.repeatPassword)
                            tooltip += "<p>Podane nowe hasła nie są identyczne.</p>";

                        if (control.$valid || this.classList.contains('ng-empty')) {
                            $(this).attr('data-original-title', tooltip);
                            $(this).tooltip('hide');
                        } else if (tooltip != $(this).attr('data-original-title')) {
                            $(this).attr('data-original-title', tooltip);
                            if ($(this)[0] == document.activeElement)
                                $(this).tooltip('show');
                        }
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('email', ['Utils', function(Utils) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' title='' data-toggle='tooltip' data-trigger='focus' data-html='true'>",
                link: function(scope, element, attributes, control) {

                    //Validate minimum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = 256;
                        if (!Utils.isEmpty($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    //Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);


                    if (element.attr('data-old-email') != undefined) {
                        //Validate old email
                        control.$validators.oldEmail = jQuery.proxy(function(value) {
                            angular.element('input[data-new-email]').data('$ngModelController').$validate();
                            angular.element('input[data-new-email]').trigger('change');
                            return true;
                        }, element);
                    }

                    if (element.attr('data-new-email') != undefined) {
                        //Validate new email
                        control.$validators.newEmail = jQuery.proxy(function(value) {
                            angular.element('input[data-repeat-email]').data('$ngModelController').$validate();
                            angular.element('input[data-repeat-email]').trigger('change');
                            return (control.$isEmpty(value) || $('input[data-old-email]').val() != value);
                        }, element);
                    }

                    if (element.attr('data-repeat-email') != undefined) {
                        //Validate repeat email
                        control.$validators.repeatEmail = jQuery.proxy(function(value) {
                            return (control.$isEmpty(value) || $('input[data-new-email]').val() == value);
                        }, element);
                    }

                    //Live validation tooltip
                    $(element).on('keyup change', function(event) {
                        var tooltip = '';
                        if (control.$error.max)
                            tooltip += "<p>Adres e-mail może zawierać maksymalnie " + ($(this).attr('data-max') || 256) + " znaków..</p>";
                        if (control.$error.email)
                            tooltip += "<p>Wprowadź poprawny adres e-mail.</p>";
                        if (control.$error.newEmail)
                            tooltip += "<p>Nowy adres e-mail jest identyczny jak dotychczasowy.</p>";
                        if (control.$error.repeatEmail)
                            tooltip += "<p>Podane adresy e-mail nie są identyczne.</p>";

                        if (control.$valid || this.classList.contains('ng-empty')) {
                            $(this).attr('data-original-title', tooltip);
                            $(this).tooltip('hide');
                        } else if (tooltip != $(this).attr('data-original-title')) {
                            $(this).attr('data-original-title', tooltip);
                            if ($(this)[0] == document.activeElement)
                                $(this).tooltip('show');
                        }
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('datepicker', ['Utils', function(Utils) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: true,
                template: "<input type='text' title='' data-toggle='tooltip' data-trigger='focus' data-html='true' data-container='body'>",
                link: function(scope, element, attributes, control) {

                    //MODEL -> VIEW
                    control.$formatters.push(function(value) {
                        var newValue = parseInt(value);
                        if (Utils.isEmpty(newValue)) {
                            console.log("Empty :(");
                            return '';
                        }
                        return Utils.getDate(newValue);
                    });

                    //VIEW -> MODEL
                    control.$parsers.push(jQuery.proxy(function(value) {
                        var newValue = value;
                        if (Utils.isNotDate(newValue))
                            return null;
                        var result = new Date(0);
                        result.setSeconds(0);
                        result.setMinutes(0);
                        result.setHours(0);
                        result.setDate(newValue.split('.')[0]);
                        result.setMonth(newValue.split('.')[1] - 1);
                        result.setYear(newValue.split('.')[2]);
                        //If this date is 'to' date then include the whole day
                        if (this.attr('name') == 'to')
                            result = result.getTime() + (1000 /*ms*/ * 60 /*s*/ * 60 /*min*/ * 24 /*h*/ ) - 1 /*do not include next day*/ ;
                        else
                            result = result.getTime();
                        return result;
                    }, element));

                    //Validate minimum
                    control.$validators.min = jQuery.proxy(function(value) {
                        var minimum = 0;
                        if (!Utils.isNotAmount($(this).attr('data-min')))
                            minimum = $(this).attr('data-min');
                        return (control.$isEmpty(value) || (value >= minimum));
                    }, element);

                    //Validate maximum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = new Date();
                        maximum.setSeconds(0);
                        maximum.setMinutes(0);
                        maximum.setHours(0);
                        maximum = new Date(maximum.getTime() + (1000 /*ms*/ * 60 /*s*/ * 60 /*min*/ * 24 /*h*/ ) - 1 /*do not include next day*/ );
                        if (!Utils.isNotAmount($(this).attr('data-max')))
                            maximum = new Date(parseInt($(this).attr('data-max')));
                        else if ($(this).attr('max-constraint') == "false")
                            maximum.setFullYear(maximum.getFullYear() + 7);
                        return (control.$isEmpty(value) || (value <= maximum.getTime()));
                    }, element);

                    //Validate date format
                    control.$validators.date = jQuery.proxy(function(value) {
                        return (Utils.isEmpty(control.$viewValue) || !Utils.isEmpty(value));
                    }, element);

                    //Live validation tooltip
                    $(element).on('keyup change', function(event) {
                        var tooltip = '';
                        if (control.$error.min)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj datę późniejszą niż " + new Date(parseInt($(this).attr('data-min')) || 0).toLocaleDateString() + ".</p>";
                        if (control.$error.max)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj datę wcześniejszą niż " + new Date(parseInt($(this).attr('data-max')) || new Date().getTime()).toLocaleDateString() + ".</p>";
                        if (control.$error.date)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj prawidłową datę, np.: 02.02.2016</p>";

                        if (control.$valid) {
                            $(this).attr('data-original-title', tooltip);
                            $(this).tooltip('hide');
                        } else if (tooltip != $(this).attr('data-original-title')) {
                            $(this).attr('data-original-title', tooltip);
                            if ($(this)[0] == document.activeElement)
                                $(this).tooltip('show');
                        }
                    });

                    //Datepicker
                    $(element).datepicker({
                        autoclose: true,
                        maxViewMode: 2,
                        daysOfWeekHighlighted: [0, 6],
                        clearBtn: true,
                        language: "pl",
                        startDate: '-7y',
                        endDate: $(element).attr('max-constraint') == "false" ? '+7y' : '0d',
                        weekStart: 1,
                        todayHighlight: true,
                        format: 'dd.mm.yyyy'
                    });

                    //Hide datepicker on enter
                    $(element).datepicker().on('keydown', function(e) {
                        if (e.which == 13) $(this).datepicker('hide');
                    });

                    var family = $(element).attr('family');

                    if ($(element).attr('name') == "from") {
                        $(element).datepicker()
                            .on('changeDate clearDate', function() {
                                if ($(this).datepicker('getDate') != null)
                                    $("input.date-picker[name='to'][family=" + family + "]").datepicker('setStartDate', $(this).datepicker('getDate'));
                                else
                                    $("input.date-picker[name='to'][family=" + family + "]").datepicker('setStartDate', '-7y');
                            });
                    } else if ($(element).attr('name') == "to") {
                        $(element).datepicker()
                            .on('changeDate clearDate', function() {
                                var familyElements = $("input.date-picker[name='from'][family=" + family + "]");

                                $.each(familyElements, function(index, elem) {
                                    if ($(element).datepicker('getDate') != null)
                                        $(elem).datepicker('setEndDate', $(element).datepicker('getDate'));
                                    else
                                        $(elem).datepicker('setEndDate', elem.attributes["max-constraint"] && elem.attributes["max-constraint"].nodeValue == "false" ? '+7y' : '0d');
                                });

                            });
                    }
                }
            };
        }]);

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('amount', ['Utils', function(Utils) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: true,
                template: "<input type='text' title='' data-toggle='tooltip' data-trigger='focus' data-html='true'>",
                link: function(scope, element, attributes, control) {

                    //MODEL -> VIEW
                    control.$formatters.push(function(value) {
                        if (Utils.isNotAmount(value))
                            return null;
                        return value.toString().replace('.', ',');
                    });

                    //VIEW -> MODEL
                    control.$parsers.push(function(value) {
                        if (Utils.isNotAmount(value))
                            return value;
                        return parseFloat(value.replace(',', '.'));
                    });

                    //Validate minimum
                    control.$validators.min = jQuery.proxy(function(value) {
                        var minimum = null;
                        if (!Utils.isNotAmount($(this).attr('data-min')))
                            return (control.$isEmpty(value) || (value >= $(this).attr('data-min')));
                        else
                            return true;
                    }, element);

                    //Validate maximum
                    control.$validators.max = jQuery.proxy(function(value) {
                        if (!Utils.isNotAmount($(this).attr('data-max')))
                            return (control.$isEmpty(value) || (value <= $(this).attr('data-max')));
                        else
                            return true;
                    }, element);

                    //Validate amount
                    control.$validators.amount = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[+-]?\d+([,.]\d{1,2})?$/.test(value.toString()));
                    }, element);

                    //Live validation tooltip
                    $(element).on('keyup change', function(event) {
                        var tooltip = '';
                        if (control.$error.min)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj liczbę większą lub równą " + $(this).attr('data-min') + ".</p>";
                        if (control.$error.max)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj liczbę mniejszą lub równą " + $(this).attr('data-max') + ".</p>";
                        if (control.$error.amount)
                            tooltip += "<p style='font-size:10pt;font-weight:normal;margin:0px;'>Podaj prawidłową kwotę netto, np.: '12,22'.</p>";

                        if (control.$valid) {
                            $(this).attr('data-original-title', tooltip);
                            $(this).tooltip('hide');
                        } else if (tooltip != $(this).attr('data-original-title')) {
                            $(this).attr('data-original-title', tooltip);
                            if ($(this)[0] == document.activeElement)
                                $(this).tooltip('show');
                        }
                    });
                }
            };
        }]);

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(paginationConfig);

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(pagerConfig);

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive("confirm", function($document, $parse) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var buttonId, html, message, nope, title, yep;

                    buttonId = Math.floor(Math.random() * 10000000000);

                    attrs.buttonId = buttonId;

                    message = attrs.message || "Czy jesteś pewien?";
                    yep = attrs.yes || "Tak";
                    nope = attrs.no || "Nie";
                    title = attrs.title || "Potwierdź";

                    html = "<div id=\"button-" + buttonId + "\" style='text-align: center'>\n  <span class=\"confirmbutton-msg\">" + message + "</span><br/>\n    <button class=\"confirmbutton-yes btn btn-primary btn-fill btn-round\" style='min-width: 40px'>" + yep + "</button>\n   <button class=\"confirmbutton-no btn btn-primary btn-round\" style='min-width: 40px'>" + nope + "</button>\n</div>";

                    element.popover({
                        content: html,
                        html: true,
                        trigger: "manual",
                        title: title
                    });

                    return element.bind('click', function(e) {
                        var dontBubble, pop;
                        dontBubble = true;

                        e.stopPropagation();

                        element.popover('show');

                        pop = $("#button-" + buttonId);

                        pop.closest(".popover").click(function(e) {
                            if (dontBubble) {
                                e.stopPropagation();
                            }
                        });

                        pop.find('.confirmbutton-yes').click(function(e) {
                            dontBubble = false;

                            var func = $parse(attrs.confirm);
                            func(scope);
                        });

                        pop.find('.confirmbutton-no').click(function(e) {
                            dontBubble = false;

                            $document.off('click.confirmbutton.' + buttonId);

                            element.popover('hide');
                        });

                        $document.on('click.confirmbutton.' + buttonId, ":not(.popover, .popover *)", function() {
                            $document.off('click.confirmbutton.' + buttonId);
                            element.popover('hide');
                        });
                    });
                }
            };
        });
})();
;
(function() {
    //copyright JGA 2013 under MIT License
    var monster = {
        set: function(e, t, n, r) {
            var i = new Date,
                s = "",
                o = typeof t,
                u = "";
            r = r || "/", n && (i.setTime(i.getTime() + n * 24 * 60 * 60 * 1e3), s = "; expires=" + i.toGMTString());
            if (o === "object" && o !== "undefined") {
                if (!("JSON" in window)) throw "Bummer, your browser doesn't support JSON parsing.";
                u = JSON.stringify({ v: t });
            } else u = escape(t);
            document.cookie = e + "=" + u + s + "; path=" + r;
        },
        get: function(e) {
            var t = e + "=",
                n = document.cookie.split(";"),
                r = "",
                i = "",
                s = {};
            for (var o = 0; o < n.length; o++) {
                var u = n[o];
                while (u.charAt(0) == " ") u = u.substring(1, u.length);
                if (u.indexOf(t) === 0) {
                    r = u.substring(t.length, u.length), i = r.substring(0, 1);
                    if (i == "{") {
                        s = JSON.parse(r);
                        if ("v" in s) return s.v;
                    }
                    return r == "undefined" ? undefined : unescape(r);
                }
            }
            return null;
        },
        remove: function(e) { this.set(e, "", -1); },
        increment: function(e, t) {
            var n = this.get(e) || 0;
            this.set(e, parseInt(n, 10) + 1, t);
        },
        decrement: function(e, t) {
            var n = this.get(e) || 0;
            this.set(e, parseInt(n, 10) - 1, t);
        }
    };

    if (monster.get('cookieinfo') === 'true') {
        return false;
    }

    var container = document.createElement('div'),
        link = document.createElement('a');

    container.setAttribute('id', 'cookieinfo');
    container.setAttribute('class', 'cookie-alert');
    container.innerHTML = '<h6>Ta strona wykorzystuje pliki cookie</h6><p>Używamy informacji zapisanych za pomocą plików cookies w celu zapewnienia maksymalnej wygody w korzystaniu z Portalu VB Leasing. Jeżeli wyrażasz zgodę na zapisywanie informacji zawartej w cookies kliknij na &bdquo;x&rdquo; w prawym górnym rogu tej informacji. Jeśli nie wyrażasz zgody, ustawienia dotyczące plików cookies możesz zmienić w swojej przeglądarce.</p>';

    link.setAttribute('href', '#');
    link.classList.add('glyphicon');
    link.classList.add('glyphicon-remove');
    link.setAttribute('title', 'Zamknij');

    function clickHandler(e) {
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            e.returnValue = false;
        }

        container.setAttribute('style', 'opacity: 1');

        var interval = window.setInterval(function() {
            container.style.opacity -= 0.01;

            if (container.style.opacity <= 0.02) {
                document.body.removeChild(container);
                window.clearInterval(interval);
                monster.set('cookieinfo', 'true', 365);
            }
        }, 4);
    }

    if (link.addEventListener) {
        link.addEventListener('click', clickHandler);
    } else {
        link.attachEvent('onclick', clickHandler);
    }

    container.appendChild(link);
    document.body.appendChild(container);

    return true;
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('statements', ['$state', 'Info', function($state, Info) {
            return {
                restrict: 'E',
                template: "<div class='info success' ng-repeat='statement in statements'></span><span class='info-left success-left glyphicon glyphicon-ok'></span><span ng-bind-html='$sce.trustAsHtml(statement)'></span></div>",
                link: function(scope, element, attrs) {
                    //If container is undefined
                    if (Info.statements[$state.current.name] == undefined)
                    //Initialize array
                        Info.statements[$state.current.name] = [];
                    //Give a reference
                    scope.statements = Info.statements[$state.current.name];
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('infos', ['$state', 'Info', function($state, Info) {
            return {
                restrict: 'E',
                template: "<div class='info comm' ng-repeat='info in infos'></span><span class='info-left comm-left glyphicon glyphicon-info-sign'></span><span ng-bind-html='$sce.trustAsHtml(info)'></span></div>",
                link: function(scope, element, attrs) {
                    //If container is undefined
                    if (Info.infos[$state.current.name] == undefined)
                    //Initialize array
                        Info.infos[$state.current.name] = [];
                    //Give a reference
                    scope.infos = Info.infos[$state.current.name];
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('errors', ['$state', 'Info', function($state, Info) {
            return {
                restrict: 'E',
                template: "<div class='info error' ng-repeat='error in errors'></span><span class='info-left error-left glyphicon glyphicon-remove'></span><span ng-bind-html='$sce.trustAsHtml(error)'></span></div>",
                link: function(scope, element, attrs) {
                    //If container is undefined
                    if (Info.errors[$state.current.name] == undefined)
                    //Initialize array
                        Info.errors[$state.current.name] = [];
                    //Give a reference
                    scope.errors = Info.errors[$state.current.name];
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('edistradaIdealeasingPortalApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('edistradaIdealeasingPortalApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-edistradaIdealeasingPortalApp-error');
                var entityKey = httpResponse.headers('X-edistradaIdealeasingPortalApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('edistradaIdealeasingPortalApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .service('HttpPendingRequestsService', HttpPendingRequestsService)
        .factory('serviceUnavailableInterceptor', serviceUnavailableInterceptor);

    serviceUnavailableInterceptor.$inject = ['$window', '$q', 'HttpPendingRequestsService'];

    function serviceUnavailableInterceptor ($window, $q, HttpPendingRequestsService) {
        var service = {
            request: handleRequest,
            responseError: handleResponseError
        };

        return service;

        function handleResponseError(response) {
            if (response.status >= 400 && response.status <= 408 && angular.isDefined(response.data) && response.data.rest_not_available === true) {
                HttpPendingRequestsService.cancelAll();
                $window.location.href = $window.location.origin + "/40x.htm";
                throw new Error("Backend is not available! Redirecting to mainenance page.");
            }

            if (response.config.timeout.isGloballyCancelled) {
                return $q.defer().promise;
            }
            return $q.reject(response);
        }

        function handleRequest(config) {
            config = config || {};
            if (config.timeout === undefined && !config.noCancelOnRouteChange) {
                config.timeout = HttpPendingRequestsService.newTimeout();
            }
            return config;
        }
    }

    HttpPendingRequestsService.$inject = ['$q'];

    function HttpPendingRequestsService($q) {
        var cancelPromises = [];

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-edistradaIdealeasingPortalApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-edistradaIdealeasingPortalApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .service('HttpPendingRequestsService', HttpPendingRequestsService)
        .factory('globalPromiseInterceptor', globalPromiseInterceptor);

    globalPromiseInterceptor.$inject = ['$q', 'HttpPendingRequestsService', '$rootScope', 'API_URL'];

    function globalPromiseInterceptor($q, HttpPendingRequestsService, $rootScope, API_URL) {

        function isRequestToAPI(request) {
            if (request.url.indexOf(API_URL) == 0)
                return true;
            else
                return false;
        }

        function updateSession(request) {
            $rootScope.Principal.updateLastAccessedTime();
        }

        return {
            request: function(config) {
                config = config || {};
                if (isRequestToAPI(config)) {
                    if (config.timeout === undefined && !config.noCancelOnRouteChange) {
                        config.timeout = HttpPendingRequestsService.newTimeout();
                    }
                    updateSession(config);
                }
                return config;
            },
            responseError: function(response) {
                if (response.config.timeout.isGloballyCancelled) {
                    return $q.defer().promise;
                }
                return $q.reject(response);
            }
        };
    }

    HttpPendingRequestsService.$inject = ['$q'];

    function HttpPendingRequestsService($q) {
        var cancelPromises = [];

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('edistradaIdealeasingPortalApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document', '$sessionStorage', 'API_URL'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document, $sessionStorage, API_URL) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/session') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    $rootScope.afterAuth = to.name;
                    $rootScope.afterAuthParams = params;
                    /* $sessionStorage.previousStateName = to.name;
                     $sessionStorage.previousStateParams = params;*/
                }
                //                var LoginService = $injector.get('LoginService');
                //                LoginService.open();
                if ($rootScope.fromState)
                    $injector.get('$state').go('401');
                else
                    $injector.get('$state').go('login');
            } else if /*the CSRF token expired, then try to get a new CSRF token and retry the old request*/ (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                var $http = $injector.get('$http');
                return $http.get(API_URL + 'api/welcome').finally(function() {
                    return afterCSRFRenewed(response);
                });
            }
            return $q.reject(response);
        }

        /*Get CSRF token*/
        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') { c = c.substring(1); }

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            //If CSRF token was renewed
            if (getCSRF() !== '') {
                // Retry the old request
                var $http = $injector.get('$http');
                //And return its response
                return $http(oldResponse.config);
            } else {
                // Unlikely to get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$window',
        'Auth', 'Principal', 'ENV', 'VERSION', 'Info', '$urlRouter', 'HttpPendingRequestsService'
    ];

    function stateHandler($rootScope, $state, $sessionStorage, $window,
        Auth, Principal, ENV, VERSION, Info, $urlRouter, HttpPendingRequestsService) {

        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;

            initializeState();

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                //Abort all pending requests
                HttpPendingRequestsService.cancelAll();

                //Verify if user can access this view
                if (!$rootScope.omit) {
                    Auth.authorize(true).then(function() {
                        if (Principal.isAuthenticated()) {
                            if (!$state.isApplication(toState) && !$state.isAccessible(toState)) {
                                $state.go('documents');
                                return;
                            } else if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                                $state.go('403');
                                return;
                            }
                        } else {
                            if ($state.isApplication(toState)) {
                                $rootScope.afterAuth = toState.name;
                                $state.go('401');
                                return;
                            }
                        }
                        $rootScope.omit = true;
                        $state.go(toState, toStateParams);
                    });
                    event.preventDefault();
                } else {
                    $rootScope.omit = false;
                }
                //Hide sidebar if not going to app state
                if (!$state.isApplication(toState)) {
                    $rootScope.sidebar = false;
                    var toggle = $('.navbar-toggle');
                    $('html').css("transition", "none");
                    $('html').removeClass('nav-open');
                    setTimeout(function() {
                        toggle.removeClass('toggled');
                        $('html').css("transition", "all 0.3s ease-in-out");
                    }, 430);
                }
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'edistradaIdealeasingPortal';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;

                //Clear all info from exited state
                Info.clear(fromState.name);
            });

            $rootScope.$on('$stateChangeError', function(event) {
                event.preventDefault();
                $state.go('404');
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }

        function initializeState() {
            $state.application = [];
            $state.accessible = [];

            $state.getStateChildren = function(states, rootState, children) {
                children.push(rootState);

                for (var state in states) {
                    if (states[state].parent == rootState.name)
                        $state.getStateChildren(states, states[state], children);
                }
            };

            $state.addApplication = function(state) {
                if (typeof state == 'string')
                    state = $state.get(state);
                $state.getStateChildren($state.get(), state, $state.application);
            };

            $state.isApplication = function(state) {
                if (typeof state == 'string')
                    state = $state.get(state);
                for (var stateIndex in $state.application)
                    if ($state.application[stateIndex].name == state.name)
                        return true;
                return false;
            };

            $state.addAccessible = function(state) {
                if (typeof state == 'string')
                    state = $state.get(state);
                $state.getStateChildren($state.get(), state, $state.accessible);
            };

            $state.isAccessible = function(state) {
                if (typeof state == 'string')
                    state = $state.get(state);
                for (var stateIndex in $state.accessible)
                    if ($state.accessible[stateIndex].name == state.name)
                        return true;
                return false;
            };

            $state.addApplication($state.get('application'));
            $state.addAccessible($state.get('emailChange'));
            $state.addAccessible($state.get('error'));
            $state.addAccessible($state.get('userActivate'));
            $state.addAccessible($state.get('appRegulations'));

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(vendorConfig);

    vendorConfig.$inject = [ /*Nothing*/ ];

    function vendorConfig() {

        var gsdk = {
            misc: {
                navbar_menu_visible: 0
            },
            initFiltersCollapse: function() {
                $(window).resize(function() {
                    if ($(window).width() < 992) {
                        $('.aside-filters .panel-title a, .panel-filters .panel-title a').addClass('collapsed');
                        $('.aside-filters .panel-collapse, .panel-filters .panel-collapse').removeClass('in');
                        $('#filters-panel').removeClass('in').css({ height: '' });
                        $('.card-refine').removeClass('card-plain');
                    } else {
                        $('#filters-panel').addClass('in');
                        $('.card-refine').addClass('card-plain');
                        //  $('.aside-filters .panel-collapse, .panel-filters .panel-collapse').addClass('in');
                    }
                });
                $(window).trigger('resize');
            },
            initNavSearchFormDisplay: function() {
                var $search = $('.ib-home-search');
                var $sm = $('.secondary-menu');

                var isVisibleOnTop = $search.is('.ib-search-form--visible-on-top');

                if (isVisibleOnTop) {
                    return;
                }
                if (!$sm.length) return;

                var wScrollTop = $(window).scrollTop();
                if (wScrollTop > $sm.offset().top) {
                    $search.addClass('.search-hidden');
                } else {
                    $search.removeClass('.search-hidden');
                }
            },
            initShuffle: function() {

                var $grid = $('.shuffle'),
                    $sizer = $grid.find(':first');

                $grid.shuffle({
                    itemSelector: 'div',
                    sizer: $sizer
                });


            },

            initLeftMenu: function() {
                if (!navbar_initialized) {
                    if(!angular.isDefined($navbar))
                        var $navbar;
                    $navbar = $('.navbar-collapse');


                    $navbar.css('min-height', window.screen.height);

                    // ul_content = '';

                    // $navbar.children('ul').each(function(){
                    //    content_buff = $(this).html();
                    //    ul_content = ul_content + content_buff;
                    // });

                    // ul_content = '<ul class="nav navbar-nav">' + ul_content + '</ul>';
                    // $navbar.html(ul_content);

                    // $('body').append($navbar);

                    // background_image = $navbar.data('nav-image');
                    // if(background_image != undefined){
                    //    $navbar.css('background',"url('" + background_image + "')")
                    //           .removeAttr('data-nav-image')
                    //           .css('background-size',"cover")
                    //           .addClass('has-image');
                    // }


                    if(!angular.isDefined($toggle))
                        var $toggle;
                    $toggle = $('.navbar-toggle');

                    // $navbar.find('a').removeClass('btn btn-round btn-default');
                    $navbar.find('button').removeClass('btn-round btn-fill btn-info btn-primary btn-success btn-danger btn-warning btn-neutral');
                    $navbar.find('button').addClass('btn-simple btn-block');

                    $toggle.click(function() {
                        if (gsdk.misc.navbar_menu_visible == 1) {
                            $('html').removeClass('nav-open');
                            gsdk.misc.navbar_menu_visible = 0;
                            $('#bodyClick').remove();
                            setTimeout(function() {
                                $toggle.removeClass('toggled');
                            }, 400);

                        } else {
                            setTimeout(function() {
                                $toggle.addClass('toggled');
                            }, 430);

                            div = '<div id="bodyClick"></div>';
                            $(div).appendTo("body").click(function() {
                                $('html').removeClass('nav-open');
                                gsdk.misc.navbar_menu_visible = 0;
                                $('#bodyClick').remove();
                                setTimeout(function() {
                                    $toggle.removeClass('toggled');
                                }, 400);
                            });

                            $('html').addClass('nav-open');
                            gsdk.misc.navbar_menu_visible = 1;

                        }
                    });
                    navbar_initialized = true;
                }

            },

            checkScrollForTransparentNavbar: debounce(function() {
                if ($(document).scrollTop() > 160) {
                    // if(transparent) {
                    // transparent = false;
                    $('nav[role="navigation"]').removeClass('navbar-transparent');
                    $('body').removeClass('header-transparent');
                    // }
                } else {
                    // if( !transparent ) {
                    // transparent = true;
                    $('nav[role="navigation"]').addClass('navbar-transparent');
                    $('body').addClass('header-transparent');
                    // }
                }
            }, 17),

            fitBackgroundForCards: function() {
                $('.card').each(function() {
                    if (!$(this).hasClass('card-product') && !$(this).hasClass('card-image')) {
                        image = $(this).find('.image img');
                        if (image.length) {
                            image.hide();
                            image_src = image.attr('src');

                            $(this).find('.image').css({
                                "background-image": "url('" + image_src + "')",
                                "background-position": "top center",
                                "background-size": "cover"
                            });
                        }
                    }
                });
            },
            initPopovers: function() {
                if ($('[data-toggle="popover"]').length != 0) {
                    $('body').append('<div class="popover-filter"></div>');

                    //    Activate Popovers
                    $('[data-toggle="popover"]').popover().on('show.bs.popover', function() {
                        $('.popover-filter').click(function() {
                            $(this).removeClass('in');
                            $('[data-toggle="popover"]').popover('hide');
                        });
                        $('.popover-filter').addClass('in');
                    }).on('hide.bs.popover', function() {
                        $('.popover-filter').removeClass('in');
                    });

                }
            },

            initSliders: function() {
                // Sliders for demo purpose in refine cards section
                // if($('#slider-range').length != 0){
                //     $( "#slider-range" ).slider({
                //      range: true,
                //      min: 100,
                //      max: 500,
                //         step: 50,
                //      values: [ 100, 500 ],
                //         slide: function( event, ui ) {
                //             min_price = ui.values[0];
                //             max_price = ui.values[1];
                //             console.log(this);
                //             $(this).next('.from-to-input').find('.from').val(min_price );
                //             $(this).next('.from-to-input').find('.to').val(max_price )
                //         }
                //  });
                // }
                // if($('#amount-slider').length != 0){
                //   $( "#amount-slider" ).slider({
                //      range: false,
                //      min: 1000,
                //      max: 50000,
                //      value: 25000,
                //         step: 1000,
                //      slide: function( event, ui ) {
                //          price = ui.value;
                //          $(this).siblings('.amount').html(price + " PLN");

                //      }
                //  });
                // }
                // if($('#slider-default').length != 0 || $('#slider-default2').length != 0){
                //  $( "#slider-default, #slider-default2" ).slider({
                //          value: 70,
                //          orientation: "horizontal",
                //          range: "min",
                //          animate: true
                //  });
                // }
            },
            initVideoCards: function() {


                $('[data-toggle="video"]').click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log(e);



                    var id_video = $(this).data('video');
                    var video = $('#' + id_video).get(0);

                    var $card = $(this).closest('.card');
                    // console.log($card,id_video, video);

                    if (video.paused) {
                        video.play();
                        $card.find('.fa-pause,.fa-play').parent().html('<i class="fa fa-pause"></i> Pause');
                        $card.addClass('state-play');
                    } else {
                        video.pause();
                        $card.find('.fa-pause,.fa-play').parent().html('<i class="fa fa-play"></i> Play');
                        $card.removeClass('state-play');
                    }
                });
            },
            initNavbarSearch: function() {
                $('[data-toggle="search"]').click(function() {
                    if (searchVisible == 0) {
                        searchVisible = 1;
                        $(this).parent().addClass('active');
                        $('.navbar-search-form').fadeIn(function() {
                            $('.navbar-search-form input').focus();
                        });
                    } else {
                        searchVisible = 0;
                        $(this).parent().removeClass('active');
                        $(this).blur();
                        $('.navbar-search-form').fadeOut(function() {
                            $('.navbar-search-form input').blur();
                        });
                    }
                });
            },
            initMasonry: function() {

                // var msnry = new Masonry( '.masonry', {
                //   // options
                //   // itemSelector: '.',
                //   // columnWidth: 200
                // });


            },
            initSlickSliders: function() {
                //    $('#slickCarousel').slick({
                //         dots: true,
                //         infinite: false,
                //         speed: 300,
                //         slidesToShow: 3,
                //         slidesToScroll: 2,
                //         prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
                //         nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
                //         responsive: [
                //           {
                //             breakpoint: 1024,
                //             settings: {
                //               slidesToShow: 3,
                //               slidesToScroll: 2,
                //               infinite: true,
                //               dots: true
                //             }
                //           },
                //           {
                //             breakpoint: 700,
                //             settings: {
                //               slidesToShow: 2,
                //               slidesToScroll: 1
                //             }
                //           },
                //           {
                //             breakpoint: 580,
                //             settings: {
                //               slidesToShow: 1,
                //               slidesToScroll: 1
                //             }
                //           }
                //           // You can unslick at a given breakpoint now by adding:
                //           // settings: "unslick"
                //           // instead of a settings object
                //         ]
                //     });


            }
        };

        /**
         * jquery.matchHeight-min.js master
         * http://brm.io/jquery-match-height/
         * License: MIT
         */
        (function(c) {
            var n = -1,
                f = -1,
                g = function(a) {
                    return parseFloat(a) || 0
                },
                r = function(a) {
                    var b = null,
                        d = [];
                    c(a).each(function() {
                        var a = c(this),
                            k = a.offset().top - g(a.css("margin-top")),
                            l = 0 < d.length ? d[d.length - 1] : null;
                        null === l ? d.push(a) : 1 >= Math.floor(Math.abs(b - k)) ? d[d.length - 1] = l.add(a) : d.push(a);
                        b = k
                    });
                    return d
                },
                p = function(a) {
                    var b = { byRow: !0, property: "height", target: null, remove: !1 };
                    if ("object" === typeof a) return c.extend(b, a);
                    "boolean" === typeof a ? b.byRow = a : "remove" === a && (b.remove = !0);
                    return b
                },
                b = c.fn.matchHeight =
                function(a) {
                    a = p(a);
                    if (a.remove) {
                        var e = this;
                        this.css(a.property, "");
                        c.each(b._groups, function(a, b) { b.elements = b.elements.not(e) });
                        return this
                    }
                    if (1 >= this.length && !a.target) return this;
                    b._groups.push({ elements: this, options: a });
                    b._apply(this, a);
                    return this
                };
            b._groups = [];
            b._throttle = 80;
            b._maintainScroll = !1;
            b._beforeUpdate = null;
            b._afterUpdate = null;
            b._apply = function(a, e) {
                var d = p(e),
                    h = c(a),
                    k = [h],
                    l = c(window).scrollTop(),
                    f = c("html").outerHeight(!0),
                    m = h.parents().filter(":hidden");
                m.each(function() {
                    var a = c(this);
                    a.data("style-cache", a.attr("style"))
                });
                m.css("display", "block");
                d.byRow && !d.target && (h.each(function() {
                    var a = c(this),
                        b = a.css("display");
                    "inline-block" !== b && "inline-flex" !== b && (b = "block");
                    a.data("style-cache", a.attr("style"));
                    a.css({ display: b, "padding-top": "0", "padding-bottom": "0", "margin-top": "0", "margin-bottom": "0", "border-top-width": "0", "border-bottom-width": "0", height: "100px" })
                }), k = r(h), h.each(function() {
                    var a = c(this);
                    a.attr("style", a.data("style-cache") || "")
                }));
                c.each(k, function(a, b) {
                    var e = c(b),
                        f = 0;
                    if (d.target) f = d.target.outerHeight(!1);
                    else {
                        if (d.byRow && 1 >= e.length) {
                            e.css(d.property, "");
                            return
                        }
                        e.each(function() {
                            var a = c(this),
                                b = a.css("display");
                            "inline-block" !== b && "inline-flex" !== b && (b = "block");
                            b = { display: b };
                            b[d.property] = "";
                            a.css(b);
                            a.outerHeight(!1) > f && (f = a.outerHeight(!1));
                            a.css("display", "")
                        })
                    }
                    e.each(function() {
                        var a = c(this),
                            b = 0;
                        d.target && a.is(d.target) || ("border-box" !== a.css("box-sizing") && (b += g(a.css("border-top-width")) + g(a.css("border-bottom-width")), b += g(a.css("padding-top")) + g(a.css("padding-bottom"))),
                            a.css(d.property, f - b + "px"))
                    })
                });
                m.each(function() {
                    var a = c(this);
                    a.attr("style", a.data("style-cache") || null)
                });
                b._maintainScroll && c(window).scrollTop(l / f * c("html").outerHeight(!0));
                return this
            };
            b._applyDataApi = function() {
                var a = {};
                c("[data-match-height], [data-mh]").each(function() {
                    var b = c(this),
                        d = b.attr("data-mh") || b.attr("data-match-height");
                    a[d] = d in a ? a[d].add(b) : b
                });
                c.each(a, function() { this.matchHeight(!0) })
            };
            var q = function(a) {
                b._beforeUpdate && b._beforeUpdate(a, b._groups);
                c.each(b._groups, function() {
                    b._apply(this.elements,
                        this.options)
                });
                b._afterUpdate && b._afterUpdate(a, b._groups)
            };
            b._update = function(a, e) {
                if (e && "resize" === e.type) {
                    var d = c(window).width();
                    if (d === n) return;
                    n = d
                }
                a ? -1 === f && (f = setTimeout(function() {
                    q(e);
                    f = -1
                }, b._throttle)) : q(e)
            };
            c(b._applyDataApi);
            c(window).bind("load", function(a) { b._update(!1, a) });
            c(window).bind("resize orientationchange", function(a) { b._update(!0, a) })
        })(jQuery);


        /* chartist-plugin-pointlabels 0.0.7
         * Copyright © 2015 Gion Kunz
         * Free to use under the WTFPL license.
         * http://www.wtfpl.net/
         */

        // !function(a,b){"function"==typeof define&&define.amd?define([],function(){return a.returnExportsGlobal=b()}):"object"==typeof exports?module.exports=b():a["Chartist.plugins.tooltips"]=b()}(this,function(){return function(a,b,c){"use strict";var d={currency:void 0};c.plugins=c.plugins||{},c.plugins.tooltip=function(a){return a=c.extend({},d,a),function(b){var d=".ct-point";b instanceof c.Bar?d=".ct-bar":b instanceof c.Pie&&(d=".ct-slice");var e=$(b.container),f=e.append('<div class="chartist-tooltip"></div>').find(".chartist-tooltip").hide();e.on("mouseenter",d,function(){var d=$(this),e="";if(a.tooltipFnc)e=a.tooltipFnc(d.attr("ct:meta")||"",d.attr("ct:value"));else{if(d.attr("ct:meta"))e+=d.attr("ct:meta")+"<br/>";else if(b instanceof c.Pie){var g=d.next(".ct-label");g.length>0&&(e+=g.text()+"<br/>")}var h=d.attr("ct:value");$.isEmptyObject(a.currency)||(h=a.currency+h.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g,"$1,")),e+=h}f.html(e).show()}),e.on("mouseleave",d,function(){f.hide()}),e.on("mousemove",function(a){f.css({left:(a.originalEvent.layerX||a.offsetX)-f.width()/2-10,top:(a.originalEvent.layerY||a.offsetY)-f.height()-40})})}}}(window,document,Chartist),Chartist.plugins.tooltips});
        



        /**
         * Polish translation for bootstrap-datepicker
         * Robert <rtpm@gazeta.pl>
         */
        ;
        (function($) {
            $.fn.datepicker.dates['pl'] = {
                days: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
                daysShort: ["niedz.", "pon.", "wt.", "śr.", "czw.", "piąt.", "sob."],
                daysMin: ["ndz.", "pn.", "wt.", "śr.", "czw.", "pt.", "sob."],
                months: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                monthsShort: ["sty.", "lut.", "mar.", "kwi.", "maj", "cze.", "lip.", "sie.", "wrz.", "paź.", "lis.", "gru."],
                today: "dzisiaj",
                weekStart: 1,
                clear: "wyczyść",
                format: "dd.mm.yyyy"
            };
        }(jQuery));

        var searchVisible = 0;
        var transparent = true;

        var transparentDemo = true;
        var fixedTop = false;

        var navbar_initialized = false;

        function isTouchDevice() {
            var el = document.createElement('div');
            el.setAttribute('ongesturestart', 'return;'); // or try "ontouchstart"
            return typeof el.ongesturestart === "function";
        }

        $(document).ready(function() {
            var window_width = $(window).width();


            // Init search form display
            gsdk.initNavSearchFormDisplay();

            // Init navigation toggle for small screens
            // if(window_width < 768){
            //  gsdk.initLeftMenu();
            // }

            // Activate Morpghing Buttons
            $('[data-toggle="morphing"]').each(function() {
                $(this).morphingButton();
            });

            //  Activate the tooltips
            $('[rel="tooltip"]').tooltip();

            //      Activate the switches with icons
            if ($('.switch').length != 0) {
                $('.switch')['bootstrapSwitch']();
            }
            //      Activate regular switches
            if ($("[data-toggle='switch']").length != 0) {
                $("[data-toggle='switch']").wrap('<div class="switch"></div>').parent().bootstrapSwitch();
            }

            //    Activate bootstrap-select
            if ($(".selectpicker").length != 0) {
                $(".selectpicker").selectpicker();
            }

            // if($(".tagsinput").length != 0){
            //     $(".tagsinput").tagsInput();
            // }

            if ($('.date-picker').length != 0) {
                $('.date-picker').datepicker({
                    weekStart: 1,
                    format: 'dd/mm/yyyy',
                    language: 'pl',
                    orientation: 'auto right'
                });
            }
            //
            // if( $('.masonry').length != 0 ){
            //     gsdk.initMasonry();
            // }


            $('.btn-tooltip').tooltip();
            $('.label-tooltip').tooltip();




            $('.form-control').on("focus", function() {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function() {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });

            // demo.initPickColor();

            // Make the images from the card fill the hole space
            gsdk.fitBackgroundForCards();

            // Init icon search action for the navbar
            // gsdk.initNavbarSearch();

            // Init popovers
            // gsdk.initPopovers();

            // Init Collapse Areas
            // gsdk.initCollapseArea();

            // Init Sliders
            // gsdk.initSliders();

            //  Init video card actions
            gsdk.initVideoCards();
            gsdk.initFiltersCollapse();

            $(window).on('scroll', gsdk.checkScrollForTransparentNavbar);
            $(window).trigger('resize');
            $(window).trigger('scroll');

            // gsdk.checkScrollForTransparentNavbar();

        });


        /**
         * Table row toggle
         * podsumowanie-umow-leasingowych.php
         */
        $(function() {

            $('[data-js-slide-table-trigger]').on('click', function(e) {
                e.preventDefault();
                var id = $(this).data('js-slide-table-trigger');
                // var $tr = $(this).parent();
                var $details = $(id);
                var $tr = $details.closest('tr').prev();
                //
                if ($details.hasClass('visible')) {
                    $details.slideUp('fast');
                    $details.removeClass('visible');
                    $tr.delay(111).show('slow');
                } else {
                    $details.slideDown('fast');
                    $details.addClass('visible');
                    $tr.hide();
                }
            });

        });

        /**
         * Cards equal height settings.php
         */
        $(function() {

            $('.grid .content').matchHeight({
                byRow: true
            });


        });

        // activate collapse right menu when the windows is resized
        $(window).resize(function() {
            if ($(window).width() < 768) {
                gsdk.initLeftMenu();
            }
        });

        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        };





        // jQuery(function () {
        //   $('[data-placeholder-animate]').each(function (i, el) {
        //     var $el = $(el);
        //     var timeoutId;
        //     var placeholder = $el.attr('placeholder');
        //     var currentPos = 0;
        //     // console.log( placeholder, placeholder.length )
        //     // var currentPos = 0;
        //     $el.on('focusin', function (e) {
        //        $el.attr("placeholder", '' );
        //       if( timeoutId ) clearTimeout(timeoutId);

        //     });
        //     $el.on('focusout', function (e) {
        //       if( $el.val() == '' )
        //       {
        //         setTimeout(animation, 100);
        //       }
        //     }).trigger('focusout');

        //     function animation() {

        //       // var placeholder = $el.attr('placeholder');
        //       var text = placeholder.substr(0, currentPos++);
        //       // console.log( currentPos, placeholder.length );
        //       $el.attr("placeholder", text );

        //       if( currentPos == placeholder.length+1 ){
        //         currentPos = 0;
        //         var timeout = 1000;
        //       }else{
        //         var timeout = 100;
        //       }

        //       timeoutId = setTimeout(animation,  timeout);
        //     }

        //   });
        // });


    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('il-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
        $httpProvider.defaults.withCredentials = true;

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.when('', '/');
        $urlRouterProvider.otherwise('/error/404');

        $httpProvider.interceptors.push('serviceUnavailableInterceptor');
        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('globalPromiseInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function(val) {
                return val === true || val === 'true';
            },
            encode: function(val) {
                return val ? 1 : 0;
            },
            equals: function(a, b) {
                return this.is(a) && a === b;
            },
            is: function(val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'ENV'];

    function compileServiceConfig($compileProvider, ENV) {
        // disable debug data on prod profile to improve performance
        if(ENV === 'prod'){
            $compileProvider.debugInfoEnabled(false);
        }

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('site', {
                abstract: true
            })
            .state('application', {
                parent: 'site',
                abstract: true,
                resolve: {
                    authorize: function(Auth) {
                        return Auth.authorize();
                    }

                },
                url: '/app',
                views: {
                    'index@': {
                        templateUrl: 'app/layouts/application/application.html'
                    },
                    'shell@application': {
                        templateUrl: 'app/layouts/shell/shell.html',
                        controller: 'ShellController',
                        controllerAs: 'vm'
                    },
                    'sidebar@application': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'footer@application': {
                        templateUrl: 'app/layouts/footer/footer.html'
                    }
                }
            });
    }
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("edistradaIdealeasingPortalApp")
.constant("ENV", "prod")
.constant("API_URL", "../ilapi/")
.constant("VERSION", "132.0.0-14-g0a226ad");

})();
;(function(){angular.module("edistradaIdealeasingPortalApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1>Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" maxlength=\"128\" placeholder=\"Your username\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"Your password\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span>Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\">Did you forget your password?</a></div><div class=\"alert alert-warning\">You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a></div></div></div></div>");
$templateCache.put("app/components/util/document.html","<td class=\"no-border no-hover visible-lg\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip><span class=\"blue-dot\" ng-if=\"!vm.isDocumentRead(document)\"></span></td><td class=\"visible-lg\" has-authority=\"ROLE_EMPLOYEE\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.login}}</td><td class=\"visible-lg\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.agreement_nr}}</td><td title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.document_type}}</td><td title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.document_nr}}</td><td title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.ksef_nr}}</td><td class=\"nowrap\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{vm.getDate(document.date_issue)}}</td><td title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.invoice_reference}}</td><td class=\"nowrap hidden-xs\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{vm.getDate(document.date_payment)}}</td><td class=\"text-right\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip><span ng-repeat=\"value in document.netto\">{{value}}<br></span></td><td class=\"text-right visible-lg\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip><span ng-repeat=\"value in document.vat\">{{value}}<br></span></td><td class=\"text-right visible-lg\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip><span ng-repeat=\"value in document.brutto\">{{value}}<br></span></td><td class=\"text-right visible-lg\" has-authority=\"ROLE_EMPLOYEE\" title=\"{{document.e_invoice ? \'Dokument (.pdf), kliknij by pobrać\'\n : \'\'}}\" data-placement=\"left\" data-container=\"body\" tooltip>{{document.e_invoice ? (document.date_document_open == null ? \"Nie otwarto\" : vm.getDate(document.date_document_open)) : \"\"}}</td><td class=\"actions visible-lg\" ng-click=\"vm.downloadXML($event, $index, document)\" title=\"{{document.e_invoice ? \'Dokument (.xml), kliknij by pobrać\' : \'\'}}\" tooltip data-placement=\"left\"><a ng-if=\"document.e_invoice\" rel=\"tooltip\" class=\"btn-e-fv\" ng-class=\"{readFV:document.date_document_open != null}\" has-authority=\"ROLE_EMPLOYEE\"></a> <a ng-if=\"document.e_invoice\" class=\"btn-e-fv\" ng-class=\"{readFV:document.date_document_open != null}\" has-authority=\"ROLE_CLIENT\"></a></td>");
$templateCache.put("app/layouts/application/application.html","<div id=\"shell\" class=\"transition\" ui-view=\"shell\" ng-cloak></div><div id=\"sidebar\" class=\"collapse navbar-collapse\" ui-view=\"sidebar\" ng-cloak></div><div class=\"\" style=\"height:50px\"></div><div id=\"content\" class=\"transition wrapper\" ui-view=\"content\" ng-cloak></div><div ui-view=\"footer\" ng-cloak></div>");
$templateCache.put("app/layouts/footer/footer.html","<footer class=\"footer footer-transparent\"><div class=\"container\"><div class=\"copyright\">Portal VB Leasing<br><a href ui-sref=\"appRegulations\">Regulamin Portalu</a></div></div></footer>");
$templateCache.put("app/layouts/shell/shell.html","<button id=\"menu-toggle\" rel=\"tooltip\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"<p>Menu</p>\" tooltip type=\"button\" ng-click=\"vm.toggleSidebar()\" class=\"navbar-toggle\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar bar1\"></span> <span class=\"icon-bar bar2\"></span> <span class=\"icon-bar bar3\"></span></button><nav class=\"navbar navbar-ct-blue navbar-on-white navbar-inverse navbar-transparent navbar-fixed-top\" role=\"navigation\"><div class=\"push-container\"><div class=\"container-fluid\"><!-- Brand and toggle get grouped for better mobile display --><div class=\"navbar-header\"><a class=\"logo\" href=\"./\"><img class=\"logo-img\" src=\"img/logo.png\"> <img class=\"logo-blue-img\" src=\"img/logo-blue.png\"></a><div class=\"advert\"><b id=\"communiqueln1\"></b><br><b id=\"communiqueln2\"></b></div><div class=\"nav navbar-nav navbar-right\"></div><!-- /.navbar_header --></div><!-- /.container --></div><div us-spinner=\"{color: \'#09F\', radius:7, width:3, length: 4, opacity:0, trail:100, top:\'30%\'}\"></div><div id=\"action\" style=\"position: absolute; left: 50%; top: 60%; transform: translateX(-50%); width: 100%; text-align: center\" ng-hide=\"$root.Info.action.length == 0\">{{$root.Info.action[0]}}</div></div><div class=\"navbar-right-buttons pull-right\"><div class=\"user-info\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> <span class=\"nicname\">{{vm.name | limitTo : 47}}{{vm.name.length > 47 ? \"...\" : \"\"}}</span> <span class=\"id\" has-authority=\"ROLE_CLIENT\">(ID {{$root.Principal.getProperty(\'login\')}})</span><br><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> <span class=\"visible-lg-inline-block\">Sesja wygasa za:&#32;</span> <span id=\"sessionTimeout\"></span></div><a class=\"btn btn-primary btn-fill\" href ng-click=\"vm.logout()\">Wyloguj</a></div><!-- /.push-container --></nav><script></script><!-- popover=\"Menu\" popover-placement=\"right\" popover-trigger=\"mouseenter\" --> <!-- data-toggle=\"tooltip\" data-placement=\"right\" -->");
$templateCache.put("app/layouts/sidebar/sidebar.html","<div style=\"height:50px\" class=\"\"></div><ul class=\"nav navbar-nav\"><li><a ui-sref=\"documents\">Faktury i noty <span class=\"badge\" has-authority=\"ROLE_CLIENT\" ng-if=\"$root.Principal.getProperty(\'unreadDocumentCount\') != 0\">{{$root.Principal.getProperty(\'unreadDocumentCount\')}}</span></a></li><li><a ui-sref=\"agreements\">Umowy</a></li><li><a ui-sref=\"settings\">Ustawienia konta</a></li><li><a ui-sref=\"faq\">Pomoc</a></li><li class=\"separator\" has-authority=\"ROLE_EMPLOYEE\"></li><li has-authority=\"CLIENT_RESOURCE\"><a ui-sref=\"client\">Klienci</a></li><li has-authority=\"CLIENT_RESOURCE\"><a ui-sref=\"communique\">Komunikat</a></li><li has-authority=\"USER_RESOURCE\"><a ui-sref=\"users\">Użytkownicy</a></li><li has-authority=\"ROLE_RESOURCE\"><a ui-sref=\"roles\">Role użytkowników</a></li><li class=\"btn-container\"><a href class=\"btn btn-primary btn-white\" ng-click=\"vm.logout()\">Wyloguj się</a></li></ul>");
$templateCache.put("app/layouts/site/site.html","");
$templateCache.put("app/views/activate/activate.html","<h2 class=\"no-m-top\">Aktywacja konta Klienta w Portalu VB Leasing</h2><errors></errors><statements></statements><p>Podaj hasło, które podałeś podczas pierwszego etapu rejestracji w Portalu oraz wprowadź nowe hasło, którego będziesz używał do logowania w Portalu VB Leasing.</p><form id=\"activationForm\" name=\"activationForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"opass\" class=\"control-label col-md-3\">Hasło startowe</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.startPassword\" data-old-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><label for=\"npass\" class=\"control-label col-md-3\">Nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.password\" data-new-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><label for=\"ppass\" class=\"control-label col-md-3\">Powtórz nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.newRepeat\" data-repeat-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-3 text-center\"><button id=\"account_activate\n\" type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.activate()\" ng-disabled=\"activationForm.$invalid || activationForm.$pending\">Aktywuj konto</button></div></div></form>");
$templateCache.put("app/views/activate/quickActivate1.html","<h2 class=\"no-m-top\">Aktywacja konta Klienta w Portalu VB Leasing</h2><h4>Zgody i oświadczenia wydane przy zawarciu umowy</h4><form id=\"step3Form\" name=\"step3Form\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-12\"><input type=\"checkbox\" id=\"agreement1\" required=\"required\" disabled=\"disabled\" ng-model=\"vm.data.agreement1\" tabindex=\"1\"><label class=\"checkbox\" for=\"agreement1\" style=\"cursor:default\">Oświadczam, że zapoznałem się z <b><a ui-sref=\"regulations\" ng-click=\"vm.data.agreement1 = !vm.data.agreement1\" href>Regulaminem</a></b> świadczenia usługi elektronicznej Portal VBL przez VB Leasing S.A. w restrukturyzacji oraz akceptuję jego postanowienia.<!--<strong style=\"color:red;\">*</strong>--></label></div></div><!-- Agreement 2 was removed and made not required due to SD-636556 --><div class=\"form-group\"><div class=\"col-xs-12\"><input type=\"checkbox\" id=\"agreement3\" disabled=\"disabled\" ng-model=\"vm.data.agreement3\" tabindex=\"3\"><label class=\"checkbox\" for=\"agreement3\" style=\"cursor:default\"><b>Akceptuję wystawianie i udostępnianie dokumentów w formie elektronicznej (e-Dokumentów)</b> przez VB Leasing S.A. w restrukturyzacji, na zasadach określonych w Regulaminie świadczenia usługi elektronicznej Portal VB Leasing.<br>Dokumenty elektroniczne (e-Dokumenty) będą udostępniane jedynie poprzez Portal VBL, po zalogowaniu się na indywidualne konto Klienta. Portal VBL będzie umożliwiał Klientowi samodzielne pobranie dokumentów w postaci pliku PDF i/lub XML. Dokumenty będą udostępniane w formacie elektronicznym po wyrażeniu niniejszej akceptacji i będą dotyczyć wszystkich usług świadczonych na podstawie umów już zawartych jak i zawartych w przyszłości. Oświadczam, że zapoznałem się z <b><a ui-sref=\"regulations\" ng-click=\"vm.data.agreement3 = !vm.data.agreement3\" href>Regulaminem</a></b> świadczenia usługi elektronicznej Portal VB Leasing.</label></div></div><!-- Agreement 4 was removed due to SD-636556 --><!-- Agreement 5 was removed due to SD-636556 --><!-- Agreement 6 was removed due to SD-636556 --><div id=\"annotations\" style=\"margin-left:20px\"><p><!--<strong style=\"color:red;\">*</strong> - pole obowiązkowe--></p></div><div id=\"disclaimer\" class=\"text-justify\" style=\"font-size: 8pt; padding: 0px 10px 10px 10px\">Administratorem danych przetwarzanych za pośrednictwem Portalu VB Leasing pozostaje VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, przy ul. Fabryczna 6, 53-609 Wrocław (\"VBL\"). Dane osobowe są przetwarzane w celu niezbędnym do świadczenia usługi Portalu VB Leasing oraz marketingu produktów i usług VBL. Podanie danych osobowych jest dobrowolne, jednak niezbędne w celu umożliwienia skorzystania z tej usługi. Osoba, której dane dotyczą ma prawo dostępu do treści jej danych oraz do ich poprawiania.</div><div class=\"form-group\"><div class=\"col-xs-12\"><button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill pull-right\" ng-click=\"vm.spreadApproval()\">Dalej aktywacja konta</button></div></div></form>");
$templateCache.put("app/views/activate/quickActivate2.html","<h2 class=\"no-m-top\">Aktywacja konta Klienta w Portalu VB Leasing</h2><errors></errors><statements></statements><p>Wprowadź nowe hasło, którego będziesz używał do logowania w Portalu VB Leasing.</p><form id=\"activationForm\" name=\"activationForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"npass\" class=\"control-label col-md-3\">Nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.newPassword\" data-new-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><label for=\"ppass\" class=\"control-label col-md-3\">Powtórz nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.password\" data-repeat-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-3 text-center\"><button id=\"account_activate\n\" type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.quickActivate()\" ng-disabled=\"activationForm.$invalid || activationForm.$pending\">Aktywuj konto</button></div></div></form>");
$templateCache.put("app/views/client/client.html","<div class=\"section\"><form class=\"container-fluid client-search\"><div class=\"row\"><input type=\"text\" placeholder=\"Kod klienta\" name=\"login\" class=\"form-control client-search-field\" ng-model=\"vm.filter.query.login\" ng-pattern=\"/^[0-9]+$/\" data-pattern-tooltip=\"Podaj poprawny kod klienta.\"> <input type=\"text\" placeholder=\"E-mail\" name=\"email\" class=\"form-control client-search-field\" ng-model=\"vm.filter.query.email\"> <button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round client-search-field\" ng-click=\"vm.getClient($event)\">Wyszukaj</button></div></form><div class=\"container-fluid\" ng-show=\"$root.Info.infos[\'client\'].length + $root.Info.statements[\'client\'].length + $root.Info.errors[\'client\'].length > 0\"><infos></infos><errors></errors><statements></statements></div><div class=\"container-fluid\" ng-if=\"vm.data.result.entries != null && vm.data.result.entries.clients != null && vm.data.result.entries.clients.length > 0\"><div class=\"row text-center\" ng-if=\"vm.data.result.pageCount > 1\"><div class=\"col-md-2\"><button type=\"submit\" class=\"btn btn-primary btn-round btn-fill client-search-button\" ng-disabled=\"vm.data.offset == 0\" ng-click=\"vm.previous()\"><span class=\"glyphicon glyphicon-chevron-left\"></span> Poprzednia</button></div><nav class=\"col-md-8\"><ul class=\"pagination\"><li ng-class=\"{active : vm.data.result.pageNumber == i}\" ng-repeat=\"i in vm.getNumber(vm.data.result.pageCount) | limitTo:10:vm.data.pageStart\"><!-- | limitTo:10:(vm.data.result.pageNumber>5?vm.data.result.pageNumber-5:0) --> <a ng-click=\"vm.page(i)\" href>{{i+1}}</a></li><input id=\"pageStart\" type=\"range\" min=\"0\" max=\"{{vm.data.result.pageCount - 10}}\" ng-model=\"vm.data.pageStart\" ng-init=\"vm.data.pageStart = 0\" ng-show=\"vm.data.result.pageCount > 10\"></ul></nav><div class=\"col-md-2\"><button type=\"submit\" class=\"btn btn-primary btn-round btn-fill client-search-button\" ng-disabled=\"vm.data.offset == vm.data.result.pageCount-1\" ng-click=\"vm.next()\">Następna <span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"table-responsive\"><table class=\"table table-users table-hover no-first-last-padding\"><thead><tr><th class=\"visible-lg\"></th><th>Kod klienta</th><th class=\"hidden-xs\">Nazwa</th><th>E-mail</th><th class=\"visible-lg\">Zarejestrowany</th></tr></thead><tbody><tr ng-repeat=\"client in vm.data.result.entries.clients\" ng-click=\"vm.setClient($event, client)\"><td class=\"visible-lg\">{{$index + 1 + vm.data.result.pageNumber*vm.data.result.pageSize}}</td><td>{{client.login}}</td><td class=\"hidden-xs\" ng-bind-html=\"client.name_addr.replace(vm.pipeRegex,\'<br>\')\"></td><td>{{client.email}}</td><td class=\"visible-lg\">{{client.portal_access ? \'TAK\' : \'NIE\'}}</td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div></div><div id=\"clientInfo\" class=\"container-fluid\" ng-show=\"vm.data.client != null\"><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"no-m-top\">Informacje o kliencie</h2></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"[ card card-details ]\"><!-- ./less/card-details.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"details\"><div class=\"row\"><div class=\"col-sm-6\"><table><tr><td><span class=\"text-default uppercase left\">Kod klienta:</span></td><td class=\"right\">{{vm.data.client.login}}</td></tr><tr><td><span class=\"text-default uppercase left\">Nazwa:</span></td><td class=\"right\" ng-bind-html=\"vm.data.client.name_addr.replace(vm.pipeRegex,\'<br>\')\"></td></tr><tr><td><span class=\"text-default uppercase left\">Zarejestrowany:</span></td><td class=\"right\">{{vm.data.client.portal_access ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">E-mail:</span></td><td class=\"right\">{{!vm.data.client.email ? \'NIE PODANO\' : vm.data.client.email}}</td></tr><tr><td><span class=\"text-default uppercase left\">Numer telefonu:</span></td><td class=\"right\">{{!vm.data.client.phone_number? \'NIE PODANO\' : vm.data.client.phone_number}}</td></tr><tr><td><span class=\"text-default uppercase left\">Blokada stała:</span></td><td class=\"right\">{{vm.data.client.account_blocked ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">Blokada na 15 minut:</span></td><td class=\"right\">{{(vm.data.client.invalid_login_counter >= 3 && (vm.data.client.invalid_login_date > (vm.now() - 1000 * 60 * 15 ))) ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">IP niepoprawnego logowania:</span></td><td class=\"right\">{{vm.data.client.invalid_login_ip == null ? \'BRAK\' : vm.data.client.invalid_login_ip}}</td></tr><tr><td><span class=\"text-default uppercase left\">Data niepoprawnego logowania:</span></td><td class=\"right\">{{vm.data.client.invalid_login_date == null ? \'BRAK\' : vm.Date(vm.data.client.invalid_login_date)}}</td></tr><tr><td><span class=\"text-default uppercase left\">Liczba niepoprawnych prób logowania:</span></td><td class=\"right\">{{vm.data.client.invalid_login_counter == null ? 0 : vm.data.client.invalid_login_counter}}</td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"text-default left uppercase\">Saldo:</td><td class=\"right\">{{vm.data.client.balance == null ? 0.00 : vm.getValue(vm.data.client.balance)}} zł</td></tr><tr><td class=\"text-default left uppercase\">Liczba umów:</td><td class=\"right\">{{vm.data.client.agreement_count}}</td></tr><tr><td class=\"text-default left uppercase\">Liczba dokumentów:</td><td class=\"right\">{{vm.data.client.document_count}}</td></tr><tr><td class=\"text-default left uppercase\">Aktywna umowa:</td><td class=\"right\">{{vm.data.client.active_agreement == true ? \'TAK\' : \'NIE\'}}</td></tr><tr><td class=\"text-default left uppercase\">Zgoda na e-faktury:</td><td class=\"right\">{{vm.data.client.e_invoice == true ? \'TAK\' : \'NIE\'}}</td></tr><tr><td class=\"text-default left uppercase\">Dostęp do portalu:</td><td class=\"right\">{{vm.data.client.enable == true ? \'TAK\' : \'NIE - rezygnacja klienta\'}}</td></tr></table></div></div></div></div><div class=\"footer\"><button class=\"btn btn-primary btn-round btn-fill client-search-button\" ng-disabled=\"!vm.data.client.email\" has-authority=\"EMPLOYEE_RESET_CLIENT_PASSWORD_RESOURCE\" confirm=\"vm.resetPassword($event)\" message=\"Czy jesteś pewien, że chcesz zresetować hasło tego klienta?\">Zresetuj hasło</button> <button class=\"btn btn-primary btn-round client-search-button\" ng-disabled=\"!vm.data.client.account_blocked\" has-authority=\"EMPLOYEE_UNLOCK_CLIENT_ACCOUNT_RESOURCE\" confirm=\"vm.unlock($event)\" message=\"Czy jesteś pewien, że chcesz odblokować tego klienta?\">Odblokuj konto</button> <button class=\"btn btn-primary btn-round btn-fill\" ui-sref=\"newClientEmail({clientLogin: vm.data.client.login})\">Aktualizuj email</button></div></div></div></div><!-- end .card-product-horizontal --></div></div><div class=\"row\" has-authority=\"LOGS_CLIENT_RESOURCE\"><div class=\"col-md-9\"><h2 class=\"\">Historia konta</h2></div></div><div class=\"row\" has-authority=\"LOGS_CLIENT_RESOURCE\"><div class=\"col-md-3 panel panel-filters\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED id=\"filters-panel\" --><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#inputDate\" href class=\"collapsed\">DATA WPISU <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"inputDate\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.log.ts_from\" data-max=\"{{vm.filter.log.ts_to}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\" for=\"to\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.log.ts_to\" data-min=\"{{vm.filter.log.ts_from}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getClientLogs()\">Wyszukaj</button></div></div></div></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"noData\" ng-if=\"vm.data.logs.length == 0\">Brak wpisów</div><div class=\"table-responsive\" ng-if=\"vm.data.logs.length != 0\"><table class=\"table table-users table-hover no-first-last-padding\"><thead><tr><th class=\"name-header-cell hidden-xs\"></th><th class=\"name-header-cell hidden-xs\">Typ wpisu</th><th class=\"name-header-cell\">Wpis</th><th class=\"name-header-cell\">Data wpisu</th><th class=\"name-header-cell\">Adres IP</th><th class=\"name-header-cell\">Login</th><th class=\"name-header-cell\">Status</th></tr></thead><tbody><tr ng-repeat=\"log in vm.data.logs | orderBy:\'-ts\'\"><td class=\"hidden-xs\">{{$index+1}}</td><td class=\"hidden-xs\">{{log.type}}</td><td>{{log.data}}</td><td>{{vm.Date(log.ts)}}</td><td>{{log.ip}}</td><td>{{log.login ? log.login : vm.data.client.login}}</td><td><a ng-class=\"[{\'btn-ok\' : log.success}, {\'btn-remove\' : !log.success}]\" title=\"{{log.success ? \'<p>Sukces</p>\' : \'<p>Porażka</p>\'}}\" data-toggle=\"tooltip\" data-placement=\"right\" tooltip></a></td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/agreements/agreements.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-9 col-md-push-3\"><h2 class=\"no-m-top\">Umowy</h2></div></div><div class=\"row\"><div class=\"col-md-3 panel panel-filters\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED id=\"filters-panel\" --><form><div class=\"panel panel-default\" has-authority=\"ROLE_EMPLOYEE\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#clientCode\" href class=\"collapsed\">KOD KLIENTA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"clientCode\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Kod klienta\" class=\"form-control\" ng-model=\"vm.filter.query.login\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#agreementNr\" href class=\"collapsed\">NR UMOWY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"agreementNr\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Nr umowy\" class=\"form-control\" ng-model=\"vm.filter.query.agreement_nr\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#dateIssue\" href class=\"collapsed\">DATA ZAWARCIA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"dateIssue\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.agreement_date_from\" data-max=\"{{vm.filter.query.agreement_date_to}}\" data-placement=\"auto right\" family=\"issue\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.agreement_date_to\" data-min=\"{{vm.filter.query.agreement_date_from}}\" data-placement=\"auto right\" family=\"issue\"></datepicker></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#dateEnd\" href class=\"collapsed\">PLANOWANA DATA ZAKOŃCZENIA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"dateEnd\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.end_plan_date_from\" data-max=\"{{vm.filter.query.end_plan_date_to}}\" max-constraint=\"false\" data-placement=\"auto right\" family=\"end\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.end_plan_date_to\" data-min=\"{{vm.filter.query.end_plan_date_from}}\" max-constraint=\"false\" data-placement=\"auto right\" family=\"end\"></datepicker></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#subject\" href class=\"collapsed\">PRZEDMIOT UMOWY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"subject\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Przedmiot umowy\" class=\"form-control\" ng-model=\"vm.filter.query.subject\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#registration_number\" href class=\"collapsed\">NUMER REJESTRACYJNY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"registration_number\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Numer rejestracyjny\" class=\"form-control\" ng-model=\"vm.filter.query.registration_number\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#status\" href class=\"collapsed\">STATUS <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"status\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Status\" class=\"form-control\" ng-model=\"vm.filter.query.status\"></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getAgreements($event)\">Wyszukaj</button></div></form></div></div></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"fDataSet\" class=\"[ card card-dataset ]\" ng-show=\"$root.Info.infos[\'agreements\'].length + $root.Info.statements[\'agreements\'].length + $root.Info.errors[\'agreements\'].length > 0 || vm.data.result.agreements.length !=0 \"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><infos></infos><errors></errors><statements></statements><div class=\"table-responsive\" ng-show=\"vm.data.result.agreements.length !=0 \"><table class=\"table table-users table-hover no-first-last-padding\"><thead><tr style=\"border-style: hidden\"><th></th><th class=\"sort-header-cell\"><span ng-class=\"[{ \'glyphicon glyphicon-chevron-down\' : (vm.sort.indexOf( \'-agreement_nr\')==0 )},{ \'glyphicon glyphicon-chevron-up\' : (vm.sort.indexOf( \'+agreement_nr\')==0 )}] \" aria-hidden=\"true \"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{ \'glyphicon glyphicon-chevron-down\' : (vm.sort.indexOf( \'-agreement_date\')==0 )},{ \'glyphicon glyphicon-chevron-up\' : (vm.sort.indexOf( \'+agreement_date\')==0 )}] \" aria-hidden=\"true \"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{ \'glyphicon glyphicon-chevron-down\' : (vm.sort.indexOf( \'-end_plan_date\')==0 )},{ \'glyphicon glyphicon-chevron-up\' : (vm.sort.indexOf( \'+end_plan_date\')==0 )}] \" aria-hidden=\"true \"></span></th><th class=\"sort-header-cell\"></th><th class=\"sort-header-cell hidden-xs\"><span ng-class=\"[{ \'glyphicon glyphicon-chevron-down\' : (vm.sort.indexOf( \'-registration_number\')==0 )},{ \'glyphicon glyphicon-chevron-up\' : (vm.sort.indexOf( \'+registration_number\')==0 )}] \" aria-hidden=\"true \"></span></th><th class=\"sort-header-cell hidden-xs\"><span ng-class=\"[{ \'glyphicon glyphicon-chevron-down\' : (vm.sort.indexOf( \'-status\')==0 )},{ \'glyphicon glyphicon-chevron-up\' : (vm.sort.indexOf( \'+status\')==0 )}] \" aria-hidden=\"true \"></span></th></tr><tr><th>Lp.</th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy( \'agreement_nr\') \" href title=\"Sortuj po numerze umowy.\" tooltip>Nr umowy</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy( \'agreement_date\') \" href title=\"Sortuj po dacie zawarcia umowy.\" tooltip>Data zawarcia</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy( \'end_plan_date\') \" href title=\"Sortuj po dacie zakończenia umowy.\" tooltip>Planowana data zakończenia</a></th><th class=\"name-header-cell\">Przedmioty umowy</th><th class=\"name-header-cell hidden-xs\"><a ng-click=\"vm.sortBy(\'registration_number\') \" href title=\"Sortuj po numerze rejestracyjnym.\" tooltip>Nr rejestracyjny</a></th><th class=\"name-header-cell hidden-xs\"><a ng-click=\"vm.sortBy( \'status\') \" href title=\"Sortuj po statusie umowy.\" tooltip>Status</a></th></tr></thead><tbody><tr ng-repeat=\"agreement in vm.data.result.agreements | orderBy:vm.sort \"><td>{{$index+1}}</td><td>{{agreement.agreement_nr}}</td><td>{{vm.Date(agreement.agreement_date)}}</td><td>{{vm.Date(agreement.end_plan_date)}}</td><td>{{agreement.subjects[0]}}<br><span ng-if=\"agreement.subjects.length > 1\" style=\"font-weight:strong\"><a style=\"font-weight:500\" data-html=\"true\" data-trigger=\"manual\" data-placement=\"top\" subjects=\"{{agreement.subjects}}\" href>Pokaż wszystkie...</a></span></td><td class=\"hidden-xs\">{{agreement.registration_number == null ? \'-\' : agreement.registration_number}}</td><td class=\"hidden-xs\">{{agreement.status}}</td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/communique/communique.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Komunikat</h2></div></div><div class=\"row\"><div class=\"col-md-8\"><div><!-- ./less/card-dataset.less --><div class=\"row\"><label for=\"opass\" class=\"control-label\">Data od</label><datepicker id=\"dateStart\" placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.end_plan_date_from\" data-placement=\"auto right\" family=\"issue\"></datepicker></div><div class=\"row\"><label for=\"opass\" class=\"control-label\">Data do</label><datepicker id=\"dateEnd\" placeholder=\"Od\" name=\"from\" ng-model=\"vm.filter.query.end_plan_date_to\" class=\"date-picker form-control\" max-constraint=\"false\" data-placement=\"auto right\" family=\"end\"></datepicker></div><div class=\"row\"><label for=\"opass\" class=\"control-label\">Linia 1</label><input type=\"text\" id=\"lane1\" class=\"form-control\" placeholder=\"Linia 1\" ng-model=\"vm.communique.line1\"></div><div class=\"row\"><label for=\"opass\" class=\"control-label\">Linia 2</label><input type=\"text\" id=\"lane2\" class=\"form-control\" placeholder=\"Linia 2\" ng-model=\"vm.communique.line2\"></div></div><!-- end .card-dataset --></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary btn-fill btn-round\" ng-click=\"vm.updateCommunique($event)\">Aktualizuj</button></div></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/documents/documents.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-6 col-md-push-3\"><h2 class=\"no-m-top\">Faktury i noty</h2></div><div class=\"col-md-3 col-md-push-3\"><div class=\"row form-group\"><div class=\"col-xs-12\"><a class=\"pull-right btn btn-primary btn-round\" ng-click=\"vm.downloadExcel($event)\" ng-disabled=\"vm.data.result.documents.length == 0\">POBIERZ JAKO XLS</a></div><div class=\"col-xs-12\" has-authority=\"ROLE_EMPLOYEE\"><a class=\"pull-right btn btn-primary btn-round\" ng-click=\"vm.downloadMergedPDF()\" ng-disabled=\"vm.data.result.documents.length == 0\">POBIERZ JAKO PDF</a></div></div></div></div><div class=\"row\"><div class=\"col-md-3 panel panel-filters\" style=\"z-index:1\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><form><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED id=\"filters-panel\" --><div class=\"panel panel-default\" has-authority=\"ROLE_EMPLOYEE\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#clientCode\" href class=\"collapsed\">KOD KLIENTA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"clientCode\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Kod klienta\" class=\"form-control\" ng-model=\"vm.filter.query.login\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docNr1Collapse\" href class=\"collapsed\">NR UMOWY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docNr1Collapse\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Numer umowy\" class=\"form-control\" ng-model=\"vm.filter.query.agreement_nr\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docNrSecond\" href class=\"collapsed\">NR DOKUMENTU <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docNrSecond\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Numer dokumentu\" class=\"form-control\" ng-model=\"vm.filter.query.document_nr\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docNrKsef\" href class=\"collapsed\">NR KSEF <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docNrKsef\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Numer KSeF\" class=\"form-control\" ng-model=\"vm.filter.query.ksef_nr\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docDateCreation\" href class=\"\">DATA WYSTAWIENIA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docDateCreation\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_issue_from\" data-max=\"{{vm.filter.query.date_issue_to}}\" data-placement=\"auto right\" family=\"issue\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_issue_to\" data-min=\"{{vm.filter.query.date_issue_from}}\" data-placement=\"auto right\" family=\"issue\"></datepicker></div></div></div></div></div><div class=\"panel panel-default\" has-authority=\"ROLE_EMPLOYEE\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#isDocRead\" href class=\"collapsed\">PRZECZYTANY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"isDocRead\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><select name=\"huge\" class=\"selectpicker form-control\" data-style=\"form-control\" data-menu-style=\"\" ng-model=\"vm.filter.query.isOpened\"><option value=\"\" selected=\"selected\">Wszystkie</option><option value=\"true\">Tak</option><option value=\"false\">Nie</option></select></div></div></div></div><div class=\"panel panel-default\" has-authority=\"ROLE_EMPLOYEE\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docDateOpen\" href class=\"collapsed\">DATA OTWARCIA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docDateOpen\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_document_open_from\" data-max=\"{{vm.filter.query.date_document_open_to}}\" data-placement=\"auto right\" family=\"open\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_document_open_to\" data-min=\"{{vm.filter.query.date_document_open_from}}\" data-placement=\"auto right\" family=\"open\"></datepicker></div></div></div></div></div><div class=\"panel panel-default\" has-authority=\"ROLE_EMPLOYEE\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docDatePayment\" href class=\"collapsed\">TERMIN PŁATNOŚCI <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docDatePayment\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_payment_from\" data-max=\"{{vm.filter.query.date_payment_to}}\" data-placement=\"auto right\" family=\"payment\" max-constraint=\"false\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.query.date_payment_to\" data-min=\"{{vm.filter.query.date_payment_from}}\" data-placement=\"auto right\" family=\"payment\" max-constraint=\"false\"></datepicker></div></div></div></div></div><div class=\"panel panel-default\" style=\"max-height: 100px; z-index: 1\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docType\" href class=\"collapsed\" ng-click=\"vm.getDocumentTypes($event)\">TYP DOKUMENTU <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docType\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><select id=\"docTypeDropdown\" class=\"form-control\" multiple=\"multiple\"></select></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#priceRange\" href class=\"collapsed\">KWOTA NETTO <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"priceRange\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-5 input-col\"><amount id=\"total_netto_from\" class=\"form-control\" placeholder=\"Od\" ng-model=\"vm.filter.query.total_netto_from\" data-max=\"{{vm.filter.query.total_netto_to}}\"></amount></div><div class=\"col-xs-2\"><label class=\"form-control-label to dash-v-spacer\" for=\"to\">-</label></div><div class=\"col-xs-5 input-col\"><amount id=\"total_netto_to\" class=\"form-control\" placeholder=\"Do\" ng-model=\"vm.filter.query.total_netto_to\" data-min=\"{{vm.filter.query.total_netto_from}}\"></amount></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#docCurrency\" href class=\"collapsed\">WALUTA <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"docCurrency\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><select name=\"huge\" class=\"selectpicker form-control\" data-style=\"form-control\" data-menu-style=\"\" ng-model=\"vm.filter.query.currency\"><option value=\"\" selected=\"selected\">Wszystkie</option><option value=\"PLN\">PLN</option><option value=\"EUR\">EUR</option></select></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getDocuments($event)\">Wyszukaj</button></div></div></div></form></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"fDataSet\" class=\"[ card card-dataset ]\" ng-show=\"$root.Info.infos[\'documents\'].length + $root.Info.statements[\'documents\'].length + $root.Info.errors[\'documents\'].length > 0 || vm.data.result.documents.length !=0\"><!-- less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><infos></infos><errors></errors><statements></statements><div class=\"table-responsive\" ng-show=\"vm.data.result.documents.length !=0\"><div class=\"info comm\"><span class=\"info-left comm-left glyphicon glyphicon-info-sign\"></span> <span>Opóźnienia w prezentacji dokumentów mogą wynikać z trwającego procesu księgowania.</span></div><table class=\"table table-small-text table-hover no-first-last-padding\"><thead><tr style=\"border-style: hidden\"><th class=\"sort-header-cell visible-lg\"></th><th class=\"sort-header-cell visible-lg\" has-authority=\"ROLE_EMPLOYEE\"></th><th class=\"sort-header-cell visible-lg\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'agreement_nr\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'agreement_nr\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'document_type\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'document_type\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'document_nr\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'document_nr\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'ksef_nr\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'ksef_nr\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"hidden-xs sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'date_issue\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'date_issue\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell visible-lg\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'invoice_reference\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'invoice_reference\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'date_payment\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'date_payment\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'total_netto\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'total_netto\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"visible-lg sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'total_vat\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'total_vat\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"visible-lg sort-header-cell\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'total_brutto\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'total_brutto\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"visible-lg sort-header-cell\" has-authority=\"ROLE_EMPLOYEE\"><span ng-class=\"[{\'glyphicon glyphicon-chevron-down\' : vm.isSortedWithOrder(\'date_document_open\', \'DESC\')},\n                                                        {\'glyphicon glyphicon-chevron-up\' : vm.isSortedWithOrder(\'date_document_open\', \'ASC\')}]\" aria-hidden=\"true\"></span></th><th class=\"sort-header-cell\"></th></tr><tr><th class=\"no-border visible-lg name-header-cell\"></th><th class=\"visible-lg name-header-cell\" has-authority=\"ROLE_EMPLOYEE\">Klient</th><th class=\"visible-lg name-header-cell\"><a ng-click=\"vm.sortBy(\'agreement_nr\')\" href title=\"Sortuj po numerze umowy.\" tooltip>Umowa</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy(\'document_type\')\" href title=\"Sortuj po typie dokumentu.\" tooltip>Typ dokumentu</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy(\'document_nr\')\" href title=\"Sortuj po numerze dokumentu.\" tooltip>Dokument</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy(\'ksef_nr\')\" href title=\"Sortuj po numerze KSeF.\" tooltip>Numer KSeF</a></th><th class=\"hidden-xs name-header-cell\"><a ng-click=\"vm.sortBy(\'date_issue\')\" href title=\"Sortuj po dacie wystawienia.\" tooltip>Data wystawienia</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy(\'invoice_reference\')\" href title=\"Sortuj po pierwotnej FV.\" tooltip>FV pierwotna</a></th><th class=\"name-header-cell\"><a ng-click=\"vm.sortBy(\'date_payment\')\" href title=\"Sortuj po terminie płatności.\" tooltip>Termin płatności</a></th><th class=\"text-right name-header-cell\"><a ng-click=\"vm.sortBy(\'total_netto\')\" href title=\"Sortuj po kwocie netto.\" tooltip>Kwota netto</a></th><th class=\"text-right visible-lg name-header-cell\"><a ng-click=\"vm.sortBy(\'total_vat\')\" href title=\"Sortuj po kwocie VAT.\" tooltip>Kwota VAT</a></th><th class=\"text-right visible-lg name-header-cell\"><a ng-click=\"vm.sortBy(\'total_brutto\')\" href title=\"Sortuj po kwocie brutto.\" tooltip>Kwota brutto</a></th><th class=\"text-right visible-lg name-header-cell\" has-authority=\"ROLE_EMPLOYEE\"><a ng-click=\"vm.sortBy(\'date_document_open\')\" href title=\"Sortuj po dacie otwarcia.\" tooltip>Otwarty</a></th><th class=\"visible-lg name-header-cell\">E-faktura</th></tr></thead><tbody><tr document data-js-slide-table-trigger=\"#st1\" ng-repeat=\"document in vm.data.result.documents\" ng-class=\"{unreadDoc: !vm.isDocumentRead(document)}\" ng-click=\"vm.downloadDocument($index, document)\" ng-style=\"{\'cursor\':  (!vm.client || document.e_invoice) ? \'pointer\' : \'default\'}\" title=\"{{document.additional_info}}\" data-placement=\"bottom\" data-container=\"body\" tooltip></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"card card-plain card-summary\"><div class=\"content text-center\" ng-show=\"vm.data.result.documents.length != 0\"><div class=\"col-sm-6 col-xs-12\"><p class=\"text-center\">Suma dokumentów prezentowanych powyżej:</p></div><div class=\"col-sm-2 col-xs-4\"><p class=\"row\" style=\"margin-bottom: 5px\">Kwota netto</p><p class=\"row bold\" style=\"margin-bottom:2px\" ng-repeat=\"result in vm.data.result.sumTotalNetto\">{{result}}</p></div><div class=\"col-sm-2 col-xs-4\"><p class=\"row\" style=\"margin-bottom: 5px\">Kwota VAT</p><p class=\"row bold\" style=\"margin-bottom:2px\" ng-repeat=\"result in vm.data.result.sumTotalVat\">{{result}}</p></div><div class=\"col-sm-2 col-xs-4\"><p class=\"row\" style=\"margin-bottom: 5px\">Kwota brutto</p><p class=\"row bold\" style=\"margin-bottom:2px\" ng-repeat=\"result in vm.data.result.sumTotalGross\">{{result}}</p></div></div></div></div></div><div class=\"row actionButtons\" ng-if=\"vm.data.result.documents.length > 0\"><div class=\"col-sm-6 text-left\"><button class=\"btn btn-primary btn-round\" ng-disabled=\"vm.page.number <= 1\" ng-click=\"vm.first()\"><i class=\"fa fa-step-backward\"></i> <span>Pierwsza</span></button> <button class=\"btn btn-primary btn-round\" ng-disabled=\"vm.page.number <= 1\" ng-click=\"vm.previous()\"><i class=\"fa fa-chevron-left\"></i> <span>Poprzednia</span></button></div><div class=\"col-sm-6 text-right\"><button class=\"btn btn-primary btn-round\" ng-disabled=\"vm.page.number >= vm.page.totalPages\" ng-click=\"vm.next()\"><span>Następna</span> <i class=\"fa fa-chevron-right\"></i></button> <button class=\"btn btn-primary btn-round\" ng-disabled=\"vm.page.number >= vm.page.totalPages\" ng-click=\"vm.last()\"><span>Ostatnia</span> <i class=\"fa fa-step-forward\"></i></button></div><div class=\"col-sm-12 text-center\"><p class=\"row\" style=\"margin-bottom: 5px\">Strona {{vm.page.number}} z {{vm.page.totalPages}}</p></div><div class=\"row actionButtons text-center\" ng-if=\"vm.data.result.documents.length > 0 && vm.page.totalPages > 1\"><div class=\"col-lg-4 col-lg-offset-4\"><div class=\"input-group col-sm-1 text-center\"><input type=\"number\" class=\"form-control\" ng-model=\"vm.page.newNumber\" style=\"margin-right: 5px;border: 1px solid #e3e3e3; border-radius: 4px\"> <span class=\"input-group-btn\" style=\"display:block\"><button class=\"btn btn-primary btn-round\" style=\"margin-top: 0\" ng-click=\"vm.open()\"><span>Przejdź do strony</span></button></span></div></div></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div>");
$templateCache.put("app/views/emailChange/emailChange-Fail-2013.html","<h4>Przepraszamy, przesłany link został już otwarty. Prosimy ponowić proces zmiany adresu e-mail.</h4>");
$templateCache.put("app/views/emailChange/emailChange-Fail-2016.html","<h4>Przepraszamy, przesłany link stracił swoją ważność. Prosimy ponowić proces zmiany adresu e-mail.</h4>");
$templateCache.put("app/views/emailChange/emailChange-Fail-208.html","<h4>Nie ma prośby zmiany adresu-email o podanym tokenie w bazie.</h4><h4>Proszę sprawdzić poprawność adresu.</h4>");
$templateCache.put("app/views/emailChange/emailChange-Fail.html","<div ui-view=\"fail\" ng-cloak></div><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"{{fromState.name || \'documents\'}}\">Powrót</button></div>");
$templateCache.put("app/views/emailChange/emailChange-Success.html","<h4>Adres e-mail w Portalu VB Leasing został zmieniony.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"{{fromState.name || \'login\'}}\">Powrót</button></div>");
$templateCache.put("app/views/emailChange/emailChange.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Zmiana adresu e-mail w portalu VB Leasing</h2><div ui-view=\"step\"></div></div></div></div></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/error/401.html","<div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Nie jesteś zalogowany</h2></div></div><div class=\"row\"><div class=\"col-md-12\"><h7 class=\"no-m-top\" style=\"text-align: left\">Twoja sesja wygasła lub zostałeś wylogowany.<br><b>Zaloguj się ponownie.</b></h7></div></div><div class=\"row error-footer border-dotted-top\"><a ui-sref=\"login\" class=\"btn btn-primary btn-round btn-fill\">Zaloguj</a></div>");
$templateCache.put("app/views/error/403.html","<div class=\"row\"><div class=\"col-md-8\"><h2 class=\"no-m-top\">Nie masz dostępu do tego zasobu</h2></div></div><div class=\"row\"><div class=\"col-md-8\"><h7 class=\"no-m-top\" style=\"text-align: left\">Nie masz uprawnień, żeby oglądać ten zasób.</h7></div></div><div class=\"row error-footer border-dotted-top\"><a ui-sref=\"login\" class=\"btn btn-primary btn-round btn-fill\">Powrót</a></div>");
$templateCache.put("app/views/error/404.html","<div class=\"row\"><div class=\"col-md-8\"><h2 class=\"no-m-top\">Podana strona nie istnieje</h2></div></div><div class=\"row\"><div class=\"col-md-8\"><h7 class=\"no-m-top\" style=\"text-align: left\">Prawdopodobnie wpisałeś zły adres lub kliknąłeś w nieważny link.</h7></div></div><div class=\"row error-footer border-dotted-top\"><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"{{fromState.name || \'login\'}}\">Powrót</button></div>");
$templateCache.put("app/views/error/error.html","<div class=\"section\"><div class=\"container\"><div class=\"card card-login error-card\"><div ui-view=\"error\"></div></div></div></div><!-- section -->");
$templateCache.put("app/views/faq/faq.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-8\"><h2>Najczęściej zadawane pytania</h2><div class=\"row section\"><div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\"><!-- .panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingOne\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a1\" aria-expanded=\"false\" aria-controls=\"a1\">Jak zmienić hasło? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a1\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingOne\"><div class=\"panel-body\"><p>Zmiana hasła możliwa jest po wybraniu zakładki <a href ui-sref=\"settings\">Ustawienia</a> z głównego menu portalu. W sekcji Zmiana hasła należy podać obecne hasło, wpisać dwukrotnie nowe a następnie kliknąć przycisk Zapisz znajdujący się poniżej. Jeśli procedura przebiegnie prawidłowo, na górze strony zostanie wyświetlony komunikat potwierdzający poprawną zmianę hasła.</p></div><!-- /.panel-body --></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingTwo\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a2\" href aria-expanded=\"false\" aria-controls=\"a2\">Jak zmienić kontaktowy adres e-mail? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a2\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingTwo\"><div class=\"panel-body\"><p>W celu zmiany adresu e-mail przypisanego do konta użytkownika należy przejść do zakładki <a href ui-sref=\"settings\">Ustawienia</a> głównego menu portalu. Tam w sekcji Zmiana adresu e-mail należy podać nowy adres e-mail, kliknąć przycisk Zapisz, a następnie zatwierdzić zmianę poprzez odebranie wiadomości wysłanej automatycznie na nowy adres e-mail i kliknięcie zawartego w niej linku potwierdzającego.</p><p>Jeśli w skrzynce odbiorczej e-mail przez dłuższy czas nie pojawia się wiadomość z linkiem potwierdzającym, należy sprawdzić, czy nie została ona automatycznie oznakowana jako SPAM i przeniesiona do folderu z wiadomościami niechcianymi.</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingThree\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a3\" href aria-expanded=\"false\" aria-controls=\"a3\">Jak aktywować usługę e-dokumenty? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a3\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingThree\"><div class=\"panel-body\"><p>Jeśli usługa e-dokumenty jest nieaktywna, w zakładce <a href ui-sref=\"settings\">Ustawienia</a> głównego menu portalu w sekcji Usługa e-dokumenty należy zaakceptować oświadczenie potwierdzające znajomość regulaminu usługi oraz przesłać je do VB Leasing, klikając przycisk Wyślij. Jeżeli aktywacja przebiegła poprawnie na górze strony pojawi się informujący o tym komunikat, a w sekcji Usługa e-dokumenty status usługi zmieni się na Aktywna. Po wyrażeniu zgody będzie możliwe pobieraniae z Portalu nowo wystawionych e-dokumentów (not odsetkowych, uznaniowych, obciążeniowych). Wszystkie faktury dostępne będą do pobrania i wydrukowania wyłącznie w Krajowym Systemie e Faktur (KSeF).</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingFour\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a4\" href aria-expanded=\"false\" aria-controls=\"a4\">Jak wydrukować e-dokument? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a4\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingFour\"><div class=\"panel-body\"><p>Wszystkie faktury wystawione od 01.02.2026 dostępne są do pobrania i wydrukowania wyłącznie w Krajowym Systemie e Faktur (KSeF). Żeby wydrukować e-dokument (bez nr KSeF) należy zlokalizować go w tabeli w zakładce \"Faktury i noty\" w głównym menu portalu. Po kliknięciu odpowiedniego wiersza, wyświetli się jego podgląd. W prawym górnym rogu okienka podglądu dostępna jest opcja \"Pobierz podgląd PDF\", którą należy wybrać. Po pobraniu i otwarciu pliku z menu programu służącego do wyświetlania plików PDF, wybrać opcję Drukuj.</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingFive\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a6\" href aria-expanded=\"false\" aria-controls=\"a6\">Jak wyłączyć usługę e-dokumentów? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a6\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingFive\"><div class=\"panel-body\"><p>W celu dezaktywacji usługi e-dokumentów należy przesłać zgłoszenie na adres e-mail <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a></p><p>Należy zwrócić uwagę, że po rezygnacji z usługi zarówno nowo wystawiane, jak i archiwalne e-dokumenty nie będą dostępne z poziomu portalu. Dlatego przed złożeniem wniosku zalecamy zadbanie o ich archiwizację.</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingSix\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a7\" href aria-expanded=\"false\" aria-controls=\"a7\">Jak zrezygnować z dostępu do Portalu VB Leasing? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a7\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingSix\"><div class=\"panel-body\"><p>Aby zrezygnować z dostępu do Portalu VB Leasing proszę przesłać zgłoszenie na adres e-mail <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a></p><p>Należy zwrócić uwagę, że po rezygnacji z usługi dostęp do portalu wraz z możliwością wglądu do archiwizowanych tam dokumentów zostanie zablokowany, dlatego przed złożeniem wniosku należy zadbać o ich archiwizację.</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingSeven\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a8\" href aria-expanded=\"false\" aria-controls=\"a8\">Dlaczego nie mogę znaleźć faktury? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a8\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingSeven\"><div class=\"panel-body\"><p>W zakładce Faktury i noty głównego menu portalu informacja o wystawionej fakturze może nie być widoczna od razu. Wynika to z trwającego procesu księgowania faktur i po jego zakończeniu informacja o wystawionej fakturze będzie widoczna na portalu. Wszystkie faktury wystawione od 01.02.2026 są dostępne do pobrania i wydrukowania wyłącznie w Krajowym Systemie e-Faktur (KSeF).</p><p>Oznacza to, że faktury wystawione od 1 lutego 2026 r. nie są już widoczne na Portalu VBL. Aby pobrać fakturę, zaloguj się do aplikacji podatnika KSeF i odszukać ją w zakładce \"Lista faktur\". Więcej na stronie ksef.podatki.gov.pl.</p></div><!-- /.panel-body --></div></div><!-- /.panel --><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingEight\"><div class=\"panel-title\"><a role=\"button\" class=\"collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#a9\" href aria-expanded=\"false\" aria-controls=\"a9\">Czym jest podpis cyfrowy? <i class=\"fa fa-chevron-up pull-right\"></i></a></div></div><div id=\"a9\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingEight\"><div class=\"panel-body\"><p>Podpis cyfrowy jest używany do uwierzytelniania informacji cyfrowych takich jak dokumenty, wiadomości e-mail i makra za pomocą kryptografii komputerowej. Podpisy cyfrowe dają następujące gwarancje:</p><p>Autentyczność: Podpis cyfrowy gwarantuje, że osoba podpisująca jest tym, za kogo się podaje.</p><p>Integralność: Podpis cyfrowy gwarantuje, że zawartość nie została zmieniona od czasu złożenia podpisu cyfrowego.</p><p>Niemożność wyparcia się: Podpis cyfrowy jest gwarantem dla wszystkich stron, że podpisana zawartość jest oryginalna. Możliwość wyparcia się odnosi się do sytuacji, w której osoba podpisująca odrzuca jakiekolwiek powiązanie z podpisaną zawartością.</p></div><!-- /.panel-body --></div></div></div><!-- /.panel-group --></div></div><div class=\"about-aside col-xs-12 col-md-4 pull-right\"><h3>Gdzie mogę uzyskać więcej informacji?</h3><p>Kontakt z Działem Obsługi Klienta:</p><p><a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a></p><p>Adres korespondencyjny:</p><p>VB Leasing S.A. w restrukturyzacji<br>ul. Fabryczna 6<br>53-609 Wrocław</p></div></div></div><!-- /.container -->");
$templateCache.put("app/views/login/login.html","<div class=\"section login\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-lg-8 col-lg-push-2\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><h2 class=\"no-m-top no-m-bottom\">Zaloguj się do<br>Portalu VB Leasing<!--                                    <img class=\"fpk\" src=\"img/FPK.png\">--></h2></div></div><form id=\"loginForm\" class=\"row form-horizontal no-m-top\" autocomplete=\"off\"><div class=\"col-xs-12\"><errors class=\"row\"></errors><statements class=\"row\"></statements><div class=\"row form-group\"><label for=\"iLogin\" class=\"col-sm-2 control-label\">Kod klienta</label><div class=\"col-sm-6\"><input type=\"text\" ng-pattern=\"/^.{0,128}$/\" class=\"form-control\" id=\"iLogin\" placeholder=\"\" ng-model=\"vm.credentials.login\" data-pattern-tooltip=\"Login nie może być dłuższy niż 128 znaków.\"></div></div><div class=\"row form-group\"><label for=\"iPass\" class=\"col-sm-2 control-label\">Hasło</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"iPass\" placeholder=\"\" autocomplete=\"new-password\" ng-model=\"vm.credentials.password\"></div></div><div class=\"row form-group\"><div class=\"col-sm-offset-2 col-sm-6\"><div class=\"text-center pull-right\">Nie pamiętasz <a href ui-sref=\"passwordReset\">hasła</a>?<br><button type=\"submit\" ng-click=\"vm.login()\" class=\"btn btn-140 btn-primary btn-round btn-fill\">Zaloguj</button></div></div></div></div></form><div class=\"row border-dotted-top login-footer-vertical-align\"><div class=\"col-sm-5 col-xs-12 login-footer-center\"><h5 class=\"no-m-top no-m-bottom\">Nie masz dostępu do portalu?</h5></div><div class=\"col-sm-3 col-xs-12\"><div class=\"text-center pull-right login-footer-center\"><a ui-sref=\"register1\" class=\"pull-right btn btn-primary btn-round\">Rejestracja</a></div></div></div></div></div><div id=\"loader\" class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Wczytywanie portalu...</p></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/newClientEmail/newClientEmail.html","<div class=\"section\"><div class=\"section\"><div class=\"container-fluid\"><infos></infos><errors></errors><statements></statements><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Aktualizacja adresu e-mail klienta {{vm.data.login}} - VB Leasing</h2></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"[ card ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><form class=\"form form-horizontal\" id=\"newUserEmailForm\" name=\"newUserEmailForm\"><div class=\"form-group row\"><label for=\"email\" class=\"col-md-5 control-label uppercase\">Nowy e-mail</label><div class=\"col-md-7\"><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.newValue\" data-new-email></email></div></div><div class=\"form-group row\"><label for=\"re-email\" class=\"col-md-5 control-label uppercase\">Powtórz e-mail</label><div class=\"col-md-7\"><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.newRepeat\" data-repeat-email></email></div></div><div class=\"buttons-row\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"newUserEmailForm.$invalid || newUserEmailForm.$pending\" ng-click=\"vm.changeUserEmail()\">AKTUALIZUJ</button></div></form></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .container --></div><!-- .section --></div>");
$templateCache.put("app/views/newRole/newRole.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Role użytkowników - nowa rola</h2></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"[ card ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><form class=\"form form-horizontal\" action=\"\"><div class=\"form-group row\"><label for=\"fName\" class=\"col-md-5 control-label uppercase\">Nazwa</label><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" id=\"fName\" placeholder=\"Nazwa\" ng-model=\"vm.data.label\" ng-pattern=\"/^.{0,256}$/\" required=\"required\" data-pattern-tooltip=\"Podana nazwa jest za długa.\"></div></div><div class=\"form-group row\"><label for=\"fTechName\" class=\"col-md-5 control-label uppercase\">Nazwa techniczna</label><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" id=\"fTechName\" placeholder=\"Nazwa techniczna\" ng-required=\"required\" ng-model=\"vm.data.name\" ng-pattern=\"/^.{0,64}$/\" required=\"required\" data-pattern-tooltip=\"Podana nazwa techniczna jest za długa.\"></div></div><div ng-repeat=\"permission in vm.data.permissions | orderBy:[\'+label\']\"><input type=\"checkbox\" id=\"checkbox{{$index}}\" ng-model=\"permission.checked\"><label class=\"checkbox\" for=\"checkbox{{$index}}\" style=\"display:inline\">{{permission.label}}</label></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"!(vm.data.name && vm.data.label)\" ng-click=\"vm.createRole()\">Dodaj</button> <button type=\"submit\" class=\"btn btn-primary btn-round\" ui-sref=\"roles\">Anuluj</button></div></form></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/newUser/newUser.html","<div class=\"section\"><div class=\"section\"><div class=\"container-fluid\"><infos></infos><errors></errors><statements></statements><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Nowy użytkownik - VB Leasing</h2></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"[ card ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><form class=\"form form-horizontal\" id=\"newUserForm\" name=\"newUserForm\"><div class=\"form-group row\"><label for=\"fName\" class=\"col-md-5 control-label uppercase\">Login</label><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" id=\"fName\" placeholder=\"Login\" ng-model=\"vm.data.login\" ng-pattern=\"/^.{0,128}$/\" required=\"required\" data-pattern-tooltip=\"Podany login jest za długi.\"></div></div><div class=\"form-group row\"><label for=\"fTechName\" class=\"col-md-5 control-label uppercase\">E-mail</label><div class=\"col-md-7\"><email type=\"email\" class=\"form-control\" id=\"fTechName\" placeholder=\"E-mail\" ng-model=\"vm.data.email\" required=\"required\"></div></div><div class=\"buttons-row\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"newUserForm.$invalid || newUserForm.$pending\" ng-click=\"vm.createUser()\">DODAJ</button></div></form></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .container --></div><!-- .section --></div>");
$templateCache.put("app/views/newUserEmail/newUserEmail.html","<div class=\"section\"><div class=\"section\"><div class=\"container-fluid\"><infos></infos><errors></errors><statements></statements><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Aktualizacja adresu e-mail użytkownika {{vm.data.email.login}} - VB Leasing</h2></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"[ card ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><form class=\"form form-horizontal\" id=\"newUserEmailForm\" name=\"newUserEmailForm\"><div class=\"form-group row\"><label for=\"email\" class=\"col-md-5 control-label uppercase\">Nowy e-mail</label><div class=\"col-md-7\"><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.email.newValue\" data-new-email></email></div></div><div class=\"form-group row\"><label for=\"re-email\" class=\"col-md-5 control-label uppercase\">Powtórz e-mail</label><div class=\"col-md-7\"><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.email.newRepeat\" data-repeat-email></email></div></div><div class=\"buttons-row\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"newUserEmailForm.$invalid || newUserEmailForm.$pending\" ng-click=\"vm.changeUserEmail()\">AKTUALIZUJ</button></div></form></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .container --></div><!-- .section --></div>");
$templateCache.put("app/views/password/password.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-8\"><h2 class=\"no-m-top\">Reset hasła do Portalu VB Leasing</h2><p>Aby nadać nowe hasło, wpisz kod klienta oraz adres e-mail podany podczas rejestracji do Portalu.</p><form id=\"loginForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"iLogin\" class=\"col-md-3 control-label\">Kod klienta</label><div class=\"col-md-6\"><input type=\"email\" class=\"form-control\" id=\"iLogin\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"email\" class=\"col-md-3 control-label\">E-mail</label><div class=\"col-md-6\"><input type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-8\"><button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\">Wyślij</button></div></div></form><script>$(function() {\n                                    $(\"#loginForm\").submit(function(event) {\n                                        event.preventDefault();\n                                        $(this).addClass(\'form-success\');\n                                        $(\'.loader\').removeClass(\'hidden\');\n                                    });\n                                });</script></div><div class=\"col-md-4\"><div class=\"promo\"><img src=\"img/promo/login-promo.png\" alt=\"\"><p class=\"text-primary\">Korzystając z elektronicznego Portalu VB Leasing, możesz liczyć na atrakcjne zniżki!</p></div></div></div><div class=\"row border-dotted-top\"><br><br><div class=\"col-md-4\"><h5 class=\"no-m-top\" style=\"margin-top: 10px\">Nie masz dostępu do portalu?</h5></div><div class=\"col-md-8 text-right\"><a href=\"\" class=\"btn btn-primary btn-round\">Sprawdź, jak uzyskać dostęp.</a> <a href=\"\" class=\"btn btn-primary btn-round\">Zobacz demo portalu.</a></div></div></div></div><div class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Wczytywanie...</p></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/passwordExpired/passwordExpired-Change.html","<h2 class=\"no-m-top\">Twoje hasło straciło ważność</h2><errors></errors><statements></statements><p>Wprowadź nowe hasło.</p><form id=\"confirmForm\" name=\"confirmForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"npass\" class=\"control-label col-md-3\">Nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control hidden\" required=\"required\" ng-model=\"vm.data.currentValue\" data-old-password></pass><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.newValueFirst\" data-new-password></pass></div></div><div class=\"form-group\"><label for=\"ppass\" class=\"control-label col-md-3\">Powtórz nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.newValue\" data-repeat-password></pass></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-3 text-center\"><button id=\"account_activate\n\" type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.changePassword()\" ng-disabled=\"confirmForm.$invalid || confirmForm.$pending\">Zmień hasło</button></div></div></form>");
$templateCache.put("app/views/passwordExpired/passwordExpired-Success.html","<h2 class=\"no-m-top\">Poprawnie zmieniono hasło</h2><h4>Hasło do Portalu VB Leasing zostało zmienione. Wróc do ekranu logowania, by skorzystać z Portalu.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/passwordExpired/passwordExpired.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12\"><div ui-view=\"step\"></div></div></div></div></div><div class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Zmienianie...</p></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/register/2013.html","<h2 class=\"no-m-top\">Przesłany link został już otwarty</h2><h4>Przepraszamy, przesłany link został już otwarty. Prosimy ponowić proces aktywacji konta.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/2015.html","<h2 class=\"no-m-top\">Klient o podanym numerze nie posiada dostępu do Portalu</h2><h4>Klient o podanym numerze nie posiada dostępu do Portalu VB Leasing.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/2016.html","<h2 class=\"no-m-top\">Przesłany link stracił ważność</h2><h4>Przepraszamy, przesłany link stracił swoją ważność. Prosimy ponowić proces aktywacji konta.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/2020.html","<h2 class=\"no-m-top\">Wystąpił błąd podczas rejestracji</h2><h4>Przepraszamy, wystąpił błąd. Prosimy ponowić proces rejestracji.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"register1\">Powrót</button></div>");
$templateCache.put("app/views/register/204.html","<h2 class=\"no-m-top\">Podany klient jest już zarejestrowany</h2><h4>Podany klient jest już zarejestrowany, ale nie aktywował swojego konta. Na adres podany podczas rejestracji został ponownie wysłany e-mail z linkiem aktywacyjnym.</h4><h4>Jeśli w ciągu 15 minut nie otrzymasz odpowiedzi, prosimy o kontakt z Działem Wsparcia Obsługi Klienta pod adresem: <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a>.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/207.html","<h2 class=\"no-m-top\">Podany klient ma już dostęp do Portalu</h2><h4>Podany klient jest już zarejestrowany oraz aktywował swoje konto. Na ekranie logowania przy użyciu kodu klienta oraz hasła podanego podczas aktywacji może zalogować się do Portalu.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/208.html","<h2 class=\"no-m-top\">Rejestracji o podanym tokenie nie ma w bazie</h2><h4>Prosimy sprawdzić poprawność adresu.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/209.html","<h2 class=\"no-m-top\">Podany klient nie ma żadnych aktywnych umów</h2><h4>Podany klient nie ma żadnych aktywnych umów i nie może uzyskać dostępu do Portalu.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/finish.html","<h2 class=\"no-m-top\">Dziękujemy za rejestrację w Portalu VB Leasing</h2><h4>Na podany adres e-mail została wysłana wiadomość z linkiem umożliwiającym pierwsze logowanie.</h4><h4>Jeśli w ciągu 15 minut nie otrzymasz odpowiedzi, prosimy o kontakt z Działem Wsparcia Obsługi Klienta pod adresem: <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a>.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/register/register-1.html","<div class=\"text-primary steps\">Krok 1/3</div><h2 class=\"no-m-top\">Rejestracja do Portalu VB Leasing</h2><errors></errors><statements></statements><p>Po wyrażeniu zgody będzie możliwość pobierania e-dokumentów.</p><p>Podczas rejestracji wystarczy podać kod klienta, numer jednej z trzech ostatnich faktur z tytułu raty leasingu / pożyczki / najmu oraz kwotę netto wskazanej faktury.</p><form id=\"step1Form\" name=\"step1Form\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"iLogin\" class=\"col-md-2 control-label\">Kod klienta</label><div class=\"col-md-5\"><input type=\"text\" ng-pattern=\"/^[0-9]+$/\" class=\"form-control\" autocomplete=\"off\" required=\"required\" id=\"iLogin\" placeholder=\"\" tabindex=\"0\" ng-model=\"vm.data.login\" data-pattern-tooltip=\"Podaj poprawny kod klienta.\"></div><div class=\"col-md-5\"><a class=\"form-help-link\" style=\"line-height: 40px\" href data-toggle=\"tooltip\" data-placement=\"top\" title=\"Kod klienta znajdziesz na dokumencie (faktura / nota obciążeniowa) po lewej stronie nad tabelką. \" tabindex=\"-1\" tooltip>Gdzie znajdę kod klienta?</a></div></div><div class=\"form-group\"><label for=\"doc\" class=\"col-md-2 control-label\">Nr dokumentu</label><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" autocomplete=\"off\" id=\"doc\" placeholder=\"\" required=\"required\" ng-model=\"vm.data.document_nr\"></div><div class=\"col-md-5\"><a class=\"form-help-link\" style=\"line-height: 40px\" href data-toggle=\"tooltip\" data-placement=\"top\" title=\"Numer dokumentu znajdziesz w górnym lewym rogu obok nazwy typ dokumentu (faktura / nota obciążeniowa).\" tabindex=\"-1\" tooltip>Gdzie znajdę nr dokumentu?</a></div></div><div class=\"form-group\"><label for=\"kwota\" class=\"col-md-2 control-label\">Kwota netto</label><div class=\"col-md-5\"><amount class=\"form-control\" ng-model=\"vm.data.total_netto\" required=\"required\"></amount></div><div class=\"col-md-5\"><a class=\"form-help-link\" style=\"line-height: 40px\" href data-toggle=\"tooltip\" data-placement=\"top\" title=\"Wpisz kwotę netto z pola \'Razem\' z dokumentu, którego numer podałeś wyżej.\" tabindex=\"-1\" tooltip>Jak wypełnić pole kwota netto?</a></div></div><div class=\"form-group\"><div class=\"col-md-push-2 col-md-10\"><button type=\"button\" class=\"btn btn-140 btn-primary btn-round\" ui-sref=\"login\">Wstecz</button> <button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.proceed\n($event)\" ng-disabled=\"step1Form.$invalid || step1Form.$pending\">Dalej</button></div></div></form>");
$templateCache.put("app/views/register/register-2.html","<div class=\"text-primary steps\">Krok 2/3</div><h2 class=\"no-m-top\">Rejestracja do Portalu VB Leasing</h2><errors></errors><statements></statements><p>Prosimy o wprowadzenie adresu e-mail, na który zostanie wysłany link aktywujący dostęp do Portalu VB Leasing oraz jednorazowego hasła startowego, które zostanie użyte podczas aktywacji konta.</p><form id=\"step2Form\" name=\"step2Form\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"iEmail\" class=\"col-md-2 control-label\">E-mail</label><div class=\"col-md-5\"><email id=\"iEmail\" class=\"form-control\" ng-model=\"vm.data.email\" required=\"required\" autocomplete=\"off\" data-toggle=\"tooltip\"></email></div></div><div class=\"form-group\"><label for=\"iPass\" class=\"col-md-2 control-label\">Hasło startowe</label><div class=\"col-md-5\"><pass id=\"iPass\" class=\"form-control\" ng-model=\"vm.data.newPassword\" required=\"required\" autocomplete=\"off\" data-new-password></pass></div><div class=\"col-md-5\"></div></div><div class=\"form-group\"><label for=\"iRepeatPassword\" class=\"col-md-2 control-label\">Powtórz hasło startowe</label><div class=\"col-md-5\"><pass id=\"iRepeatPassword\" class=\"form-control\" ng-model=\"vm.data.password\" required=\"required\" autocomplete=\"off\" data-repeat-password></pass></div><div class=\"col-md-5\"></div><div class=\"form-group\"><div class=\"col-md-push-2 col-md-10\"><button type=\"button\" class=\"btn btn-140 btn-primary btn-round\" ng-click=\"vm.back()\">Wstecz</button> <button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.proceed($event)\" ng-disabled=\"step2Form.$invalid || step2Form.$pending\">Dalej</button></div></div></div></form>");
$templateCache.put("app/views/register/register-3.html","<div class=\"text-primary steps\" ng-init=\"vm.stepValidity()\">Krok 3/3</div><h2 class=\"no-m-top\">Rejestracja do Portalu VB Leasing</h2><h4>Zgody i oświadczenia</h4><form id=\"step3Form\" name=\"step3Form\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-12\"><input type=\"checkbox\" id=\"agreement1\" required=\"required\" ng-model=\"vm.data.agreement1\" tabindex=\"1\"><label class=\"checkbox\" for=\"agreement1\" style=\"cursor:default\">Oświadczam, że zapoznałem się z <b><a ui-sref=\"regulations\" ng-click=\"vm.data.agreement1 = !vm.data.agreement1\" href>Regulaminem</a></b> świadczenia usługi elektronicznej Portal VB Leasing przez VB Leasing S.A. w restrukturyzacji oraz akceptuję jego postanowienia.<strong style=\"color:red\">*</strong></label></div></div><!-- Agreement 2 was removed and made not required due to SD-636556 --><div class=\"form-group\"><div class=\"col-xs-12\"><input type=\"checkbox\" id=\"agreement3\" ng-model=\"vm.data.agreement3\" tabindex=\"3\"><label class=\"checkbox\" for=\"agreement3\" style=\"cursor:default\"><b>Akceptuję wystawianie i udostępnianie dokumentów w formie elektronicznej (e-Dokumentów)</b> przez VB Leasing S.A. w restrukturyzacji, na zasadach określonych w Regulaminie świadczenia usługi elektronicznej Portal VB Leasing.<br>Dokumenty elektroniczne (e-Dokumenty) będą udostępniane jedynie poprzez Portal VBL, po zalogowaniu się na indywidualne konto Klienta. Portal VBL będzie umożliwiał Klientowi samodzielne pobranie dokumentów w postaci pliku PDF i/lub XML. Dokumenty będą udostępniane w formacie elektronicznym po wyrażeniu niniejszej akceptacji i będą dotyczyć wszystkich usług świadczonych na podstawie umów już zawartych jak i zawartych w przyszłości. Oświadczam, że zapoznałem się z <b><a ui-sref=\"regulations\" ng-click=\"vm.data.agreement3 = !vm.data.agreement3\" href>Regulaminem</a></b> świadczenia usługi elektronicznej Portal VB Leasing.</label></div></div><!-- Agreement 4 was removed due to SD-636556 --><!-- Agreement 5 was removed due to SD-636556 --><!-- Agreement 6 was removed due to SD-636556 --><div id=\"annotations\" style=\"margin-left:20px\"><p><strong style=\"color:red\">*</strong> - pole obowiązkowe</p></div><div id=\"disclaimer\" class=\"text-justify\" style=\"font-size: 8pt; padding: 0px 10px 10px 10px\">Administratorem danych przetwarzanych za pośrednictwem Portalu VB Leasing pozostaje VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, przy ul. Fabryczna 6, 53-609 Wrocław (\"VBL\"). Dane osobowe są przetwarzane w celu niezbędnym do świadczenia usługi Portalu VB Leasing oraz marketingu produktów i usług VBL. Podanie danych osobowych jest dobrowolne, jednak niezbędne w celu umożliwienia skorzystania z tej usługi. Osoba, której dane dotyczą ma prawo dostępu do treści jej danych oraz do ich poprawiania.</div><div class=\"form-group\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-140 btn-primary btn-round\" ng-click=\"vm.back()\">Wstecz</button> <button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.proceed($event)\" ng-disabled=\"step3Form.$invalid || step3Form.$pending\">Wyślij</button></div></div></form>");
$templateCache.put("app/views/register/register.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"step\" ui-view=\"step\" ng-cloak></div></div></div></div></div></div></div></div></div><!-- section --><div class=\"loader registrator hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Przesyłanie formularza rejestracyjnego...</p></div><div class=\"loader activator hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Aktywacja konta...</p></div>");
$templateCache.put("app/views/register/regulations.html","<div class=\"section\"><h3 class=\"no-m-top\">Regulamin świadczenia usługi elektronicznej Portal VB Leasing przez VB Leasing S.A. w restrukturyzacji</h3><h5><b>Definicje</b></h5><div id=\"definitions\" style=\"margin-left: 20px\"><p>Określenia użyte w Regulaminie otrzymują następujące znaczenie:</p><p><b>Aktywna Umowa z VBL</b> – umowa zawarta z VBL prawidłowo wykonywana przez Klienta,</p><p><b>Faktura ustrukturyzowana (Faktura KSeF)</b> – faktura wystawiana i przesyłana/udostępniana/archiwizowana przy użyciu Krajowego Systemu e-Faktur (KSeF) wraz z przydzielonym numerem identyfikującym tę fakturę w tym systemie, zgodnie z przepisami ustawy z dnia 11 marca 2004 r. o podatku od towarów i usług.</p><p><b>Dokumenty elektroniczne/e-Dokumenty</b> – elektroniczne dokumenty wystawiane i udostępniane przez VBL, inne niż Faktury ustrukturyzowane, w szczególności noty korygujące, noty uznaniowe, noty obciążeniowe oraz inne dokumenty związane z obsługą umów zawartych z VBL.</p><p><b>Faktury archiwalne</b> – faktury wystawione i udostępnione Klientowi w formie elektronicznej przed dniem objęcia VBL obowiązkiem wystawiania faktur przy użyciu KSeF. Dostęp do Faktur archiwalnych za pośrednictwem Portalu VB Leasing przysługuje wyłącznie Klientom, którzy wyrazili zgodę na e-fakturę przed dniem objęcia VBL obowiązkiem wystawiania faktur przy użyciu KSeF.</p><p><b>Funkcjonalność Portalu VB Leasing/Usługa Portal VB Leasing</b> – usługa oferowana Klientom VBL przy wykorzystaniu Portalu VB Leasing,</p><p><b>Klient</b> – osoba będąca stroną umowy zawartej z VBL w szczególności na rzecz której VBL dokonuje sprzedaży usług bądź towarów.</p><p><b>Konto Klienta</b> – indywidualne konto dostępne dla uprawnionego użytkownika wyłącznie po zalogowaniu.</p><p><b>Portal VB Leasing</b> – platforma informatyczna pod adresem <a ng-href=\"{{$location.$$absUrl.split(\'#\')[0]}}\" target=\"_blank\">{{$location.$$absUrl.split(\'#\')[0]}}</a>, której administratorem jest VBL wykorzystywana do świadczenia Usługi Portal VB Leasing Klientom VBL.</p><p><b>Regulamin</b> – niniejszy Regulamin świadczenia usługi elektronicznej Portal VB Leasing przez VB Leasing S.A. w restrukturyzacji będący regulaminem w rozumieniu Ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną</p><p><b>Użytkownik</b> – Klient VBL lub osoba przez niego upoważniona.</p><p><b>VBL</b> – VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, ul. Fabryczna 6, 53-609 Wrocław, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Wrocławia – Fabrycznej we Wrocławiu, VI Wydział Gospodarczy Krajowego Rejestru Sądowego pod nr KRS: 0000307665, NIP: 521-348-24-74, REGON: 141374292, kapitał zakładowy w wysokości 23.501.000,00 zł opłacony w całości.</p></div><h5><b>§ 1. Zasady ogólne.</b></h5><div id=\"main_rules\" style=\"margin-left: 20px\"><ol><li>Usługa Portal VB Leasing polega na umożliwieniu Klientowi przez VBL dostępu do internetowego portalu pod adresem <a ng-href=\" {{$location.$$absUrl.split( \'#\')[0]}} \" target=\"_blank \">{{$location.$$absUrl.split(\'#\')[0]}}</a> oraz korzystanie z usług elektronicznych oferowanych przez VBL lub świadczonych za pośrednictwem VBL przez osoby trzecie.</li><li>W zależności od wybranych przez Klienta ustawień Portal VB Leasing umożliwia Klientowi dostęp do funkcjonalności i usług oferowanych przez VBL za pośrednictwem Portalu VB Leasing. Funkcjonalności te mogą ulegać zmianie wraz z rozwojem Portalu VB Leasing. O zmianach VBL będzie informował za pośrednictwem Portalu VB Leasing.</li><li>W ramach Portalu VB Leasing Klientowi zostanie udostępniona funkcjonalność:<ol type=\"a\"><li>Dokumenty elektroniczne (e-Dokumenty) – polegająca na udostępnianiu Klientom Dokumentów elektronicznych (e-Dokumentów),</li><li>dostęp do Faktur archiwalnych – przysługujący wyłącznie Klientom spełniającym warunki określone w definicji Faktur archiwalnych zawartej w Regulaminie. Portal VB Leasing nie stanowi systemu wystawiania, doręczania ani udostępniania Faktur ustrukturyzowanych (Faktur KSeF). Zakres dokumentów udostępnianych w Portalu VB Leasing może różnić się w zależności od statusu Klienta oraz obowiązujących przepisów prawa, w szczególności w zakresie obowiązku korzystania z Krajowego Systemu e-Faktur (KSeF).</li></ol>Wraz z rozwojem Portalu VB Leasing mogą zostać udostępnione także inne funkcjonalności oraz usługi.</li><li>Uzyskanie dostępu i rozpoczęcie świadczenia usługi wymaga wyrażenia akceptacji przez Klienta na świadczenie usługi i jej warunki. Akceptacja może zostać wyrażona w formie pisemnej lub poprzez dokonanie odpowiednich wyborów i zaznaczeń na Portalu VB Leasing.</li><li>Do użytkowania Portalu VB Leasing niezbędne jest spełnienie następujących wymagań:<ol type=\"a\"><li>złożenie przez Klienta oświadczenia o wyrażeniu zgody na korzystanie z Portalu VB Leasing;</li><li>zapoznanie się z niniejszym Regulaminem oraz złożenie przez Klienta oświadczenia o akceptacji przez niego postanowień Regulaminu;</li><li>posiadanie urządzenia komputerowego lub telekomunikacyjnego posiadającego dostęp do internetu;</li><li>posiadania aplikacji i programów komputerowych umożliwiających odczyt plików elektronicznych.</li><li>Korzystanie z części funkcjonalności/usług może wymagać spełnienia innych warunków niż wskazane w ust. 4 opisanych w niniejszym Regulaminie bądź na Portalu VB Leasing.</li></ol></li></ol></div><h5><b>§ 2. Uzyskanie dostępu do Portalu VB Leasing i wybór usług/funkcjonalności.</b></h5><div id=\"access_gain\" style=\"margin-left: 20px\"><ol><li>Dostęp do Portalu VB Leasing jest możliwy po zalogowaniu za pomocą loginu i indywidualnego hasła dostępowego oraz wyrażeniu zgód i złożeniu oświadczeń umożliwiających rozpoczęcie świadczenia przez VBL usług polegających na udostępnieniu Klientowi Funkcjonalności Portalu VB Leasing. Logowanie następuje poprzez bezpieczne łącze internetowe. Po zalogowaniu użytkownik otrzyma dostęp do indywidualnego Konta Klienta.</li><li>Przy logowaniu Klient może być proszony o uzupełnienie danych w panelu logowania.</li><li>Przy logowaniu Klient może być proszony o określenie usług i/lub funkcjonalności, z których chce korzystać. Usługi i funkcjonalności mogą być także wybrane później. W zależności od wybranych usług i/lub funkcjonalności system wskaże niezbędne kroki do aktywowania wybranego dostępu.</li><li>Dostęp do niektórych funkcjonalności może wymagać (posiadania przez Klienta co najmniej jednej) aktywnej umowy z VBL.</li><li>Postanowienia Regulaminu dotyczące poszczególnych funkcjonalności Portalu znajdują zastosowanie w przypadku gdy Klient korzystający z Portalu dokona wyboru danej funkcjonalności Portalu jako usługi świadczonej na jego rzecz przez VBL.</li></ol></div><h5><b>§ 3. Usługa udostępniania Dokumentów elektronicznych (e-Dokumentów) oraz dostępu do Faktur archiwalnych.</b></h5><div id=\"e_invoice\" style=\"margin-left: 20px\"><ol type=\"A\"><li><b>Dostęp do funkcjonalności/usługi.</b> Funkcjonalność Portalu VB Leasing polega na wystawianiu przez VBL i przesyłaniu Klientom VBL poprzez udostępnianie na Portalu VB Leasing Dokumentów elektronicznych (e-Dokumentów) oraz dostępie do Faktur archiwalnych.<ol><li>Warunkiem korzystania z funkcjonalności/usługi przez Klienta jest spełnienie przez niego łącznie następujących warunków:<ol type=\"a\"><li>złożenie oświadczenia o wyrażeniu zgody na wystawianie i udostępnianie dokumentów w formie elektronicznej;</li><li>zapoznanie się z niniejszym Regulaminem oraz złożenie przez Klienta oświadczenia o akceptacji przez niego postanowień Regulaminu;</li><li>posiadanie i wskazanie VBL adresu poczty elektronicznej, na który mają być przesyłane powiadomienia o wystawieniu i udostępnieniu e-Dokumentów;</li><li>posiadanie urządzenia komputerowego lub telekomunikacyjnego z dostępem do Internetu umożliwiającym dostęp do Portalu VB Leasing;</li></ol></li><li>Wyrażenie zgody na wystawianie i udostępnienie e-Dokumentów w drodze elektronicznej obejmuje zgodę na udostępnianie także dokumentacji powiązanej.</li><li>Uruchomienie funkcjonalności i rozpoczęcie wystawiania i przesyłania przez VBL (poprzez udostępnianie) e-Dokumentów nastąpi po wyrażeniu przez Klienta VBL zgody o której mowa w §3 lit. A pkt.1a, chyba że strony uzgodnią inny termin nie dłuższy niż 21 dni od daty wyrażenia zgody.</li></ol></li><li><b>Zasady wystawiania i stosowania e-Dokumentów</b> – e-Dokumenty są udostępniane przez VBL w sposób zapewniający autentyczność pochodzenia, integralność treści oraz ich czytelność, także z funkcją pobierania.<ol><li>e-Dokumenty udostępniane są w formie pliku XML wraz możliwością ich wizualizacji w formacie PDF (Portable Document Format).</li><li>e-Dokumenty są udostępniane (również z funkcją pobierania) poprzez Portal VB Leasing. Dostęp do Portalu VB Leasing następuje z wykorzystaniem przydzielonego Klientowi loginu i hasła.</li><li>Klient zobowiązany jest do pobrania e-Dokumentu z Portalu VB Leasing. Niepobranie e-Dokumentu przez Klienta nie zwalnia go z obowiązku terminowego regulowania opłaty z niego wynikającej/opłat wynikających z zawartej umowy.</li><li>Złożenie przez Klienta oświadczenia o akceptacji na wystawianie i przesyłanie dokumentów w formie elektronicznej nie wyłącza prawa VBL do wystawiania i przesyłania dokumentów w formie papierowej, w tym w szczególności wówczas gdy nie jest możliwe ich udostępnienie na Portalu VB Leasing z powodów technicznych lub formalnych.</li></ol></li><li><b>Przechowywanie oraz pozostałe zasady przekazywania e-Dokumentów.</b><ol><li>Dokumenty elektroniczne są przechowywane w sposób i przez okres wymagany przepisami prawa w sposób umożliwiający wyszukanie, podgląd, zapisanie oraz wydruk dokumentu.</li><li>VBL nie ponosi odpowiedzialności wobec Klienta za utratę lub uszkodzenie danych przechowywanych na Portalu VB Leasing.</li><li>Klient może w każdym czasie zrezygnować z możliwości otrzymywania dokumentów w formie elektronicznej poprzez złożenie oświadczenia o cofnięciu akceptacji na wystawianie i udostępnianie ich w formie elektronicznej. Oświadczenie takie powinno zostać złożone w formie pisemnej i przesłane na adres centrali VB Leasing SA.</li><li>VBL zaprzestaje udostępniania e-dokumentów za pośrednictwem Portalu VB Leasing po otrzymaniu od Klienta oświadczenia o cofnięciu akceptacji na wystawianie i przesyłanie dokumentów w formie elektronicznej, nie później niż w ciągu 14 dni, chyba że strony uzgodniły inny termin. Rezygnacja z otrzymywania dokumentów elektronicznych (e-Dokumentów) nie wpływa na sposób wystawiania oraz udostępniania Faktur ustrukturyzowanych zgodnie z obowiązującymi przepisami prawa.</li></ol></li></ol></div><h5><b>§ 4. Pozostałe funkcjonalności Portalu VB Leasing</b></h5><div id=\"other_functionalities\" style=\"margin-left: 20px\"><p>Korzystanie przez Klienta z pozostałych funkcjonalności Portalu VB Leasing, np. usługi polegającej na możliwości otrzymywania informacji handlowych dotyczących usług oferowanych przez VBL lub partnerów VBL, a także innych usług i funkcjonalności dodawanych w miarę rozwoju Portalu VB Leasing, Odbywa się w sposób wykorzystujący aktualne możliwości techniczne Portalu VB Leasing i wymaga dokonania odpowiednich ustawień lub operacji przez Użytkownika Portalu VB Leasing przy czym niektóre funkcje takie jak otrzymywanie informacji handlowych, mogą wymagać złożenia odrębnej zgody przez Klienta.</p></div><h5><b>§ 5. Zasady bezpieczeństwa</b></h5><div id=\"security\" style=\"margin-left: 20px\"><ol><li>Dostęp do Portalu VB Leasing wymaga korzystania z przydzielonego Loginu i Hasła. Błędne wpisanie loginu i/lub hasła spowoduje prośbę o ponowne, poprawne wpisanie danych dostępowych. W przypadku trzykrotnej błędnej próby logowania dostęp do Konta zostaje zablokowany na 15 minut. Po tym czasie każda następne błędna próba logowania blokuje dostęp na 15 minut. W przypadku sześciu kolejnych błędnych prób logowania dostęp do Konta jest blokowany. Wówczas Konto może zostać odblokowane tylko przez uprawnionego konsultanta VBL, o czym Użytkownik jest informowany za pomocą stosownego komunikatu.</li><li>Zachowanie hasła w poufności i nieudostępnianie go osobom nieuprawnionym należy do obowiązków Klienta. W przypadku utraty danych logowania Klient powinien wybrać opcję „zapomniałem hasła” w panelu logowania i postąpić zgodnie z wyświetloną instrukcją.</li><li>Wszystkie operacje dokonane za pośrednictwem Portalu VB Leasing po zalogowaniu się indywidualnym loginem i hasłem uważa się za zlecone przez Klienta i w tym zakresie VBL nie ponosi odpowiedzialności za nieuprawnione działania osób trzecich.</li></ol></div><h5><b>§ 6. Zmiana danych</b></h5><div id=\"personal_data_change\" style=\"margin-left: 20px\"><ol><li>W przypadku zmiany danych mających znaczenie dla użytkowania Portalu VB Leasing, klient zobowiązany jest do ich zgłoszenia VBL do Działu Obsługi Klienta. Informacja odnośnie koniecznych formalności zostanie przekazana Klientowi w formie elektronicznej, telefonicznie lub pisemnie, w zależności od możliwej formy kontaktu.</li><li>Udostępniony VBL przez Klienta adres poczty elektronicznej może zostać wykorzystany przez VBL do przesyłania Klientowi wezwań (monitów) do zapłaty lub innych wiadomości związanych z umowami zawartymi przez strony.</li><li>Do czasu wskazania przez Klienta aktualnych danych, w sposób wskazany w ust. 1 lub zmiany w ramach Portalu VB Leasing, wszelkie oświadczenia przesłane na adres poczty elektronicznej lub przy użyciu podanych VBL danych, w tym osobowych, będą uważane za złożone przez VBL w sposób prawidłowy i skuteczny.</li><li>W celu dodatkowej autoryzacji niektórych operacji VBL za pośrednictwem Portalu VB Leasing lub Konsultanta ma prawo zadać Użytkownikowi pytania dotyczące jego danych osobowych udostępnionych VBL lub innych danych dotyczących zawartych umów. Jeżeli Użytkownik nie może podać prawidłowych danych niezbędnych do wykonania danego zlecenia, nie może ono być zrealizowane.</li></ol></div><h5><b>§ 7. Opłaty</b></h5><div id=\"payments\" style=\"margin-left: 20px\"><ol><li>Korzystanie z Portalu VB Leasing przez Klientów jest wolne od opłat z zastrzeżeniem ust. 2.</li><li>Usługi i czynności związane z zawartymi umowami zlecane przez Klienta za pośrednictwem Portalu VB Leasing , płatne są zgodnie z właściwą Tabelą Opłat i Prowizji.</li><li>VBL zastrzega sobie prawo wprowadzenia nowych, płatnych usług świadczonych za pośrednictwem Portalu VB Leasing. Każdorazowo świadczenie takich usług wymagać będzie zgody Klienta.</li></ol></div><h5><b>§ 8. Rezygnacja z korzystania z Portalu VB Leasing.</b></h5><div id=\"resignation\" style=\"margin-left: 20px\"><ol><li>Klient może zrezygnować z Portalu VB Leasing poprzez złożenie VBL odpowiedniego oświadczenia w formie pisemnej.</li><li>Rezygnacja z otrzymywania dokumentów elektronicznych (e-Dokumentów) następuje na zasadach określonych w § 3 lit. C pkt. 3-4.</li></ol></div><h5><b>§ 9. Zmiany regulaminu.</b></h5><div id=\"regulation_changes\" style=\"margin-left: 20px\"><ol><li>VBL zastrzega sobie możliwość zmiany postanowień Regulaminu oraz wprowadzania zmian w funkcjonowaniu Portalu VB Leasing. Informacja o zmianie będzie Klientowi przekazywana poprzez udostępnienie na Portalu VB Leasing.</li><li>Klientowi służy prawo do rezygnacji z Portalu VB Leasing w terminie 30 dni od daty udostępnienia informacji o zmianie. W przypadku gdy w powyższym terminie Klient nie złoży pisemnego oświadczenia o rezygnacji zmienione postanowienia wiążą strony od dnia ich wprowadzenia. Rezygnacja z Portalu nie wpływa na sposób wystawiania i udostępniania Faktur ustrukturyzowanych zgodnie z obowiązującymi przepisami prawa.</li></ol></div><h5><b>§ 10. Reklamacje</b></h5><div id=\"complaints\" style=\"margin-left: 20px\"><ol><li>W przypadku niezadowolenia Klienta z usług świadczonych za pośrednictwem Portalu VB Leasing, Klient będący klientem podmiotu rynku finansowego w rozumieniu ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego, o Rzeczniku Finansowym i o Funduszu Edukacji Finansowej uprawniony jest do złożenia reklamacji w każdym oddziale VBL. Lista oddziałów przyjmujących reklamacje dostępna jest na stronie internetowej VBL pod adresem: <a href=\"http://www.vbleasing.pl\">www.vbleasing.pl</a>. Reklamacje mogą być składane:<ol type=\"a\"><li>w formie pisemnej – listownie na adres VB Leasing S.A. w restrukturyzacji, ul. Fabryczna 6, 53-609 Wrocław;</li><li>ustnie – osobiście do protokołu podczas wizyty Klienta w oddziale przyjmującym reklamacje zgodnie z listą o której mowa powyżej;</li><li>w formie wiadomości elektronicznej wysłanej na adresy poczty elektronicznej wskazane dla tego celu na stronie internetowej VBL pod adresem: www.vbleasing.pl.</li></ol></li><li>Reklamacja powinna zawierać:<ol type=\"a\"><li>opis zdarzenia, którego dotyczy,</li><li>wskazanie zastrzeżenia co do usług świadczonych przez VBL oraz</li><li>wyraźne wskazanie roszczenia Klienta względem VBL (tj. czego klient żąda od VBL).</li></ol></li><li>Reklamacje są rozpatrywane w terminie nie dłuższym niż 30 dni od dnia otrzymania reklamacji przez VBL.</li><li>Klient będzie poinformowany o wyniku rozpatrzenia reklamacji przez VBL w terminie 30 dni od dnia jej otrzymania poprzez list polecony lub wiadomość email VBL, wysłaną na adres wskazany przez Klienta – na co niniejszym Klient wyraźnie udziela zgody.</li><li>Do zachowania terminu wystarczy wysłanie przez VBL odpowiedzi przed jego upływem.</li><li>W przypadku bardziej skomplikowanych przypadków uniemożliwiających rozpatrzenie reklamacji i udzielenie odpowiedzi w podanym wyżej terminie tj. przed upływem trzydziestodniowego terminu, VBL zawiadomi LB w drodze: a) listu poleconego lub b) wiadomości email VBL wysłanej na adres wskazany przez Klienta (na co niniejszym Klient wyraźnie udziela zgody), iż odpowiedź będzie wysłana w terminie nie dłuższym niż 60 dni od dnia otrzymania przez VBL reklamacji. Zawiadomienie zawierać będzie: a) informację co do przyczyn opóźnienia, b) wskazanie okoliczności, które muszą zostać ustalone dla rozpatrzenia sprawy oraz c) określenie przewidywanego terminu rozpatrzenia reklamacji i udzielenia odpowiedzi.</li><li>Klient niniejszym wnosi o przesyłanie przez VBL wszelkiej korespondencji dotyczącej reklamacji i procedury reklamacyjnej w drodze wiadomości email VBL.</li><li>Żadne z postanowień umowy nie ogranicza praw Klienta wynikających z ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego, o Rzeczniku Finansowym i o Funduszu Edukacji Finansowej. Klient, który jest niezadowolony z udzielonej przez VBL odpowiedzi na złożoną przez niego reklamację, może wystąpić z wnioskiem o rozpatrzenie sprawy do Rzecznika Finansowego.</li></ol></div><h5><b>§ 11. Postanowienia końcowe</b></h5><div id=\"end\" style=\"margin-left: 20px\"><ol><li>W związku z korzystaniem z Portalu VB Leasing dane osobowe użytkowników są przetwarzane zgodnie z przepisami Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) oraz innymi obowiązującymi przepisami prawa dotyczącymi ochrony danych osobowych. Administratorem danych osobowych przetwarzanych za pośrednictwem Portalu VB Leasing jest VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, ul. Fabryczna 6, 53-609 Wrocław. Dane osobowe przetwarzane są w szczególności w celu: świadczenia usług dostępnych w ramach Portalu VB Leasing (art. 6 ust. 1 lit. b RODO), realizacji prawnie uzasadnionych interesów administratora, w tym marketingu bezpośredniego własnych produktów i usług (art. 6 ust. 1 lit. f RODO), w przypadku wyrażenia zgody – w celach marketingowych (art. 6 ust. 1 lit. a RODO). Podanie danych osobowych jest dobrowolne, jednak może być niezbędne do skorzystania z usług dostępnych w Portalu VB Leasing. Osobie, której dane dotyczą, przysługuje prawo dostępu do treści swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu wobec przetwarzania danych oraz prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li><li>Dane osobowe mogą być przekazywane podmiotom powiązanym z administratorem lub należącym do tej samej grupy kapitałowej w rozumieniu przepisów ustawy z dnia 29 września 1994 r. o rachunkowości, w celu oferowania produktów i usług tych podmiotów, wyłącznie na podstawie uprzednio wyrażonej zgody osoby, której dane dotyczą. Zgoda może zostać wyrażona poprzez zaznaczenie odpowiedniego pola w formularzu rejestracyjnym lub kontaktowym.</li><li>Klient, poprzez zaznaczenie odpowiedniego pola w formularzu rejestracyjnym lub kontaktowym, może wyrazić zgodę na otrzymywanie informacji handlowych za pomocą środków komunikacji elektronicznej, w szczególności poczty elektronicznej lub innych kanałów komunikacji elektronicznej, zgodnie z obowiązującymi przepisami ustawy Prawo komunikacji elektronicznej.</li><li>W celu zapewnienia wysokiej jakości obsługi oraz w celach dowodowych rozmowy telefoniczne z konsultantami VB Leasing mogą być nagrywane. Osoba rozpoczynająca rozmowę jest każdorazowo informowana o nagrywaniu rozmowy.</li><li>VB Leasing nie ponosi odpowiedzialności za szkody poniesione przez Klienta w związku z korzystaniem z Portalu VB Leasing, powstałe z przyczyn niezależnych od VB Leasing. W szczególności VB Leasing nie odpowiada za szkody wynikające z: przerw w dostępie do Portalu VB Leasing spowodowanych awariami technicznymi lub działaniem siły wyższej, problemów technicznych po stronie użytkownika lub dostawców usług telekomunikacyjnych, nieprawidłowego korzystania z Portalu VB Leasing lub urządzeń wykorzystywanych do dostępu do Portalu VB Leasing.</li></ol></div><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"register3 \">Powrót do rejestracji</button></div></div>");
$templateCache.put("app/views/passwordReset/passwordReset-Confirm-Success.html","<h2 class=\"no-m-top\">Reset hasła do portalu VB Leasing</h2><h4>Hasło do Portalu VB Leasing zostało zmienione.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/passwordReset/passwordReset-Confirm.html","<h2 class=\"no-m-top\">Reset hasła do portalu VB Leasing</h2><errors></errors><statements></statements><p>Wprowadź nowe hasło.</p><form id=\"confirmForm\" name=\"confirmForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"npass\" class=\"control-label col-md-3\">Nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.newValue\" data-new-password></pass></div></div><div class=\"form-group\"><label for=\"ppass\" class=\"control-label col-md-3\">Powtórz nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.repeatValue\" data-repeat-password></pass></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-3 text-center\"><button id=\"account_activate\n\" type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.confirmResetPassword()\" ng-disabled=\"confirmForm.$invalid || confirmForm.$pending\">Zmień hasło</button></div></div></form>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-1027.html","<h4>Token nie został podany.</h4><h4>Proszę sprawdzić poprawność danych.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-1028.html","<h4>Nie podano nowego hasła dwukrotnie.</h4><h4>Proszę podać nowe hasło w obydwu polach.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-1029.html","<h4>Podane nowe hasła nie są identyczne.</h4><h4>Proszę podać jednakowe hasło w obydwu polach.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-1031.html","<h4>Podane hasło nie spełnia warunków bezpieczeństwa.</h4><h4>Hasło powinno zawierać przynajmniej 8 znaków, w tym przynajmniej jedną małą i wielką literę oraz cyfrę lub znak specjalny.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-2013.html","<h4>Przepraszamy, przesłany link został już otwarty. Prosimy ponowić proces zmiany hasła.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-2016.html","<h4>Przepraszamy, przesłany link stracił swoją ważność. Prosimy ponowić proces zmiany hasła.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-208.html","<h4>Nie ma prośby resetu hasła o podanym tokenie w bazie.</h4><h4>Proszę sprawdzić poprawność adresu.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-403.html","<h4>Zmiana hasła nie jest możliwa. Konto zostało zablokowane z powodu błędnych prób logowania.</h4><h4>Prosimy o kontakt z Działem Obsługi Klienta na adres e-mail: <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a>.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail-408.html","<h4>Zmiana hasła nie jest możliwa. Konto nie posiada dostępu do Portalu.</h4><h4>Prosimy o zarejestrowanie się za pomocą <a href ui-sref=\"register1\">formularza rejestracyjnego</a>.</h4>");
$templateCache.put("app/views/passwordReset/passwordReset-Fail.html","<h2 class=\"no-m-top\">Reset hasła do portalu VB Leasing</h2><div ui-view=\"fail\" ng-cloak></div><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/passwordReset/passwordReset-Reset.html","<h2 class=\"no-m-top\">Reset hasła do portalu VB Leasing</h2><errors></errors><statements></statements><p>Aby nadać nowe hasło, wprowadź kod klienta / login oraz adres e-mail podany podczas rejestracji.</p><form id=\"resetForm\" name=\"resetForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">Kod klienta / login</label><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" required=\"required\" autocomplete=\"off\" placeholder=\"\" tabindex=\"0\" ng-model=\"vm.data.login\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">E-mail</label><div class=\"col-md-5\"><email class=\"form-control\" required=\"required\" placeholder=\"\" ng-model=\"vm.data.email\"></email></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">Potwierdź swoją tożsamość</label><div class=\"col-md-5\"><div class=\"g-recaptcha\" data-sitekey=\"\"></div></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-2 text-center\"><button type=\"button\" class=\"btn btn-140 btn-primary btn-round\" ui-sref=\"login\">Powrót</button> <button type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-disabled=\"resetForm.$invalid || resetForm.$pending\" ng-click=\"vm.resetPassword()\">Wyślij</button></div></div><!-- GOOGLE Recaptcha --><script type=\"text/javascript\">if(window.location.hostname === \'dev.edistrada.pl\'){\n            var recaptchaPublicKey = \"6Lc2MuIkAAAAAGEdVEww2HnVBwd-PJrb6FI6w2At\";\n        }else if(window.location.hostname === \'vbl-qas.edistrada.pl\' || window.location.hostname === \'edi3test.edistrada.pl\'){\n            var recaptchaPublicKey = \"6Lc2MuIkAAAAAGEdVEww2HnVBwd-PJrb6FI6w2At\";\n        }else if(window.location.hostname === \'klient.vbleasing.pl\'){\n            var recaptchaPublicKey = \"6LeuDVokAAAAABLPrxfIGert4YjxMJDPb4tsbJbZ\";\n        }else{\n            var recaptchaPublicKey = null;\n            console.error(\"Error: No reCAPTCHA public key for this site.\")\n        }\n\n        var recaptchaElement = document.querySelector(\'.g-recaptcha\');\n        recaptchaElement.dataset.sitekey = recaptchaPublicKey;\n\n        var googleScript = document.createElement(\"script\");\n		googleScript.src=\"https://www.google.com/recaptcha/api.js?hl=pl\"\n		document.body.appendChild(googleScript)</script><!--\n        <script src=\"https://www.google.com/recaptcha/api.js?hl=pl\"></script>\n    --></form>");
$templateCache.put("app/views/passwordReset/passwordReset-Success.html","<h2 class=\"no-m-top\">Reset hasła do portalu VB Leasing</h2><h4>Na podany adres e-mail została wysłana wiadomość umożliwiająca nadanie nowego hasła.</h4><h4>Jeśli w ciągu 15 minut nie otrzymasz odpowiedzi, prosimy o kontakt z Działem Wsparcia Obsługi Klienta pod adresem: <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a>.</h4><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"login\">Powrót do ekranu logowania</button></div>");
$templateCache.put("app/views/passwordReset/passwordReset.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12\"><div ui-view=\"step\"></div></div></div></div></div><div class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Resetowanie...</p></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/regulations/regulations.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-m-top\">Regulamin świadczenia usługi elektronicznej Portal VB Leasing przez VB Leasing S.A. w restrukturyzacji</h3><div><button class=\"btn btn-140 btn-primary btn-round btn-fIll\" ui-sref=\"{{fromState.name != \'\' ? fromState.name : \'login\'}}\">Powrót</button></div><h5><b>Definicje</b></h5><div id=\"definitions\" style=\"margin-left: 20px\"><p>Określenia użyte w Regulaminie otrzymują następujące znaczenie:</p><p><b>Aktywna Umowa z VBL</b> – umowa zawarta z VBL prawidłowo wykonywana przez Klienta,</p><p><b>Faktura ustrukturyzowana (Faktura KSeF)</b> – faktura wystawiana i przesyłana/udostępniana/archiwizowana przy użyciu Krajowego Systemu e-Faktur (KSeF) wraz z przydzielonym numerem identyfikującym tę fakturę w tym systemie, zgodnie z przepisami ustawy z dnia 11 marca 2004 r. o podatku od towarów i usług.</p><p><b>Dokumenty elektroniczne/e-Dokumenty</b> – elektroniczne dokumenty wystawiane i udostępniane przez VBL, inne niż Faktury ustrukturyzowane, w szczególności noty korygujące, noty uznaniowe, noty obciążeniowe oraz inne dokumenty związane z obsługą umów zawartych z VBL.</p><p><b>Faktury archiwalne</b> – faktury wystawione i udostępnione Klientowi w formie elektronicznej przed dniem objęcia VBL obowiązkiem wystawiania faktur przy użyciu KSeF. Dostęp do Faktur archiwalnych za pośrednictwem Portalu VB Leasing przysługuje wyłącznie Klientom, którzy wyrazili zgodę na e-fakturę przed dniem objęcia VBL obowiązkiem wystawiania faktur przy użyciu KSeF.</p><p><b>Funkcjonalność Portalu VB Leasing/Usługa Portal VB Leasing</b> – usługa oferowana Klientom VBL przy wykorzystaniu Portalu VB Leasing,</p><p><b>Klient</b> – osoba będąca stroną umowy zawartej z VBL w szczególności na rzecz której VBL dokonuje sprzedaży usług bądź towarów.</p><p><b>Konto Klienta</b> – indywidualne konto dostępne dla uprawnionego użytkownika wyłącznie po zalogowaniu.</p><p><b>Portal VB Leasing</b> – platforma informatyczna pod adresem <a ng-href=\"{{$location.$$absUrl.split(\'#\')[0]}}\" target=\"_blank\">{{$location.$$absUrl.split(\'#\')[0]}}</a>, której administratorem jest VBL wykorzystywana do świadczenia Usługi Portal VB Leasing Klientom VBL.</p><p><b>Regulamin</b> – niniejszy Regulamin świadczenia usługi elektronicznej Portal VB Leasing przez VB Leasing S.A. w restrukturyzacji będący regulaminem w rozumieniu Ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną</p><p><b>RODO</b> – ROZPORZĄDZENIE PARLAMENTU EUROPEJSKIEGO I RADY (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych)</p><p><b>Użytkownik</b> – Klient VBL lub osoba przez niego upoważniona.</p><p><b>VBL</b> – VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, ul. Fabryczna 6, 53-609 Wrocław, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Wrocławia – Fabrycznej we Wrocławiu, VI Wydział Gospodarczy Krajowego Rejestru Sądowego pod nr KRS: 0000307665, NIP: 521-348-24-74, REGON: 141374292, BDO: 000349095 kapitał zakładowy w wysokości 28.201.000,00zł opłacony w całości, posiadająca status dużego przedsiębiorcy w rozumieniu przepisów ustawy z dnia 8 marca 2013 r. o przeciwdziałaniu nadmiernym opóźnieniom w transakcjach handlowych</p></div><h5><b>§ 1. Zasady ogólne.</b></h5><div id=\"main_rules\" style=\"margin-left: 20px\"><ol><li>Usługa Portal VB Leasing polega na umożliwieniu Klientowi przez VBL dostępu do internetowego portalu pod adresem <a ng-href=\" {{$location.$$absUrl.split( \'#\')[0]}} \" target=\"_blank \">{{$location.$$absUrl.split(\'#\')[0]}}</a> oraz korzystanie z usług elektronicznych oferowanych przez VBL lub świadczonych za pośrednictwem VBL przez osoby trzecie.</li><li>W zależności od wybranych przez Klienta ustawień Portal VB Leasing umożliwia Klientowi dostęp do funkcjonalności i usług oferowanych przez VBL za pośrednictwem Portalu VB Leasing. Funkcjonalności te mogą ulegać zmianie wraz z rozwojem Portalu VB Leasing. O zmianach VBL będzie informował za pośrednictwem Portalu VB Leasing.</li><li>W ramach Portalu VB Leasing Klientowi zostanie udostępniona funkcjonalność:<ol type=\"a\"><li>Dokumenty elektroniczne (e-Dokumenty) – polegająca na udostępnianiu Klientom Dokumentów elektronicznych (e-Dokumentów),</li><li>dostęp do Faktur archiwalnych – przysługujący wyłącznie Klientom spełniającym warunki określone w definicji Faktur archiwalnych zawartej w Regulaminie. Portal VB Leasing nie stanowi systemu wystawiania, doręczania ani udostępniania Faktur ustrukturyzowanych (Faktur KSeF). Zakres dokumentów udostępnianych w Portalu VB Leasing może różnić się w zależności od statusu Klienta oraz obowiązujących przepisów prawa, w szczególności w zakresie obowiązku korzystania z Krajowego Systemu e-Faktur (KSeF).</li></ol>Wraz z rozwojem Portalu VB Leasing mogą zostać udostępnione także inne funkcjonalności oraz usługi.</li><li>Uzyskanie dostępu i rozpoczęcie świadczenia usługi wymaga wyrażenia akceptacji przez Klienta na świadczenie usługi i jej warunki. Akceptacja może zostać wyrażona w formie pisemnej lub poprzez dokonanie odpowiednich wyborów i zaznaczeń na Portalu VB Leasing.</li><li>Do użytkowania Portalu VB Leasing niezbędne jest spełnienie następujących wymagań:<ol type=\"a\"><li>złożenie przez Klienta oświadczenia o wyrażeniu zgody na korzystanie z Portalu VB Leasing;</li><li>zapoznanie się z niniejszym Regulaminem oraz złożenie przez Klienta oświadczenia o akceptacji przez niego postanowień Regulaminu;</li><li>posiadanie urządzenia komputerowego lub telekomunikacyjnego posiadającego dostęp do internetu;</li><li>posiadania aplikacji i programów komputerowych umożliwiających odczyt plików elektronicznych.</li><li>Korzystanie z części funkcjonalności/usług może wymagać spełnienia innych warunków niż wskazane w ust. 4 opisanych w niniejszym Regulaminie bądź na Portalu VB Leasing.</li></ol></li></ol></div><h5><b>§ 2. Uzyskanie dostępu do Portalu VB Leasing i wybór usług/funkcjonalności.</b></h5><div id=\"access_gain\" style=\"margin-left: 20px\"><ol><li>Dostęp do Portalu VB Leasing jest możliwy po zalogowaniu za pomocą loginu i indywidualnego hasła dostępowego oraz wyrażeniu zgód i złożeniu oświadczeń umożliwiających rozpoczęcie świadczenia przez VBL usług polegających na udostępnieniu Klientowi Funkcjonalności Portalu VB Leasing. Logowanie następuje poprzez bezpieczne łącze internetowe. Po zalogowaniu użytkownik otrzyma dostęp do indywidualnego Konta Klienta.</li><li>Przy logowaniu Klient może być proszony o uzupełnienie danych w panelu logowania.</li><li>Przy logowaniu Klient może być proszony o określenie usług i/lub funkcjonalności, z których chce korzystać. Usługi i funkcjonalności mogą być także wybrane później. W zależności od wybranych usług i/lub funkcjonalności system wskaże niezbędne kroki do aktywowania wybranego dostępu.</li><li>Dostęp do niektórych funkcjonalności może wymagać (posiadania przez Klienta co najmniej jednej) aktywnej umowy z VBL.</li><li>Postanowienia Regulaminu dotyczące poszczególnych funkcjonalności Portalu znajdują zastosowanie w przypadku gdy Klient korzystający z Portalu dokona wyboru danej funkcjonalności Portalu jako usługi świadczonej na jego rzecz przez VBL.</li></ol></div><h5><b>§ 3. Usługa udostępniania Dokumentów elektronicznych (e-Dokumentów) oraz dostępu do Faktur archiwalnych.</b></h5><div id=\"e_invoice\" style=\"margin-left: 20px\"><ol type=\"A\"><li><b>Dostęp do funkcjonalności/usługi.</b> Funkcjonalność Portalu VB Leasing polega na wystawianiu przez VBL i przesyłaniu Klientom VBL poprzez udostępnianie na Portalu VB Leasing Dokumentów elektronicznych (e-Dokumentów) oraz dostępie do Faktur archiwalnych.<ol><li>Warunkiem korzystania z funkcjonalności/usługi przez Klienta jest spełnienie przez niego łącznie następujących warunków:<ol type=\"a\"><li>złożenie oświadczenia o wyrażeniu zgody na wystawianie i udostępnianie dokumentów w formie elektronicznej;</li><li>zapoznanie się z niniejszym Regulaminem oraz złożenie przez Klienta oświadczenia o akceptacji przez niego postanowień Regulaminu;</li><li>posiadanie i wskazanie VBL adresu poczty elektronicznej, na który mają być przesyłane powiadomienia o wystawieniu i udostępnieniu e-Dokumentów;</li><li>posiadanie urządzenia komputerowego lub telekomunikacyjnego z dostępem do Internetu umożliwiającym dostęp do Portalu VB Leasing;</li></ol></li><li>Wyrażenie zgody na wystawianie i udostępnienie e-Dokumentów w drodze elektronicznej obejmuje zgodę na udostępnianie także dokumentacji powiązanej.</li><li>Uruchomienie funkcjonalności i rozpoczęcie wystawiania i przesyłania przez VBL (poprzez udostępnianie) e-Dokumentów nastąpi po wyrażeniu przez Klienta VBL zgody o której mowa w §3 lit. A pkt.1a, chyba że strony uzgodnią inny termin nie dłuższy niż 21 dni od daty wyrażenia zgody.</li></ol></li><li><b>Zasady wystawiania i stosowania e-Dokumentów</b> – e-Dokumenty są udostępniane przez VBL w sposób zapewniający autentyczność pochodzenia, integralność treści oraz ich czytelność, także z funkcją pobierania.<ol><li>e-Dokumenty udostępniane są w formie pliku XML wraz możliwością ich wizualizacji w formacie PDF (Portable Document Format).</li><li>e-Dokumenty są udostępniane (również z funkcją pobierania) poprzez Portal VB Leasing. Dostęp do Portalu VB Leasing następuje z wykorzystaniem przydzielonego Klientowi loginu i hasła.</li><li>Klient zobowiązany jest do pobrania e-Dokumentu z Portalu VB Leasing. Niepobranie e-Dokumentu przez Klienta nie zwalnia go z obowiązku terminowego regulowania opłaty z niego wynikającej/opłat wynikających z zawartej umowy.</li><li>Złożenie przez Klienta oświadczenia o akceptacji na wystawianie i przesyłanie dokumentów w formie elektronicznej nie wyłącza prawa VBL do wystawiania i przesyłania dokumentów w formie papierowej, w tym w szczególności wówczas gdy nie jest możliwe ich udostępnienie na Portalu VB Leasing z powodów technicznych lub formalnych.</li></ol></li><li><b>Przechowywanie oraz pozostałe zasady przekazywania e-Dokumentów.</b><ol><li>Dokumenty elektroniczne są przechowywane w sposób i przez okres wymagany przepisami prawa w sposób umożliwiający wyszukanie, podgląd, zapisanie oraz wydruk dokumentu.</li><li>VBL nie ponosi odpowiedzialności wobec Klienta za utratę lub uszkodzenie danych przechowywanych na Portalu VB Leasing.</li><li>Klient może w każdym czasie zrezygnować z możliwości otrzymywania dokumentów w formie elektronicznej poprzez złożenie oświadczenia o cofnięciu akceptacji na wystawianie i udostępnianie ich w formie elektronicznej. Oświadczenie takie powinno zostać złożone w formie pisemnej i przesłane na adres centrali VB Leasing SA.</li><li>VBL zaprzestaje udostępniania e-dokumentów za pośrednictwem Portalu VB Leasing po otrzymaniu od Klienta oświadczenia o cofnięciu akceptacji na wystawianie i przesyłanie dokumentów w formie elektronicznej, nie później niż w ciągu 14 dni, chyba że strony uzgodniły inny termin. Rezygnacja z otrzymywania dokumentów elektronicznych (e-Dokumentów) nie wpływa na sposób wystawiania oraz udostępniania Faktur ustrukturyzowanych zgodnie z obowiązującymi przepisami prawa.</li></ol></li></ol></div><h5><b>§ 4. Pozostałe funkcjonalności Portalu VB Leasing</b></h5><div id=\"other_functionalities\" style=\"margin-left: 20px\"><p>Korzystanie przez Klienta z pozostałych funkcjonalności Portalu VB Leasing, np. usługi polegającej na możliwości otrzymywania informacji handlowych dotyczących usług oferowanych przez VBL lub partnerów VBL, a także innych usług i funkcjonalności dodawanych w miarę rozwoju Portalu VB Leasing, Odbywa się w sposób wykorzystujący aktualne możliwości techniczne Portalu VB Leasing i wymaga dokonania odpowiednich ustawień lub operacji przez Użytkownika Portalu VB Leasing przy czym niektóre funkcje takie jak otrzymywanie informacji handlowych, mogą wymagać złożenia odrębnej zgody przez Klienta.</p></div><h5><b>§ 5. Zasady bezpieczeństwa</b></h5><div id=\"security\" style=\"margin-left: 20px\"><ol><li>Dostęp do Portalu VB Leasing wymaga korzystania z przydzielonego Loginu i Hasła. Błędne wpisanie loginu i/lub hasła spowoduje prośbę o ponowne, poprawne wpisanie danych dostępowych. W przypadku trzykrotnej błędnej próby logowania dostęp do Konta zostaje zablokowany na 15 minut. Po tym czasie każda następne błędna próba logowania blokuje dostęp na 15 minut. W przypadku sześciu kolejnych błędnych prób logowania dostęp do Konta jest blokowany. Wówczas Konto może zostać odblokowane tylko przez uprawnionego konsultanta VBL, o czym Użytkownik jest informowany za pomocą stosownego komunikatu.</li><li>Zachowanie hasła w poufności i nieudostępnianie go osobom nieuprawnionym należy do obowiązków Klienta. W przypadku utraty danych logowania Klient powinien wybrać opcję „zapomniałem hasła” w panelu logowania i postąpić zgodnie z wyświetloną instrukcją.</li><li>Wszystkie operacje dokonane za pośrednictwem Portalu VB Leasing po zalogowaniu się indywidualnym loginem i hasłem uważa się za zlecone przez Klienta i w tym zakresie VBL nie ponosi odpowiedzialności za nieuprawnione działania osób trzecich.</li></ol></div><h5><b>§ 6. Zmiana danych</b></h5><div id=\"personal_data_change\" style=\"margin-left: 20px\"><ol><li>W przypadku zmiany danych mających znaczenie dla użytkowania Portalu VB Leasing, klient zobowiązany jest do ich zgłoszenia VBL do Działu Obsługi Klienta. Informacja odnośnie koniecznych formalności zostanie przekazana Klientowi w formie elektronicznej, telefonicznie lub pisemnie, w zależności od możliwej formy kontaktu.</li><li>Udostępniony VBL przez Klienta adres poczty elektronicznej może zostać wykorzystany przez VBL do przesyłania Klientowi wezwań (monitów) do zapłaty lub innych wiadomości związanych z umowami zawartymi przez strony.</li><li>Do czasu wskazania przez Klienta aktualnych danych, w sposób wskazany w ust. 1 lub zmiany w ramach Portalu VB Leasing, wszelkie oświadczenia przesłane na adres poczty elektronicznej lub przy użyciu podanych VBL danych, w tym osobowych, będą uważane za złożone przez VBL w sposób prawidłowy i skuteczny.</li><li>W celu dodatkowej autoryzacji niektórych operacji VBL za pośrednictwem Portalu VB Leasing lub Konsultanta ma prawo zadać Użytkownikowi pytania dotyczące jego danych osobowych udostępnionych VBL lub innych danych dotyczących zawartych umów. Jeżeli Użytkownik nie może podać prawidłowych danych niezbędnych do wykonania danego zlecenia, nie może ono być zrealizowane.</li></ol></div><h5><b>§ 7. Opłaty</b></h5><div id=\"payments\" style=\"margin-left: 20px\"><ol><li>Korzystanie z Portalu VB Leasing przez Klientów jest wolne od opłat z zastrzeżeniem ust. 2.</li><li>Usługi i czynności związane z zawartymi umowami zlecane przez Klienta za pośrednictwem Portalu VB Leasing, płatne są zgodnie z właściwą Tabelą Opłat i Prowizji.</li><li>VBL zastrzega sobie prawo wprowadzenia nowych, płatnych usług świadczonych za pośrednictwem Portalu VB Leasing. Każdorazowo świadczenie takich usług wymagać będzie zgody Klienta.</li></ol></div><h5><b>§ 8. Rezygnacja z korzystania z Portalu VB Leasing.</b></h5><div id=\"resignation\" style=\"margin-left: 20px\"><ol><li>Klient może zrezygnować z Portalu VB Leasing poprzez złożenie VBL odpowiedniego oświadczenia w formie pisemnej.</li><li>Rezygnacja z otrzymywania dokumentów elektronicznych (e-Dokumentów) następuje na zasadach określonych w § 3 lit. C pkt. 3-4.</li></ol></div><h5><b>§ 9. Zmiany regulaminu.</b></h5><div id=\"regulation_changes\" style=\"margin-left: 20px\"><ol><li>VBL zastrzega sobie możliwość zmiany postanowień Regulaminu oraz wprowadzania zmian w funkcjonowaniu Portalu VB Leasing. Informacja o zmianie będzie Klientowi przekazywana poprzez udostępnienie na Portalu VB Leasing.</li><li>Klientowi służy prawo do rezygnacji z Portalu VB Leasing w terminie 30 dni od daty udostępnienia informacji o zmianie. W przypadku gdy w powyższym terminie Klient nie złoży pisemnego oświadczenia o rezygnacji zmienione postanowienia wiążą strony od dnia ich wprowadzenia. Rezygnacja z Portalu nie wpływa na sposób wystawiania i udostępniania Faktur ustrukturyzowanych zgodnie z obowiązującymi przepisami prawa.</li></ol></div><h5><b>§ 10. Reklamacje</b></h5><div id=\"complaints\" style=\"margin-left: 20px\"><ol><li>W przypadku niezadowolenia Klienta z usług świadczonych za pośrednictwem Portalu VB Leasing, Klient będący klientem podmiotu rynku finansowego w rozumieniu ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego, o Rzeczniku Finansowym i o Funduszu Edukacji Finansowej uprawniony jest do złożenia reklamacji w każdym oddziale VBL. Lista oddziałów przyjmujących reklamacje dostępna jest na stronie internetowej VBL pod adresem: <a href=\"http://www.vbleasing.pl\">www.vbleasing.pl</a>. Reklamacje mogą być składane:<ol type=\"a\"><li>w formie pisemnej – osobiście w każdym oddziale VBL albo listownie na adres VB Leasing S.A. w restrukturyzacji, ul. Fabryczna 6, 53-609 Wrocław,</li><li>ustnie – telefonicznie albo osobiście do protokołu podczas wizyty Klienta w każdym oddziale VBL przyjmującym reklamacje zgodnie z listą, o której mowa powyżej,</li><li>w formie wiadomości elektronicznej wysłanej na adresy poczty elektronicznej wskazane dla tego celu na stronie internetowej VBL pod adresem: www.vbleasing.pl.</li></ol></li><li>Reklamacja powinna zawierać:<ol type=\"a\"><li>opis zdarzenia, którego dotyczy,</li><li>wskazanie zastrzeżenia co do usług świadczonych przez VBL oraz</li><li>wyraźne wskazanie roszczenia Klienta względem VBL (tj. czego klient żąda od VBL).</li></ol></li><li>Reklamacje są rozpatrywane w terminie nie dłuższym niż 30 dni od dnia otrzymania reklamacji przez VBL.</li><li>Klient będzie poinformowany o wyniku rozpatrzenia reklamacji przez VBL w terminie 30 dni od dnia jej otrzymania poprzez: list polecony lub wiadomość email, wysłaną na adres wskazany przez Klienta – na co niniejszym Klient wyraźnie udziela zgody.</li><li>Do zachowania terminu wystarczy wysłanie przez VBL odpowiedzi przed jego upływem.</li><li>W przypadku bardziej skomplikowanych przypadków uniemożliwiających rozpatrzenie reklamacji i udzielenie odpowiedzi w podanym w ust. 3 terminie tj. przed upływem trzydziestodniowego terminu, VBL zawiadomi Klienta w drodze: a) listu poleconego lub b) wiadomości email wysłanej na adres wskazany przez Klienta (na co niniejszym Klient wyraźnie udziela zgody), iż odpowiedź będzie wysłana w terminie nie dłuższym niż 60 dni od dnia otrzymania przez VBL reklamacji. Zawiadomienie zawierać będzie: a) informację co do przyczyn opóźnienia, b) wskazanie okoliczności, które muszą zostać ustalone dla rozpatrzenia sprawy oraz c) określenie przewidywanego terminu rozpatrzenia reklamacji i udzielenia odpowiedzi.</li><li>Klient niniejszym wnosi o przesyłanie przez VBL wszelkiej korespondencji dotyczącej reklamacji i procedury reklamacyjnej w drodze wiadomości email.</li><li>Żadne z postanowień umowy nie ogranicza praw Klienta wynikających z ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego, o Rzeczniku Finansowym i o Funduszu Edukacji Finansowej. Klient, który jest niezadowolony z udzielonej przez VBL odpowiedzi na złożoną przez niego reklamację, może wystąpić z wnioskiem o rozpatrzenie sprawy do Rzecznika Finansowego.</li></ol></div><h5><b>§ 11. Postanowienia Końcowe</b></h5><div id=\"end\" style=\"margin-left: 20px\"><ol><li>W związku z korzystaniem z Portalu VB Leasing dane osobowe użytkowników są przetwarzane zgodnie z przepisami Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) oraz innymi obowiązującymi przepisami prawa dotyczącymi ochrony danych osobowych. Administratorem danych osobowych przetwarzanych za pośrednictwem Portalu VB Leasing jest VB Leasing S.A. w restrukturyzacji z siedzibą we Wrocławiu, ul. Fabryczna 6, 53-609 Wrocław. Dane osobowe przetwarzane są w szczególności w celu: świadczenia usług dostępnych w ramach Portalu VB Leasing (art. 6 ust. 1 lit. b RODO), realizacji prawnie uzasadnionych interesów administratora, w tym marketingu bezpośredniego własnych produktów i usług (art. 6 ust. 1 lit. f RODO), w przypadku wyrażenia zgody – w celach marketingowych (art. 6 ust. 1 lit. a RODO). Podanie danych osobowych jest dobrowolne, jednak może być niezbędne do skorzystania z usług dostępnych w Portalu VB Leasing. Osobie, której dane dotyczą, przysługuje prawo dostępu do treści swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu wobec przetwarzania danych oraz prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li><li>Dane osobowe mogą być przekazywane podmiotom powiązanym z administratorem lub należącym do tej samej grupy kapitałowej w rozumieniu przepisów ustawy z dnia 29 września 1994 r. o rachunkowości, w celu oferowania produktów i usług tych podmiotów, wyłącznie na podstawie uprzednio wyrażonej zgody osoby, której dane dotyczą. Zgoda może zostać wyrażona poprzez zaznaczenie odpowiedniego pola w formularzu rejestracyjnym lub kontaktowym.</li><li>Klient, poprzez zaznaczenie odpowiedniego pola w formularzu rejestracyjnym lub kontaktowym, może wyrazić zgodę na otrzymywanie informacji handlowych za pomocą środków komunikacji elektronicznej, w szczególności poczty elektronicznej lub innych kanałów komunikacji elektronicznej, zgodnie z obowiązującymi przepisami ustawy Prawo komunikacji elektronicznej.</li><li>W celu zapewnienia wysokiej jakości obsługi oraz w celach dowodowych rozmowy telefoniczne z konsultantami VB Leasing mogą być nagrywane. Osoba rozpoczynająca rozmowę jest każdorazowo informowana o nagrywaniu rozmowy.</li><li>VB Leasing nie ponosi odpowiedzialności za szkody poniesione przez Klienta w związku z korzystaniem z Portalu VB Leasing, powstałe z przyczyn niezależnych od VB Leasing. W szczególności VB Leasing nie odpowiada za szkody wynikające z: przerw w dostępie do Portalu VB Leasing spowodowanych awariami technicznymi lub działaniem siły wyższej, problemów technicznych po stronie użytkownika lub dostawców usług telekomunikacyjnych, nieprawidłowego korzystania z Portalu VB Leasing lub urządzeń wykorzystywanych do dostępu do Portalu VB Leasing.</li></ol></div><div><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"{{fromState.name != \'\' ? fromState.name : \'documents\'}}\">Powrót</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/views/reset/reset.html","<div class=\"section login\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-10 col-md-push-1\"><div class=\"card card-login\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-8\"><h2 class=\"no-m-top\">Znajdź kod klienta</h2><h5 class=\"no-m-top\" style=\"margin-left:20px; margin-bottom: 10px\">Kod klienta znajdziesz (...)</h5><h2 class=\"no-m-top\">Resetuj hasło</h2><form id=\"resetForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"iID\" class=\"col-md-3 control-label\">Kod klienta</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"iID\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"iEmail\" class=\"col-md-3 control-label\">Email</label><div class=\"col-md-6\"><input type=\"email\" class=\"form-control\" id=\"iEmail\" placeholder=\"\"></div></div><div class=\"form-group\"><div id=\"sample-captcha\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-8\"><button type=\"submit\" ng-click=\"vm.reset()\" class=\"btn btn-140 btn-primary btn-round btn-fill\">Resetuj hasło</button></div></div></form><script>$(function() {\n                                    $(\"#resetForm\").submit(function(event) {\n                                        event.preventDefault();\n                                        $(this).addClass(\'form-success\');\n                                        $(\".content\").addClass(\'hidden\');\n                                        $(\'.loader\').removeClass(\'hidden\');\n\n                                    });\n                                });</script></div></div></div></div><div id=\"loader\" class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\"\"><p>Resetowanie hasła...</p></div></div></div></div></div><!-- section -->");
$templateCache.put("app/views/roles/roles.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Role użytkowników</h2></div></div><div class=\"row\"><div class=\"col-md-8\"><div id=\"fDataSet\" class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><errors></errors><statements></statements><div class=\"table-responsive\"><table class=\"table table-users table-hover no-first-last-padding\"><thead><tr><th></th><th>Nazwa</th><th>Nazwa techniczna</th></tr></thead><tbody><tr ng-repeat=\"role in vm.data.roles | orderBy:[\'+label\']\"><td>{{$index + 1}}</td><td><a ui-sref=\"role({role_id:role.role_id})\" href>{{role.label}}</a></td><td>{{role.name}}</td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary btn-fill btn-round\" ui-sref=\"newRole\">Dodaj</button></div></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/role/role.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"no-m-top\">Role użytkownika - edycja roli</h2></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"[ card ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><form name=\"roleForm\" class=\"form form-horizontal\" action=\"\"><div class=\"form-group row\"><label for=\"fName\" class=\"col-md-5 control-label uppercase\">Nazwa</label><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" id=\"fName\" placeholder=\"Nazwa\" ng-model=\"vm.data.role.label\" ng-pattern=\"/^.{0,256}$/\" data-pattern-tooltip=\"Podana nazwa jest za długa.\"></div></div><div class=\"form-group row\"><label for=\"fTechName\" class=\"col-md-5 control-label uppercase\">Nazwa techniczna</label><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" id=\"fTechName\" placeholder=\"Nazwa techniczna\" ng-model=\"vm.data.role.name\" ng-pattern=\"/^.{0,64}$/\" data-pattern-tooltip=\"Podana nazwa techniczna jest za długa.\"></div></div><div ng-repeat=\"permission in vm.data.permissions | orderBy:[\'+label\']\"><input type=\"checkbox\" id=\"checkbox{{$index}}\" ng-model=\"permission.checked\"><label class=\"checkbox\" for=\"checkbox{{$index}}\" style=\"display:inline\">{{permission.label}}</label></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-round\" ng-click=\"vm.updateRole()\" ng-disabled=\"roleForm.$invalid || roleForm.$pending\">Aktualizuj</button> <button type=\"submit\" class=\"btn btn-primary btn-round\" confirm=\"vm.deleteRole()\" message=\"Czy jesteś pewien, że chcesz usunąć tę rolę?\">Usuń</button> <button type=\"submit\" class=\"btn btn-primary btn-round\" ui-sref=\"roles\">Anuluj</button></div></form></div></div></div></div><!-- end .card-dataset --></div></div><div class=\"row\" has-authority=\"LOGS_EMPLOYEE_RESOURCE\"><div class=\"col-md-9\"><h2 class=\"\">Historia konta</h2></div></div><div class=\"row\" has-authority=\"LOGS_EMPLOYEE_RESOURCE\"><div class=\"col-md-3 panel panel-filters\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED id=\"filters-panel\" --><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#inputDate\" href class=\"collapsed\">DATA WPISU <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"inputDate\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.ts_from\" data-max=\"{{vm.filter.ts_to}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\" for=\"to\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.ts_to\" data-min=\"{{vm.filter.ts_from}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getRoleLogs()\">Wyszukaj</button></div></div></div></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"fDataSet\" class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"noData\" ng-if=\"vm.data.logs.length == 0\">Brak wpisów</div><div class=\"table-responsive\" ng-if=\"vm.data.logs.length != 0\"><table class=\"table table-users table-hover no-first-last-padding\" style=\"white-space: normal !important\"><thead><tr><th class=\"name-header-cell hidden-xs\"></th><th class=\"name-header-cell hidden-xs\">Typ wpisu</th><th class=\"name-header-cell\">Wpis</th><th class=\"name-header-cell\">Data wpisu</th><th class=\"name-header-cell\">Adres IP</th><th class=\"name-header-cell\">Login</th><th class=\"name-header-cell\">Status</th></tr></thead><tbody><tr ng-repeat=\"log in vm.data.logs | orderBy: \'-ts\' \"><td class=\"hidden-xs\">{{$index+1}}</td><td class=\"hidden-xs\">{{log.type}}</td><td>{{log.data}}</td><td>{{vm.Date(log.ts)}}</td><td>{{log.ip}}</td><td>{{log.login}}</td><td><a ng-class=\"[{ \'btn-ok\' : log.success}, { \'btn-remove\' : !log.success}] \" title=\"{{log.success ? \'Sukces\' : \'Porażka\'}} \" data-toggle=\"tooltip \" data-placement=\"right \" tooltip></a></td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/settings/settings.html","<div class=\"section\"><div id=\"settingsGrid\" class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"no-m-top\">Ustawienia konta</h2></div></div><errors></errors><statements></statements><div class=\"row\" style=\"margin-bottom:20px\"><div class=\"col-md-4\"><div class=\"grid\" has-authority=\"ROLE_CLIENT\"><div class=\"content\"><h3 class=\"no-m-top\">Dane do fakturowania</h3><h5 ng-bind-html=\"Principal.getProperty(\'displayName\').replace(vm.pipeRegex,\'<br>\')\"></h5></div></div></div><div class=\"col-md-4\"><div class=\"grid\" has-authority=\"ROLE_CLIENT\"><div class=\"content\"><!--<h3 class=\"no-m-top\">Dane do korespondencji</h3>\n                        <h5 ng-bind-html=\"Principal.getProperty(\'displayName\').replace(vm.pipeRegex,\'<br>\')\"></h5>--><h3 class=\"no-m-top\">Adres e-mail</h3><h5 principal-property=\"email\"></h5></div></div></div><div class=\"col-md-4\"><div class=\"grid setting-panel\" has-authority=\"ROLE_CLIENT\"><div class=\"content\"><h3 class=\"no-m-top\">Aktualizacja danych kontaktowych</h3><p>W celu aktualizacji danych kontakowych prosimy o kontakt z Działem Obsługi Klienta.</p><p><a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a></p><p>Adres korespondencyjny:</p><p>VB Leasing S.A. w restrukturyzacji<br>ul. Fabryczna 6<br>53-609 Wrocław</p></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"card grid setting-panel\"><div class=\"content\"><h4 class=\"no-m-top\">Aktualizuj hasło</h4><form id=\"passwordForm\" name=\"passwordForm\" class=\"form\"><div class=\"form-group\"><label for=\"opass\" class=\"control-label\">Stare hasło</label><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.password.currentValue\" data-old-password></pass></div><div class=\"form-group\"><label for=\"npass\" class=\"control-label\">Nowe hasło</label><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.password.newValue \" data-new-password></pass></div><div class=\"form-group\"><label for=\"ppass \" class=\"control-label\">Powtórz nowe hasło</label><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.password.newRepeat\" data-repeat-password></pass></div></form></div><div class=\"footer\" style=\"position: absolute; bottom: 0px; width: 100%\"><button id=\"password_submit\" type=\"submit\" class=\"btn btn-wide btn-primary btn-round btn-fill\" ng-disabled=\"passwordForm.$invalid || passwordForm.$pending\" ng-click=\"vm.changePassword($event) \">Aktualizuj</button></div></div></div><div class=\"col-md-4\"><div class=\"card grid setting-panel\"><div class=\"content\"><h4 class=\"no-m-top\">Zmiana adresu e-mail</h4><form id=\"emailForm\" name=\"emailForm\" class=\"form\"><div class=\"form-group\"><label for=\"oemail \" class=\"control-label\">Aktualne hasło</label><pass class=\"form-control\" required=\"required\" ng-model=\"vm.data.email.currentValue\"></pass></div><div class=\"form-group\"><label for=\"nemail \" class=\"control-label\">Nowy e-mail</label><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.email.newValue\" data-new-email></email></div><div class=\"form-group\"><label for=\"pemail \" class=\"control-label\">Powtórz nowy e-mail</label><email class=\"form-control\" required=\"required\" ng-model=\"vm.data.email.newRepeat\" data-repeat-email></email></div></form></div><div class=\"footer\" style=\"position: absolute; bottom: 0px; width: 100%\"><button id=\"email_submit\" type=\"submit \" class=\"btn btn-wide btn-primary btn-round btn-fill\" ng-disabled=\"emailForm.$invalid || emailForm.$pending\" ng-click=\"vm.changeEmail($event)\">Aktualizuj</button></div></div></div><div class=\"col-md-4\" has-authority=\"ROLE_CLIENT \"><div class=\"card grid setting-panel\"><div class=\"content\"><h4 class=\"no-m-top\">Usługa e-dokumenty</h4><h5><span style=\"color:black\">Status usługi: </span><span style=\"color:#09F\">{{vm.eInvoice ? \'Aktywna\' : \'Nieaktywna\'}}</span></h5><form id=\"eInvoiceForm\" name=\"eInvoiceForm\" class=\"einvoice_service_form\"><fieldset ng-if=\"vm.eInvoice\"><label class=\"e-invoice-desc\" style=\"margin-bottom:20px\">W celu dezaktywacji usługi e-dokumenty proszę przesłać zgłoszenie na adres e-mail <a href=\"mailto:portal.klienta@vbl.pl\">portal.klienta@vbl.pl</a></label></fieldset><fieldset ng-if=\"!vm.eInvoice\"><label class=\"e-invoice-desc\">W celu aktywacji usługi e-dokumenty zaakceptuj oświadczenie oraz wyślij zgłoszenie.</label><div class=\"checkboxes\" style=\"margin-bottom:0.5em\"><div class=\"elem_checkbox\"><input id=\"einvoice_service\" type=\"checkbox\" required=\"required\" ng-model=\"vm.data.eInvoice\"><label for=\"einvoice_service\" class=\"e-invoice-label\" style=\"display:inline;outline:none\">Wyrażam zgodę na wystawianie i udostępnianie drogą elektroniczną e-dokumentów wystawionych przez VB Leasing S.A. w restrukturyzacji zgodnie z postanowieniami <a ui-sref=\"appRegulations\" ng-click=\"vm.data.eInvoice=! vm.data.eInvoice\" href>Regulaminu Portalu VB Leasing</a>.</label></div></div><p id=\"einvoice_service_error \" class=\"checkbox_error hidden\">W celu aktywacji usługi proszę o akceptację oświadczenia.</p></fieldset></form></div><div class=\"footer\" style=\"position: absolute; bottom: 0px; width: 100%\"><button type=\"submit \" class=\"btn btn-wide btn-primary btn-round btn-fill\" ng-if=\"!vm.eInvoice\" ng-disabled=\"eInvoiceForm.$invalid || eInvoiceForm.$pending\" ng-click=\"vm.activateEInvoice() \">Aktywuj</button></div></div></div></div><div class=\"loader hidden text-center\"><img src=\"img/svg-icons/loader.svg\" alt=\" \"><p>Wczytywanie...</p></div></div></div><!-- section -->");
$templateCache.put("app/views/user/user.html","<div class=\"section\"><div class=\"container-fluid\" ng-show=\"$root.Info.infos[\'user\'].length + $root.Info.statements[\'user\'].length + $root.Info.errors[\'user\'].length > 0\"><infos></infos><errors></errors><statements></statements></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"no-m-top\">Informacje o użytkowniku</h2></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"[ card card-details ]\"><!-- ./less/card-details.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"details\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"header\"><h4 class=\"title\" style=\"min-height:0px\">Dane</h4></div><table><tr><td><span class=\"text-default uppercase left\">Login:</span></td><td class=\"right nowrap\">{{vm.data.user.login}}</td></tr><tr><td><span class=\"text-default uppercase left\">E-mail:</span></td><td class=\"right nowrap\">{{vm.data.user.email}}</td></tr><tr><td><span class=\"text-default uppercase left\">Aktywny:</span></td><td class=\"right nowrap\">{{vm.data.user.enable ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">Blokada stała:</span></td><td class=\"right\">{{vm.data.user.account_blocked ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">Blokada na 15 minut:</span></td><td class=\"right\">{{((vm.data.user.invalid_login_counter >= 3) && (vm.data.user.invalid_login_date > (vm.now() - 1000 * 60 * 15 ))) ? \'TAK\' : \'NIE\'}}</td></tr><tr><td><span class=\"text-default uppercase left\">Liczba niepoprawnych prób logowania:</span></td><td class=\"right\">{{vm.data.user.invalid_login_counter == null ? 0 : vm.data.user.invalid_login_counter}}</td></tr></table></div><div class=\"col-sm-6\" has-authority=\"ROLE_RESOURCE\"><div class=\"header\"><h4 class=\"title\" style=\"min-height:0px\">Role</h4></div><table><tr ng-repeat=\"role in vm.data.roles  | orderBy:[\'+label\']\"><td><input type=\"checkbox\" id=\"checkbox{{$index}}\" ng-model=\"role.checked\"><label class=\"checkbox\" for=\"checkbox{{$index}}\" style=\"display:inline\">{{role.label}}</label></td></tr></table></div></div></div></div><div class=\"footer\"><button class=\"btn btn-primary btn-round btn-fill\" ng-click=\"vm.updateUserRoles()\" has-authority=\"ROLE_RESOURCE\">Aktualizuj role</button> <button class=\"btn btn-primary btn-round\" has-authority=\"EMPLOYEE_RESET_EMPLOYEE_PASSWORD_RESOURCE\" confirm=\"vm.resetPassword($event)\" message=\"Czy jesteś pewien, że chcesz zresetować hasło tego użytkownika?\">Zresetuj hasło</button> <button class=\"btn btn-primary btn-round\" has-authority=\"EMPLOYEE_UNLOCK_EMPLOYEE_ACCOUNT_RESOURCE\" confirm=\"vm.toggleActivation()\" message=\"Czy jesteś pewien, że chcesz przełączyć status konta tego użytkownika?\">{{vm.data.user.enable ? \'Deaktywuj konto\' : \'Aktywuj konto\'}}</button> <button class=\"btn btn-primary btn-round\" ng-disabled=\"!vm.data.user.account_blocked\" has-authority=\"EMPLOYEE_UNLOCK_EMPLOYEE_ACCOUNT_RESOURCE\" confirm=\"vm.unlock($event)\" message=\"Czy jesteś pewien, że chcesz odblokować tego użytkownika?\">Odblokuj konto</button> <button class=\"btn btn-primary btn-round btn-fill\" confirm=\"vm.deleteUser()\" message=\"Czy jesteś pewien, że chcesz usunąć tego użytkownika?\">Usuń</button> <button class=\"btn btn-primary btn-round btn-fill\" ui-sref=\"newUserEmail({userName: vm.data.user.login})\">Aktualizuj email</button></div></div></div></div><!-- end .card-product-horizontal --></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-140 btn-primary btn-round btn-fill\" ui-sref=\"users\">Powrót do ekranu użytkowników</button></div></div><div class=\"row\" has-authority=\"LOGS_EMPLOYEE_RESOURCE\"><div class=\"col-md-9\"><h2 class=\"\">Historia konta</h2></div></div><div class=\"row\" has-authority=\"LOGS_EMPLOYEE_RESOURCE\"><div class=\"col-md-3 panel panel-filters\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED id=\"filters-panel\" --><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#inputDate\" href class=\"collapsed\">DATA WPISU <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"inputDate\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row from-range-input\"><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Od\" name=\"from\" class=\"date-picker form-control\" ng-model=\"vm.filter.ts_from\" data-max=\"{{vm.filter.ts_to}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div><div class=\"col-xs-5 input-col\"></div><div class=\"col-xs-1\"><label class=\"form-control-label to dash-v-spacer\" for=\"to\">-</label></div><div class=\"col-xs-6 input-col\"></div><div class=\"col-xs-12 input-col\"><datepicker placeholder=\"Do\" name=\"to\" class=\"date-picker form-control\" ng-model=\"vm.filter.ts_to\" data-min=\"{{vm.filter.ts_from}}\" data-placement=\"auto right\" family=\"history\"></datepicker></div></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getUserLogs()\">Wyszukaj</button></div></div></div></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"fDataSet\" class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><div class=\"noData\" ng-if=\"vm.data.logs.length == 0\">Brak wpisów</div><div class=\"table-responsive\" ng-if=\"vm.data.logs.length != 0\"><table class=\"table table-users table-hover no-first-last-padding\" style=\"white-space: normal !important\"><thead><tr><th class=\"name-header-cell hidden-xs\"></th><th class=\"name-header-cell hidden-xs\">Typ wpisu</th><th class=\"name-header-cell\">Wpis</th><th class=\"name-header-cell\">Data wpisu</th><th class=\"name-header-cell\">Adres IP</th><th class=\"name-header-cell\">Login</th><th class=\"name-header-cell\">Status</th></tr></thead><tbody><tr ng-repeat=\"log in vm.data.logs | orderBy: \'-ts\' \"><td class=\"hidden-xs\">{{$index+1}}</td><td class=\"hidden-xs\">{{log.type}}</td><td>{{log.data}}</td><td>{{vm.Date(log.ts)}}</td><td>{{log.ip}}</td><td>{{log.login}}</td><td><a ng-class=\"[{ \'btn-ok\' : log.success}, { \'btn-remove\' : !log.success}] \" title=\"{{log.success ? \'Sukces\' : \'Porażka\'}} \" data-toggle=\"tooltip \" data-placement=\"right \" tooltip></a></td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div><!-- .section -->");
$templateCache.put("app/views/userActivate/user-activate.html","<h2 class=\"no-m-top\">Aktywacja konta Użytkownika w Portalu VB Leasing</h2><errors></errors><statements></statements><p>Podaj hasło, które, którego będziesz używał do logowania w Portalu VB Leasing.</p><form id=\"activationForm\" name=\"activationForm\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"npass\" class=\"control-label col-md-3\">Nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.password\" data-new-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><label for=\"ppass\" class=\"control-label col-md-3\">Powtórz nowe hasło</label><div class=\"col-md-5\"><pass class=\"form-control\" required=\"required\" ng-model=\"vm.activation.newRepeat\" data-repeat-password data-update=\"vm.isFilledActivation\"></pass></div></div><div class=\"form-group\"><div class=\"col-md-5 col-md-offset-3 text-center\"><button id=\"account_activate\n\" type=\"submit\" class=\"btn btn-140 btn-primary btn-round btn-fill\" ng-click=\"vm.userActivate()\" ng-disabled=\"activationForm.$invalid || activationForm.$pending\">Aktywuj konto</button></div></div></form>");
$templateCache.put("app/views/users/users.html","<div class=\"section\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-9 col-md-push-3\"><h2 class=\"no-m-top\">Użytkownicy<span class=\"header-icon docs\"></span></h2></div></div><div class=\"row\"><div class=\"col-md-3 panel panel-filters\"><div class=\"panel-heading visible-sm-block visible-xs-block\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#filters-panel\" href>Filtry <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"filters-panel\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"aside-filters\"><div class=\"card card-refine card-plain\"><div class=\"header\"><h4 class=\"title\">Filtry <button class=\"btn btn-default btn-xs btn pull-right btn-simple\" ng-click=\"vm.resetFilters($event)\"><span class=\"btn-x\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resetuj filtry\" tooltip></span></button></h4></div><form><div class=\"content\"><div class=\"panel-group\"><!-- REMOVED  id=\"filters-panel\" --><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#login\" href class=\"collapsed\">LOGIN <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"login\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"Login\" class=\"form-control\" ng-model=\"vm.filter.query.login\" value=\"{{vm.filter.query.login}}\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#email\" href class=\"collapsed\">E-MAIL <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"email\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><input type=\"text\" placeholder=\"E-mail\" class=\"form-control\" ng-model=\"vm.filter.query.email\" value=\"{{vm.filter.query.email}}\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h6 class=\"panel-title\"><a data-toggle=\"collapse\" data-target=\"#active\" href class=\"collapsed\">AKTYWNY <i class=\"fa fa-caret-up pull-right\"></i></a></h6></div><div id=\"active\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><select name=\"huge\" class=\"selectpicker form-control\" data-style=\"form-control\" data-menu-style=\"\" ng-model=\"vm.filter.query.enable\" value=\"{{vm.filter.query.enable}}\"><option selected=\"selected\"></option><option value=\"true\">TAK</option><option value=\"false\">NIE</option></select></div></div></div></div><div class=\"buttons-row text-center\"><button type=\"submit\" class=\"btn btn-primary btn-fill btn-wide btn-round\" ng-click=\"vm.getUsers($event)\">Wyszukaj</button></div></div></div></form></div><!-- end card --></div></div></div></div><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><errors></errors><statements></statements><!-- <h4 class=\"no-m-top\"><span class=\"header-icon docs left\"></span>xxx</h4> --><div class=\"noData\" ng-if=\"vm.data.result.users.length == 0\">Brak użytkowników</div><div class=\"table-responsive\" ng-if=\"vm.data.result.users.length != 0\"><table class=\"table table-users table-hover no-first-last-padding\"><thead><tr><th></th><th>Login</th><th>E-mail</th><th class=\"t\">Aktywny</th></tr></thead><tbody><tr ng-repeat=\"user in vm.data.result.users | orderBy:[\'+login\']\"><td>{{$index + 1}}</td><td><a href ui-sref=\"user({user_id : user.user_id})\">{{user.login}}</a></td><td>{{user.email}}</td><td class=\"nowrap\">{{user.enable == true ? \"TAK\" : \"NIE\"}}</td></tr></tbody></table></div></div></div></div></div><!-- end .card-dataset --></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary btn-fill btn-round\" ui-sref=\"newUser\">Dodaj użytkownika</button></div></div><!-- PASSWORD INTERVAL --><div class=\"row\" style=\"margin-top: 20px\" has-authority=\"PASSWORD_INTERVAL_CHANGE_RESOURCE\"><div class=\"col-md-12\"><div class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><!-- INTERVAL --><form><div class=\"row\"><h4 class=\"title\" style=\"min-height:0px\">Interwał zmiany hasła dla użytkowników</h4></div><div class=\"row\"><div class=\"col-xs-12\"><p>Aktualny interwał to: {{vm.userInterval.current}} {{vm.userInterval.currentMeasure}}.</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><input type=\"number\" placeholder=\"Interwał\" class=\"form-control\" ng-model=\"vm.userInterval.new\"></div><div class=\"col-xs-2\"><select name=\"huge\" class=\"selectpicker form-control\" data-style=\"form-control\" data-menu-style=\"\" ng-model=\"vm.userInterval.newMeasure\"><option value=\"dni\">dni</option><option value=\"miesiące\">miesiące</option><option value=\"lata\">lata</option></select></div></div></form></div></div></div></div><!-- end .card-dataset --><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"!vm.userInterval.new\" ng-click=\"vm.setUserInterval($event)\">Aktualizuj interwał</button></div></div></div></div><!-- PASSWORD INTERVAL --><div class=\"row\" style=\"margin-top: 20px\" has-authority=\"PASSWORD_INTERVAL_CHANGE_RESOURCE\"><div class=\"col-md-12\"><div class=\"[ card card-dataset ]\"><!-- ./less/card-dataset.less --><div class=\"row\"><div class=\"col-xs-12\"><div class=\"content\"><!-- INTERVAL --><form><div class=\"row\"><h4 class=\"title\" style=\"min-height:0px\">Interwał zmiany hasła dla klientów</h4></div><div class=\"row\"><div class=\"col-xs-12\"><p>Aktualny interwał to: {{vm.clientInterval.current}} {{vm.clientInterval.currentMeasure}}.</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><input type=\"number\" placeholder=\"Interwał\" class=\"form-control\" ng-model=\"vm.clientInterval.new\"></div><div class=\"col-xs-2\"><select name=\"huge\" class=\"selectpicker form-control\" data-style=\"form-control\" data-menu-style=\"\" ng-model=\"vm.clientInterval.newMeasure\"><option value=\"dni\">dni</option><option value=\"miesiące\">miesiące</option><option value=\"lata\">lata</option></select></div></div></form></div></div></div></div><!-- end .card-dataset --><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary btn-fill btn-round\" ng-disabled=\"!vm.clientInterval.new\" ng-click=\"vm.setClientInterval($event)\">Aktualizuj interwał</button></div></div></div></div><!-- .col-md-9 --></div></div><!-- .container --></div></div><!-- .section -->");}]);})();